export interface ISpecFields {
    Tag: number;
    Name: string;
    Type: string;
    AssociatedDataTag?: number;
    AbbrName?: string;
    BaseCategory?: string;
    BaseCategoryAbbrName?: string;
    NotReqXML: number;
    UnionDataType?: string;
    EnumDatatype?: number;
    Description: string;
    updated?: string;
    updatedEP?: number;
    added: string;
    addedEP?: number;
    deprecated?: string;
    issue?: string;
}

const batch1: ISpecFields[] = [
    {
        Type: 'String',
        Description:
            'Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager.',
        added: 'FIX.2.7',
        AbbrName: 'Acct',
        Tag: 1,
        NotReqXML: 0,
        Name: 'Account',
    },
    {
        Type: 'String',
        Description: 'Unique identifier of advertisement message.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'AdvId',
        Tag: 2,
        NotReqXML: 0,
        Name: 'AdvId',
    },
    {
        Type: 'String',
        Description:
            'Reference identifier used with CANCEL and REPLACE transaction types.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'AdvRefID',
        Tag: 3,
        NotReqXML: 0,
        Name: 'AdvRefID',
    },
    {
        Type: 'char',
        Description: "Broker's side of advertised trade",
        added: 'FIX.2.7',
        AbbrName: 'AdvSide',
        Tag: 4,
        NotReqXML: 0,
        Name: 'AdvSide',
    },
    {
        Type: 'String',
        Description: 'Identifies advertisement message transaction type',
        added: 'FIX.2.7',
        AbbrName: 'AdvTransTyp',
        Tag: 5,
        NotReqXML: 0,
        Name: 'AdvTransType',
    },
    {
        Type: 'Price',
        Description:
            'Calculated average price of all fills on this order.\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount.',
        added: 'FIX.2.7',
        AbbrName: 'AvgPx',
        Tag: 6,
        NotReqXML: 0,
        Name: 'AvgPx',
    },
    {
        Type: 'SeqNum',
        Description: 'Message sequence number of first message in range to be resent',
        added: 'FIX.2.7',
        AbbrName: 'BeginSeqNo',
        Tag: 7,
        NotReqXML: 1,
        Name: 'BeginSeqNo',
    },
    {
        Type: 'String',
        Description:
            'Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)\nValid values:\nFIXT.1.1',
        issue: 'SPEC-376',
        added: 'FIX.2.7',
        AbbrName: 'BeginString',
        Tag: 8,
        NotReqXML: 1,
        Name: 'BeginString',
    },
    {
        Type: 'Length',
        Description:
            'Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)',
        added: 'FIX.2.7',
        AbbrName: 'BodyLength',
        Tag: 9,
        NotReqXML: 1,
        Name: 'BodyLength',
    },
    {
        Type: 'String',
        Description:
            'Three byte, simple checksum (see Volume 2: "Checksum Calculation" for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)',
        added: 'FIX.2.7',
        AbbrName: 'CheckSum',
        Tag: 10,
        NotReqXML: 1,
        Name: 'CheckSum',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description:
            'Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID (49) or OnBehalfOfCompID (5) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID field.',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'ClOrdID',
        Tag: 11,
        NotReqXML: 0,
        Name: 'ClOrdID',
    },
    {
        Type: 'Amt',
        Description: 'Commission. Note if CommType (13) is percentage, Commission of 5% should be represented as .05.',
        added: 'FIX.2.7',
        AbbrName: 'Comm',
        Tag: 12,
        NotReqXML: 0,
        Name: 'Commission',
    },
    {
        Type: 'char',
        Description: 'Commission type',
        added: 'FIX.2.7',
        AbbrName: 'CommTyp',
        Tag: 13,
        NotReqXML: 0,
        Name: 'CommType',
    },
    {
        Type: 'Qty',
        Description: 'Total quantity (e.g. number of shares) filled.\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'CumQty',
        Tag: 14,
        NotReqXML: 0,
        Name: 'CumQty',
    },
    {
        Type: 'Currency',
        Description:
            'Identifies currency used for price. Absence of this field is interpreted as the default for the security. It is recommended that systems provide the currency value whenever possible. See "Appendix 6-A: Valid Currency Codes" for information on obtaining valid values.',
        added: 'FIX.2.7',
        AbbrName: 'Ccy',
        Tag: 15,
        NotReqXML: 0,
        Name: 'Currency',
    },
    {
        Type: 'SeqNum',
        Description:
            'Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = "0" (representing infinity).',
        added: 'FIX.2.7',
        AbbrName: 'EndSeqNo',
        Tag: 16,
        NotReqXML: 1,
        Name: 'EndSeqNo',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n(Prior to FIX 4.1 this field was of type int).',
        added: 'FIX.2.7',
        updatedEP: 95,
        AbbrName: 'ExecID',
        Tag: 17,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'ExecID',
    },
    {
        Type: 'MultipleCharValue',
        Description:
            'Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
        added: 'FIX.2.7',
        AbbrName: 'ExecInst',
        Tag: 18,
        NotReqXML: 0,
        Name: 'ExecInst',
    },
    {
        Type: 'String',
        Description:
            'Reference identifier used with Trade, Trade Cancel and Trade Correct execution types.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'ExecRefID',
        Tag: 19,
        NotReqXML: 0,
        Name: 'ExecRefID',
    },
    {
        Type: 'char',
        Description: 'Instructions for order handling on Broker trading floor',
        added: 'FIX.2.7',
        AbbrName: 'HandlInst',
        Tag: 21,
        NotReqXML: 0,
        Name: 'HandlInst',
    },
    {
        Type: 'String',
        Description:
            'Identifies class or source of the SecurityID (48) value. Required if SecurityID is specified.\n100+ are reserved for private security identifications',
        added: 'FIX.2.7',
        AbbrName: 'Src',
        Tag: 22,
        NotReqXML: 0,
        Name: 'SecurityIDSource',
    },
    {
        BaseCategory: 'Indication',
        Type: 'String',
        Description: 'Unique identifier of IOI message.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'IOIID',
        Tag: 23,
        NotReqXML: 0,
        Name: 'IOIID',
    },
    {
        Type: 'char',
        Description: 'Relative quality of indication',
        added: 'FIX.2.7',
        AbbrName: 'QltyInd',
        Tag: 25,
        NotReqXML: 0,
        Name: 'IOIQltyInd',
    },
    {
        Type: 'String',
        Description:
            'Reference identifier used with CANCEL and REPLACE, transaction types.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'RefID',
        Tag: 26,
        NotReqXML: 0,
        Name: 'IOIRefID',
    },
    {
        Type: 'String',
        UnionDataType: 'Qty',
        Description: 'Quantity (e.g. number of shares) in numeric form or relative size.',
        added: 'FIX.2.7',
        AbbrName: 'Qty',
        Tag: 27,
        NotReqXML: 0,
        Name: 'IOIQty',
    },
    {
        Type: 'char',
        Description: 'Identifies IOI message transaction type',
        added: 'FIX.2.7',
        AbbrName: 'TransTyp',
        Tag: 28,
        NotReqXML: 0,
        Name: 'IOITransType',
    },
    {
        Type: 'char',
        Description: 'Broker capacity in order execution',
        added: 'FIX.2.7',
        AbbrName: 'LastCpcty',
        Tag: 29,
        NotReqXML: 0,
        Name: 'LastCapacity',
    },
    {
        Type: 'Exchange',
        Description:
            'Market of execution for last fill, or an indication of the market where an order was routed\nValid values:\nSee "Appendix 6-C"',
        added: 'FIX.2.7',
        AbbrName: 'LastMkt',
        Tag: 30,
        NotReqXML: 0,
        Name: 'LastMkt',
    },
    {
        Type: 'Price',
        Description: 'Price of this (last) fill.',
        added: 'FIX.2.7',
        AbbrName: 'LastPx',
        Tag: 31,
        NotReqXML: 0,
        Name: 'LastPx',
    },
    {
        Type: 'Qty',
        Description:
            'Quantity (e.g. shares) bought/sold on this (last) fill.\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'LastQty',
        Tag: 32,
        NotReqXML: 0,
        Name: 'LastQty',
    },
    {
        Type: 'NumInGroup',
        Description: 'Identifies number of lines of text body',
        added: 'FIX.2.7',
        AbbrName: 'NoLinesOfText',
        Tag: 33,
        NotReqXML: 1,
        Name: 'NoLinesOfText',
    },
    {
        Type: 'SeqNum',
        Description: 'Integer message sequence number.',
        added: 'FIX.2.7',
        AbbrName: 'SeqNum',
        Tag: 34,
        NotReqXML: 0,
        Name: 'MsgSeqNum',
    },
    {
        Type: 'String',
        Description:
            'Defines message type ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A "U" as the first character in the MsgType field (i.e. U, U2, etc) indicates that the message format is privately defined between the sender and receiver.\n*** Note the use of lower case letters ***',
        added: 'FIX.2.7',
        AbbrName: 'MsgTyp',
        Tag: 35,
        NotReqXML: 0,
        Name: 'MsgType',
    },
    {
        Type: 'SeqNum',
        Description: 'New sequence number',
        added: 'FIX.2.7',
        AbbrName: 'NewSeqNo',
        Tag: 36,
        NotReqXML: 1,
        Name: 'NewSeqNo',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days.',
        added: 'FIX.2.7',
        AbbrName: 'OrdID',
        Tag: 37,
        NotReqXML: 0,
        Name: 'OrderID',
    },
    {
        Type: 'Qty',
        Description:
            'Quantity ordered. This represents the number of shares for equities or par, face or nominal value for FI instruments.\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'Qty',
        Tag: 38,
        NotReqXML: 0,
        Name: 'OrderQty',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'char',
        Description:
            'Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'Stat',
        AbbrName: 'OrdStat',
        Tag: 39,
        NotReqXML: 0,
        Name: 'OrdStatus',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'char',
        Description:
            'Order type. *** SOME VALUES ARE NO LONGER USED - See "Deprecated (Phased-out) Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'Typ',
        AbbrName: 'OrdTyp',
        Tag: 40,
        NotReqXML: 0,
        Name: 'OrdType',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description:
            'ClOrdID (11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests.',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'OrigID',
        AbbrName: 'OrigClOrdID',
        Tag: 41,
        NotReqXML: 0,
        Name: 'OrigClOrdID',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Time of message origination (always expressed in UTC (Universal Time Coordinated, also known as "GMT"))',
        added: 'FIX.2.7',
        AbbrName: 'OrigTm',
        Tag: 42,
        NotReqXML: 0,
        Name: 'OrigTime',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates possible retransmission of message with this sequence number',
        added: 'FIX.2.7',
        AbbrName: 'PosDup',
        Tag: 43,
        NotReqXML: 0,
        Name: 'PossDupFlag',
    },
    {
        Type: 'Price',
        Description: 'Price per unit of quantity (e.g. per share)',
        added: 'FIX.2.7',
        AbbrName: 'Px',
        Tag: 44,
        NotReqXML: 0,
        Name: 'Price',
    },
    {
        Type: 'SeqNum',
        Description: 'Reference message sequence number',
        added: 'FIX.2.7',
        AbbrName: 'RefSeqNum',
        Tag: 45,
        NotReqXML: 0,
        Name: 'RefSeqNum',
    },
    {
        Type: 'String',
        Description:
            'Security identifier value of SecurityIDSource (22) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityIDSource.',
        added: 'FIX.2.7',
        AbbrName: 'ID',
        Tag: 48,
        NotReqXML: 0,
        Name: 'SecurityID',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify firm sending message.',
        added: 'FIX.2.7',
        AbbrName: 'SID',
        Tag: 49,
        NotReqXML: 0,
        Name: 'SenderCompID',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify specific message originator (desk, trader, etc.)',
        added: 'FIX.2.7',
        AbbrName: 'SSub',
        Tag: 50,
        NotReqXML: 0,
        Name: 'SenderSubID',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
        added: 'FIX.2.7',
        AbbrName: 'Snt',
        Tag: 52,
        NotReqXML: 0,
        Name: 'SendingTime',
    },
    {
        Type: 'Qty',
        Description: 'Overall/total quantity (e.g. number of shares)\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'Qty',
        Tag: 53,
        NotReqXML: 0,
        Name: 'Quantity',
    },
    {
        Type: 'char',
        Description: 'Side of order (see Volume : "Glossary" for value definitions)',
        added: 'FIX.2.7',
        AbbrName: 'Side',
        Tag: 54,
        NotReqXML: 0,
        Name: 'Side',
    },
    {
        Type: 'String',
        Description:
            'Ticker symbol. Common, "human understood" representation of the security. SecurityID (48) value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\nUse "[N/A]" for products which do not have a symbol.',
        added: 'FIX.2.7',
        AbbrName: 'Sym',
        Tag: 55,
        NotReqXML: 0,
        Name: 'Symbol',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify receiving firm.',
        added: 'FIX.2.7',
        AbbrName: 'TID',
        Tag: 56,
        NotReqXML: 0,
        Name: 'TargetCompID',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify specific individual or unit intended to receive message. "ADMIN" reserved for administrative messages not intended for a specific user.',
        added: 'FIX.2.7',
        AbbrName: 'TSub',
        Tag: 57,
        NotReqXML: 0,
        Name: 'TargetSubID',
    },
    {
        Type: 'String',
        Description: 'Free format text string\n(Note: this field does not have a specified maximum length)',
        added: 'FIX.2.7',
        AbbrName: 'Txt',
        Tag: 58,
        NotReqXML: 0,
        Name: 'Text',
    },
    {
        Type: 'char',
        Description:
            'Specifies how long the order remains in effect. Absence of this field is interpreted as DAY. NOTE not applicable to CIV Orders. (see Volume : "Glossary" for value definitions)',
        added: 'FIX.2.7',
        AbbrName: 'TmInForce',
        Tag: 59,
        NotReqXML: 0,
        Name: 'TimeInForce',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Timestamp when the business transaction represented by the message occurred.',
        added: 'FIX.2.7',
        updatedEP: 94,
        AbbrName: 'TxnTm',
        Tag: 60,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TransactTime',
    },
    {
        Type: 'char',
        Description: 'Urgency flag',
        added: 'FIX.2.7',
        AbbrName: 'Urgency',
        Tag: 61,
        NotReqXML: 0,
        Name: 'Urgency',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Indicates expiration time of indication message (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
        added: 'FIX.2.7',
        AbbrName: 'ValidUntilTm',
        Tag: 62,
        NotReqXML: 0,
        Name: 'ValidUntilTime',
    },
    {
        Type: 'String',
        UnionDataType: 'Tenor',
        Description:
            'Indicates order settlement period. If present, SettlDate (64) overrides this field. If both SettlType (63) and SettDate (64) are omitted, the default for SettlType (63) is 0 (Regular)\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\nIn Fixed Income the contents of this field may influence the instrument definition if the SecurityID (48) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and "when-issued" securities. Supplying a value of "7" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\nAdditionally the following patterns may be uses as well as enum values\nDx = FX tenor expression for "days", e.g. "D5", where "x" is any integer > 0\nMx = FX tenor expression for "months", e.g. "M3", where "x" is any integer > 0\nWx = FX tenor expression for "weeks", e.g. "W13", where "x" is any integer > 0\nYx = FX tenor expression for "years", e.g. "Y1", where "x" is any integer > 0\nNoted that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.',
        added: 'FIX.2.7',
        AbbrName: 'SettlTyp',
        Tag: 63,
        NotReqXML: 0,
        Name: 'SettlType',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Specific date of trade settlement (SettlementDate) in YYYYMMDD format.\nIf present, this field overrides SettlType (63). This field is required if the value of SettlType (63) is 6 (Future) or 8 (Sellers Option). This field must be omitted if the value of SettlType (63) is 7 (When and If Issued)\n(expressed in local time at place of settlement)',
        added: 'FIX.2.7',
        AbbrName: 'SettlDt',
        Tag: 64,
        NotReqXML: 0,
        Name: 'SettlDate',
    },
    {
        Type: 'String',
        Description:
            'Additional information about the security (e.g. preferred, warrants, etc.). Note also see SecurityType (167).\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory.',
        added: 'FIX.2.7',
        AbbrName: 'Sfx',
        Tag: 65,
        NotReqXML: 0,
        Name: 'SymbolSfx',
    },
    {
        BaseCategory: 'ProgramTrading',
        Type: 'String',
        Description:
            'Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days.',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'ListID',
        Tag: 66,
        NotReqXML: 0,
        Name: 'ListID',
    },
    {
        BaseCategory: 'ProgramTrading',
        Type: 'int',
        Description:
            'Sequence of individual order within list (i.e. ListSeqNo of TotNoOrders (68), 2 of 25, 3 of 25, . . . )',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'SeqNo',
        AbbrName: 'ListSeqNo',
        Tag: 67,
        NotReqXML: 0,
        Name: 'ListSeqNo',
    },
    {
        Type: 'int',
        Description:
            'Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n(Prior to FIX 4.2 this field was named "ListNoOrds")',
        added: 'FIX.2.7',
        AbbrName: 'TotNoOrds',
        Tag: 68,
        NotReqXML: 0,
        Name: 'TotNoOrders',
    },
    {
        Type: 'String',
        Description: 'Free format text message containing list handling and execution instructions.',
        added: 'FIX.2.7',
        AbbrName: 'ListExecInst',
        Tag: 69,
        NotReqXML: 0,
        Name: 'ListExecInst',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'String',
        Description: 'Unique identifier for allocation message.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'AllocID',
        Tag: 70,
        NotReqXML: 0,
        Name: 'AllocID',
    },
    {
        Type: 'char',
        Description:
            'Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
        added: 'FIX.2.7',
        AbbrName: 'TransTyp',
        Tag: 71,
        NotReqXML: 0,
        Name: 'AllocTransType',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'String',
        Description:
            'Reference identifier to be used with AllocTransType (71) = Replace or Cancel.\n(Prior to FIX 4.1 this field was of type int)',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'RefID',
        AbbrName: 'RefAllocID',
        Tag: 72,
        NotReqXML: 0,
        Name: 'RefAllocID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Indicates number of orders to be combined for average pricing and allocation.',
        added: 'FIX.2.7',
        AbbrName: 'NoOrds',
        Tag: 73,
        NotReqXML: 1,
        Name: 'NoOrders',
    },
    {
        Type: 'int',
        Description:
            'Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used.',
        added: 'FIX.2.7',
        AbbrName: 'AvgPxPrcsn',
        Tag: 74,
        NotReqXML: 0,
        Name: 'AvgPxPrecision',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Indicates date of trade referenced in this message in YYYYMMDD format. Absence of this field indicates current day (expressed in local time at place of trade).',
        added: 'FIX.2.7',
        AbbrName: 'TrdDt',
        Tag: 75,
        NotReqXML: 0,
        Name: 'TradeDate',
    },
    {
        Type: 'char',
        Description:
            'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
        added: 'FIX.2.7',
        AbbrName: 'PosEfct',
        Tag: 77,
        NotReqXML: 0,
        Name: 'PositionEffect',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating AllocAccount (79)/AllocPrice (366) entries.',
        added: 'FIX.2.7',
        AbbrName: 'NoAllocs',
        Tag: 78,
        NotReqXML: 1,
        Name: 'NoAllocs',
    },
    {
        Type: 'String',
        Description: 'Sub-account mnemonic',
        added: 'FIX.2.7',
        AbbrName: 'Acct',
        Tag: 79,
        NotReqXML: 0,
        Name: 'AllocAccount',
    },
    {
        Type: 'Qty',
        Description: 'Quantity to be allocated to specific sub-account\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'Qty',
        Tag: 80,
        NotReqXML: 0,
        Name: 'AllocQty',
    },
    {
        Type: 'char',
        Description:
            'Processing code for sub-account. Absence of this field in AllocAccount (79) / AllocPrice (366) /AllocQty (80) / ProcessCode instance indicates regular trade.',
        added: 'FIX.2.7',
        AbbrName: 'ProcCode',
        Tag: 81,
        NotReqXML: 0,
        Name: 'ProcessCode',
    },
    {
        Type: 'int',
        Description: 'Total number of reports within series.',
        added: 'FIX.2.7',
        AbbrName: 'NoRpts',
        Tag: 82,
        NotReqXML: 0,
        Name: 'NoRpts',
    },
    {
        Type: 'int',
        Description:
            'Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side.',
        added: 'FIX.2.7',
        AbbrName: 'RptSeq',
        Tag: 83,
        NotReqXML: 0,
        Name: 'RptSeq',
    },
    {
        Type: 'Qty',
        Description: 'Total quantity canceled for this order.\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.2.7',
        AbbrName: 'CxlQty',
        Tag: 84,
        NotReqXML: 0,
        Name: 'CxlQty',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of delivery instruction fields in repeating group.\nNote this field was removed in FIX 4.1 and reinstated in FIX 4.4.',
        issue: 'SPEC-394',
        added: 'FIX.2.7',
        AbbrName: 'NoDlvyInst',
        Tag: 85,
        NotReqXML: 1,
        Name: 'NoDlvyInst',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'int',
        Description: 'Identifies status of allocation.',
        added: 'FIX.2.7',
        BaseCategoryAbbrName: 'Stat',
        AbbrName: 'Stat',
        Tag: 87,
        NotReqXML: 0,
        Name: 'AllocStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Identifies reason for rejection.',
        added: 'FIX.2.7',
        updatedEP: 95,
        AbbrName: 'RejCode',
        Tag: 88,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'AllocRejCode',
    },
    {
        Type: 'data',
        Description: 'Electronic signature',
        added: 'FIX.2.7',
        deprecated: 'FIXT.1.1',
        AbbrName: 'Signature',
        Tag: 89,
        NotReqXML: 1,
        Name: 'Signature',
    },
    {
        Type: 'Length',
        Description: 'Length of encrypted message',
        added: 'FIX.2.7',
        deprecated: 'FIXT.1.1',
        AssociatedDataTag: 91,
        AbbrName: 'SecureDataLen',
        Tag: 90,
        NotReqXML: 1,
        Name: 'SecureDataLen',
    },
    {
        Type: 'data',
        Description: 'Actual encrypted data stream',
        added: 'FIX.2.7',
        deprecated: 'FIXT.1.1',
        AbbrName: 'SecureData',
        Tag: 91,
        NotReqXML: 1,
        Name: 'SecureData',
    },
    {
        Type: 'Length',
        Description: 'Number of bytes in signature field',
        added: 'FIX.2.7',
        deprecated: 'FIXT.1.1',
        AssociatedDataTag: 89,
        AbbrName: 'SignatureLength',
        Tag: 93,
        NotReqXML: 1,
        Name: 'SignatureLength',
    },
    {
        Type: 'char',
        Description: 'Email message type.',
        added: 'FIX.2.7',
        AbbrName: 'EmailTyp',
        Tag: 94,
        NotReqXML: 0,
        Name: 'EmailType',
    },
    {
        Type: 'Length',
        Description: 'Number of bytes in raw data field.',
        added: 'FIX.2.7',
        AssociatedDataTag: 96,
        AbbrName: 'RawDataLength',
        Tag: 95,
        NotReqXML: 0,
        Name: 'RawDataLength',
    },
    {
        Type: 'data',
        Description: 'Unformatted raw data, can include bitmaps, word processor documents, etc.',
        added: 'FIX.2.7',
        AbbrName: 'RawData',
        Tag: 96,
        NotReqXML: 0,
        Name: 'RawData',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates that message may contain information that has been sent under another sequence number.',
        added: 'FIX.2.7',
        AbbrName: 'PosRsnd',
        Tag: 97,
        NotReqXML: 0,
        Name: 'PossResend',
    },
    {
        Type: 'int',
        Description: 'Method of encryption.',
        added: 'FIX.2.7',
        AbbrName: 'EncryptMethod',
        Tag: 98,
        NotReqXML: 1,
        Name: 'EncryptMethod',
    },
    {
        Type: 'Price',
        Description: 'Price per unit of quantity (e.g. per share)',
        added: 'FIX.2.7',
        AbbrName: 'StopPx',
        Tag: 99,
        NotReqXML: 0,
        Name: 'StopPx',
    },
    {
        Type: 'Exchange',
        Description:
            'Execution destination as defined by institution when order is entered.\nValid values:\nSee "Appendix 6-C"',
        added: 'FIX.2.7',
        AbbrName: 'ExDest',
        Tag: 100,
        NotReqXML: 0,
        Name: 'ExDestination',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Code to identify reason for cancel rejection.',
        added: 'FIX.2.7',
        AbbrName: 'CxlRejRsn',
        Tag: 102,
        NotReqXML: 0,
        Name: 'CxlRejReason',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Code to identify reason for order rejection. Note: Values 3, 4, and 5 will be used when rejecting an order due to pre-allocation information errors.',
        added: 'FIX.2.7',
        AbbrName: 'RejRsn',
        Tag: 103,
        NotReqXML: 0,
        Name: 'OrdRejReason',
    },
    {
        Type: 'char',
        Description: 'Code to qualify IOI use. (see Volume : "Glossary" for value definitions)',
        added: 'FIX.3.0',
        AbbrName: 'Qual',
        Tag: 104,
        NotReqXML: 0,
        Name: 'IOIQualifier',
    },
    {
        Type: 'String',
        Description:
            'Name of security issuer (e.g. International Business Machines, GNMA).\nsee also Volume 7: "PRODUCT: FIXED INCOME - Euro Issuer Values"',
        added: 'FIX.3.0',
        AbbrName: 'Issr',
        Tag: 106,
        NotReqXML: 0,
        Name: 'Issuer',
    },
    {
        Type: 'String',
        Description: 'Can be used to provide an optional textual description for a financial instrument.',
        added: 'FIX.3.0',
        AbbrName: 'Desc',
        Tag: 107,
        NotReqXML: 0,
        Name: 'SecurityDesc',
    },
    {
        Type: 'int',
        Description: 'Heartbeat interval (seconds)',
        added: 'FIX.3.0',
        AbbrName: 'HeartBtInt',
        Tag: 108,
        NotReqXML: 1,
        Name: 'HeartBtInt',
    },
    {
        Type: 'Qty',
        Description: 'Minimum quantity of an order to be executed.\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.3.0',
        AbbrName: 'MinQty',
        Tag: 110,
        NotReqXML: 0,
        Name: 'MinQty',
    },
    {
        Type: 'Qty',
        Description:
            'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
        added: 'FIX.3.0',
        deprecated: 'FIX.5.0',
        AbbrName: 'MaxFloor',
        Tag: 111,
        NotReqXML: 0,
        Name: 'MaxFloor',
    },
    {
        Type: 'String',
        Description: 'Identifier included in Test Request message to be returned in resulting Heartbeat',
        added: 'FIX.3.0',
        AbbrName: 'TestReqID',
        Tag: 112,
        NotReqXML: 1,
        Name: 'TestReqID',
    },
    {
        Type: 'Boolean',
        Description: 'Identifies party of trade responsible for exchange reporting.',
        added: 'FIX.3.0',
        AbbrName: 'RptToExch',
        Tag: 113,
        NotReqXML: 0,
        Name: 'ReportToExch',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether the broker is to locate the stock in conjunction with a short sell order.',
        added: 'FIX.4.0',
        AbbrName: 'LocReqd',
        Tag: 114,
        NotReqXML: 0,
        Name: 'LocateReqd',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field.',
        added: 'FIX.4.0',
        AbbrName: 'OBID',
        Tag: 115,
        NotReqXML: 0,
        Name: 'OnBehalfOfCompID',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party',
        added: 'FIX.4.0',
        AbbrName: 'OBSub',
        Tag: 116,
        NotReqXML: 0,
        Name: 'OnBehalfOfSubID',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for quote',
        added: 'FIX.4.0',
        AbbrName: 'QID',
        Tag: 117,
        NotReqXML: 0,
        Name: 'QuoteID',
    },
    {
        Type: 'Amt',
        Description:
            'Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution.',
        added: 'FIX.4.0',
        AbbrName: 'NetMny',
        Tag: 118,
        NotReqXML: 0,
        Name: 'NetMoney',
    },
    {
        Type: 'Amt',
        Description: 'Total amount due expressed in settlement currency (includes the effect of the forex transaction)',
        added: 'FIX.4.0',
        AbbrName: 'SettlCurrAmt',
        Tag: 119,
        NotReqXML: 0,
        Name: 'SettlCurrAmt',
    },
    {
        Type: 'Currency',
        Description: 'Currency code of settlement denomination.',
        added: 'FIX.4.0',
        AbbrName: 'SettlCcy',
        Tag: 120,
        NotReqXML: 0,
        Name: 'SettlCurrency',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates request for forex accommodation trade to be executed along with security transaction.',
        added: 'FIX.4.0',
        AbbrName: 'ForexReq',
        Tag: 121,
        NotReqXML: 0,
        Name: 'ForexReq',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT") when transmitting orders as the result of a resend request.',
        added: 'FIX.4.0',
        AbbrName: 'OrigSnt',
        Tag: 122,
        NotReqXML: 0,
        Name: 'OrigSendingTime',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.',
        added: 'FIX.4.0',
        AbbrName: 'GapFillFlag',
        Tag: 123,
        NotReqXML: 1,
        Name: 'GapFillFlag',
    },
    {
        Type: 'NumInGroup',
        Description: 'No of execution repeating group entries to follow.',
        added: 'FIX.4.0',
        AbbrName: 'NoExecs',
        Tag: 124,
        NotReqXML: 1,
        Name: 'NoExecs',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Time/Date of order expiration (always expressed in UTC (Universal Time Coordinated, also known as "GMT")\nThe meaning of expiration is specific to the context where the field is used.\nFor orders, this is the expiration time of a Good Til Date TimeInForce.\nFor Quotes - this is the expiration of the quote.\nExpiration time is provided across the quote message dialog to control the length of time of the overall quoting process.\nFor collateral requests, this is the time by which collateral must be assigned.\nFor collateral assignments, this is the time by which a response to the assignment is expected.',
        added: 'FIX.4.0',
        AbbrName: 'ExpireTm',
        Tag: 126,
        NotReqXML: 0,
        Name: 'ExpireTime',
    },
    {
        Type: 'char',
        Description: 'Reason for execution rejection.',
        added: 'FIX.4.0',
        AbbrName: 'DkRsn',
        Tag: 127,
        NotReqXML: 0,
        Name: 'DKReason',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID (56) field and the ultimate receiver firm ID in this field.',
        added: 'FIX.4.0',
        AbbrName: 'D2ID',
        Tag: 128,
        NotReqXML: 0,
        Name: 'DeliverToCompID',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party',
        added: 'FIX.4.0',
        AbbrName: 'D2Sub',
        Tag: 129,
        NotReqXML: 0,
        Name: 'DeliverToSubID',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.',
        added: 'FIX.4.0',
        AbbrName: 'NatFlag',
        Tag: 130,
        NotReqXML: 0,
        Name: 'IOINaturalFlag',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for quote request',
        added: 'FIX.4.0',
        AbbrName: 'ReqID',
        Tag: 131,
        NotReqXML: 0,
        Name: 'QuoteReqID',
    },
    {
        Type: 'Price',
        Description: 'Bid price/rate',
        added: 'FIX.4.0',
        AbbrName: 'BidPx',
        Tag: 132,
        NotReqXML: 0,
        Name: 'BidPx',
    },
    {
        Type: 'Price',
        Description: 'Offer price/rate',
        added: 'FIX.4.0',
        AbbrName: 'OfrPx',
        Tag: 133,
        NotReqXML: 0,
        Name: 'OfferPx',
    },
    {
        Type: 'Qty',
        Description: 'Quantity of bid\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.4.0',
        AbbrName: 'BidSz',
        Tag: 134,
        NotReqXML: 0,
        Name: 'BidSize',
    },
    {
        Type: 'Qty',
        Description: 'Quantity of offer\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.4.0',
        AbbrName: 'OfrSz',
        Tag: 135,
        NotReqXML: 0,
        Name: 'OfferSize',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating groups of miscellaneous fees',
        added: 'FIX.4.0',
        AbbrName: 'NoMiscFees',
        Tag: 136,
        NotReqXML: 1,
        Name: 'NoMiscFees',
    },
    {
        Type: 'Amt',
        Description: 'Miscellaneous fee value',
        added: 'FIX.4.0',
        AbbrName: 'Amt',
        Tag: 137,
        NotReqXML: 0,
        Name: 'MiscFeeAmt',
    },
    {
        Type: 'Currency',
        Description: 'Currency of miscellaneous fee',
        added: 'FIX.4.0',
        AbbrName: 'Curr',
        Tag: 138,
        NotReqXML: 0,
        Name: 'MiscFeeCurr',
    },
    {
        Type: 'String',
        Description: 'Indicates type of miscellaneous fee.',
        added: 'FIX.4.0',
        AbbrName: 'Typ',
        Tag: 139,
        NotReqXML: 0,
        Name: 'MiscFeeType',
    },
    {
        Type: 'Price',
        Description: 'Previous closing price of security.',
        added: 'FIX.4.0',
        AbbrName: 'PrevClsPx',
        Tag: 140,
        NotReqXML: 0,
        Name: 'PrevClosePx',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates that the both sides of the FIX session should reset sequence numbers.',
        added: 'FIX.4.1',
        AbbrName: 'ResetSeqNumFlag',
        Tag: 141,
        NotReqXML: 1,
        Name: 'ResetSeqNumFlag',
    },
    {
        Type: 'String',
        Description:
            "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader)",
        added: 'FIX.4.1',
        AbbrName: 'SLoc',
        Tag: 142,
        NotReqXML: 0,
        Name: 'SenderLocationID',
    },
    {
        Type: 'String',
        Description:
            "Assigned value used to identify specific message destination's location (i.e. geographic location and/or desk, trader)",
        added: 'FIX.4.1',
        AbbrName: 'TLoc',
        Tag: 143,
        NotReqXML: 0,
        Name: 'TargetLocationID',
    },
    {
        Type: 'String',
        Description:
            "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
        added: 'FIX.4.1',
        AbbrName: 'OBLoc',
        Tag: 144,
        NotReqXML: 0,
        Name: 'OnBehalfOfLocationID',
    },
    {
        Type: 'String',
        Description:
            "Assigned value used to identify specific message recipient's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
        added: 'FIX.4.1',
        AbbrName: 'D2Loc',
        Tag: 145,
        NotReqXML: 0,
        Name: 'DeliverToLocationID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Specifies the number of repeating symbols specified.',
        added: 'FIX.4.1',
        AbbrName: 'NoReltdSym',
        Tag: 146,
        NotReqXML: 1,
        Name: 'NoRelatedSym',
    },
    {
        Type: 'String',
        Description: 'The subject of an Email message',
        added: 'FIX.4.1',
        AbbrName: 'Subject',
        Tag: 147,
        NotReqXML: 0,
        Name: 'Subject',
    },
    {
        Type: 'String',
        Description: 'The headline of a News message',
        added: 'FIX.4.1',
        AbbrName: 'Headline',
        Tag: 148,
        NotReqXML: 0,
        Name: 'Headline',
    },
    {
        Type: 'String',
        Description:
            'A URI (Uniform Resource Identifier) or URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)\nSee "Appendix 6-B FIX Fields Based Upon Other Standards"',
        added: 'FIX.4.1',
        AbbrName: 'URL',
        Tag: 149,
        NotReqXML: 0,
        Name: 'URLLink',
    },
    {
        Type: 'char',
        Description:
            'Describes the specific ExecutionRpt (i.e. Pending Cancel) while OrdStatus (39) will always identify the current order status (i.e. Partially Filled) *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
        added: 'FIX.4.1',
        AbbrName: 'ExecTyp',
        Tag: 150,
        NotReqXML: 0,
        Name: 'ExecType',
    },
    {
        Type: 'Qty',
        Description:
            'Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.4.1',
        AbbrName: 'LeavesQty',
        Tag: 151,
        NotReqXML: 0,
        Name: 'LeavesQty',
    },
    {
        Type: 'Qty',
        Description:
            'Specifies the approximate order quantity desired in total monetary units vs. as tradeable units (e.g. number of shares). The broker or fund manager (for CIV orders) would be responsible for converting and calculating a tradeable unit (e.g. share) quantity (OrderQty (38)) based upon this amount to be used for the actual order and subsequent messages.',
        added: 'FIX.4.1',
        AbbrName: 'Cash',
        Tag: 152,
        NotReqXML: 0,
        Name: 'CashOrderQty',
    },
    {
        Type: 'Price',
        Description:
            'AvgPx (6) for a specific AllocAccount (79)\nFor Fixed Income this is always expressed as "percent of par" price type.',
        added: 'FIX.4.1',
        AbbrName: 'AvgPx',
        Tag: 153,
        NotReqXML: 0,
        Name: 'AllocAvgPx',
    },
    {
        Type: 'Amt',
        Description: 'NetMoney (8) for a specific AllocAccount (79)',
        added: 'FIX.4.1',
        AbbrName: 'NetMny',
        Tag: 154,
        NotReqXML: 0,
        Name: 'AllocNetMoney',
    },
    {
        Type: 'float',
        Description: 'Foreign exchange rate used to compute SettlCurrAmt (9) from Currency (5) to SettlCurrency (20)',
        added: 'FIX.4.1',
        AbbrName: 'SettlCurrFxRt',
        Tag: 155,
        NotReqXML: 0,
        Name: 'SettlCurrFxRate',
    },
    {
        Type: 'char',
        Description: 'Specifies whether or not SettlCurrFxRate (55) should be multiplied or divided.',
        added: 'FIX.4.1',
        AbbrName: 'SettlCurrFxRtCalc',
        Tag: 156,
        NotReqXML: 0,
        Name: 'SettlCurrFxRateCalc',
    },
    {
        Type: 'int',
        Description: 'Number of Days of Interest for convertible bonds and fixed income. Note value may be negative.',
        added: 'FIX.4.1',
        AbbrName: 'NumDaysInt',
        Tag: 157,
        NotReqXML: 0,
        Name: 'NumDaysInterest',
    },
    {
        Type: 'Percentage',
        Description:
            'The amount the buyer compensates the seller for the portion of the next coupon interest payment the seller has earned but will not receive from the issuer because the issuer will send the next coupon payment to the buyer. Accrued Interest Rate is the annualized Accrued Interest amount divided by the purchase price of the bond.',
        added: 'FIX.4.1',
        AbbrName: 'AcrdIntRt',
        Tag: 158,
        NotReqXML: 0,
        Name: 'AccruedInterestRate',
    },
    {
        Type: 'Amt',
        Description: 'Amount of Accrued Interest for convertible bonds and fixed income',
        added: 'FIX.4.1',
        AbbrName: 'AcrdIntAmt',
        Tag: 159,
        NotReqXML: 0,
        Name: 'AccruedInterestAmt',
    },
    {
        Type: 'char',
        Description:
            'Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
        added: 'FIX.4.1',
        AbbrName: 'SettlInstMode',
        Tag: 160,
        NotReqXML: 0,
        Name: 'SettlInstMode',
    },
    {
        Type: 'String',
        Description: 'Free format text related to a specific AllocAccount (79).',
        added: 'FIX.4.1',
        AbbrName: 'Txt',
        Tag: 161,
        NotReqXML: 0,
        Name: 'AllocText',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for Settlement Instruction.',
        added: 'FIX.4.1',
        AbbrName: 'SettlInstID',
        Tag: 162,
        NotReqXML: 0,
        Name: 'SettlInstID',
    },
    {
        Type: 'char',
        Description: 'Settlement Instructions message transaction type',
        added: 'FIX.4.1',
        AbbrName: 'SettlInstTransTyp',
        Tag: 163,
        NotReqXML: 0,
        Name: 'SettlInstTransType',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for an email thread (new and chain of replies)',
        added: 'FIX.4.1',
        AbbrName: 'EmailThreadID',
        Tag: 164,
        NotReqXML: 0,
        Name: 'EmailThreadID',
    },
    {
        Type: 'char',
        Description: 'Indicates source of Settlement Instructions',
        added: 'FIX.4.1',
        AbbrName: 'InstSrc',
        Tag: 165,
        NotReqXML: 0,
        Name: 'SettlInstSource',
    },
    {
        Type: 'String',
        Description:
            'Indicates type of security. Security type enumerations are grouped by Product(460) field value. NOTE: Additional values may be used by mutual agreement of the counterparties.',
        added: 'FIX.4.1',
        AbbrName: 'SecTyp',
        Tag: 167,
        NotReqXML: 0,
        Name: 'SecurityType',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Time the details within the message should take effect (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
        added: 'FIX.4.1',
        AbbrName: 'EfctvTm',
        Tag: 168,
        NotReqXML: 0,
        Name: 'EffectiveTime',
    },
    {
        Type: 'int',
        Description: 'Identifies the Standing Instruction database used',
        added: 'FIX.4.1',
        AbbrName: 'StandInstDbTyp',
        Tag: 169,
        NotReqXML: 0,
        Name: 'StandInstDbType',
    },
    {
        Type: 'String',
        Description:
            "Name of the Standing Instruction database represented with StandInstDbType (169) (i.e. the Global Custodian's name).",
        added: 'FIX.4.1',
        AbbrName: 'StandInstDbName',
        Tag: 170,
        NotReqXML: 0,
        Name: 'StandInstDbName',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced.',
        added: 'FIX.4.1',
        AbbrName: 'StandInstDbID',
        Tag: 171,
        NotReqXML: 0,
        Name: 'StandInstDbID',
    },
    {
        Type: 'int',
        Description: 'Identifies type of settlement',
        added: 'FIX.4.1',
        AbbrName: 'DlvryTyp',
        Tag: 172,
        NotReqXML: 0,
        Name: 'SettlDeliveryType',
    },
    {
        Type: 'Price',
        Description: 'Bid F/X spot rate.',
        added: 'FIX.4.1',
        AbbrName: 'BidSpotRt',
        Tag: 188,
        NotReqXML: 0,
        Name: 'BidSpotRate',
    },
    {
        Type: 'PriceOffset',
        Description: 'Bid F/X forward points added to spot rate. May be a negative value.',
        added: 'FIX.4.1',
        AbbrName: 'BidFwdPnts',
        Tag: 189,
        NotReqXML: 0,
        Name: 'BidForwardPoints',
    },
    {
        Type: 'Price',
        Description: 'Offer F/X spot rate.',
        added: 'FIX.4.1',
        AbbrName: 'OfrSpotRt',
        Tag: 190,
        NotReqXML: 0,
        Name: 'OfferSpotRate',
    },
    {
        Type: 'PriceOffset',
        Description: 'Offer F/X forward points added to spot rate. May be a negative value.',
        added: 'FIX.4.1',
        AbbrName: 'OfrFwdPnts',
        Tag: 191,
        NotReqXML: 0,
        Name: 'OfferForwardPoints',
    },
    {
        Type: 'Qty',
        Description: 'OrderQty (38) of the future part of a F/X swap order.',
        added: 'FIX.4.1',
        deprecated: 'FIX.5.0',
        AbbrName: 'Qty2',
        Tag: 192,
        NotReqXML: 0,
        Name: 'OrderQty2',
    },
    {
        Type: 'LocalMktDate',
        Description: 'SettDate (64) of the future part of a F/X swap order.',
        added: 'FIX.4.1',
        deprecated: 'FIX.5.0',
        AbbrName: 'SettlDt2',
        Tag: 193,
        NotReqXML: 0,
        Name: 'SettlDate2',
    },
    {
        Type: 'Price',
        Description: 'F/X spot rate.',
        added: 'FIX.4.1',
        AbbrName: 'LastSpotRt',
        Tag: 194,
        NotReqXML: 0,
        Name: 'LastSpotRate',
    },
    {
        Type: 'PriceOffset',
        Description:
            'F/X forward points added to LastSpotRate (94). May be a negative value. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.1',
        AbbrName: 'LastFwdPnts',
        Tag: 195,
        NotReqXML: 0,
        Name: 'LastForwardPoints',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'String',
        Description:
            'Can be used to link two different Allocation messages (each with unique AllocID (70)) together, i.e. for F/X "Netting" or "Swaps". Should be unique.',
        added: 'FIX.4.1',
        BaseCategoryAbbrName: 'LinkID',
        AbbrName: 'LinkID',
        Tag: 196,
        NotReqXML: 0,
        Name: 'AllocLinkID',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of Allocation linkage when AllocLinkID (96) is used.',
        added: 'FIX.4.1',
        AbbrName: 'LinkTyp',
        Tag: 197,
        NotReqXML: 0,
        Name: 'AllocLinkType',
    },
    {
        Type: 'String',
        Description:
            'Assigned by the party which accepts the order. Can be used to provide the OrderID (37) used by an exchange or executing system.',
        added: 'FIX.4.1',
        AbbrName: 'OrdID2',
        Tag: 198,
        NotReqXML: 0,
        Name: 'SecondaryOrderID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating groups of IOIQualifiers (04).',
        added: 'FIX.4.1',
        AbbrName: 'NoIOIQuals',
        Tag: 199,
        NotReqXML: 1,
        Name: 'NoIOIQualifiers',
    },
    {
        Type: 'MonthYear',
        Description:
            'Can be used with standardized derivatives vs. the MaturityDate (54) field.  Month and Year of the maturity (used for standardized futures and options).\nFormat:\nYYYYMM (e.g. 199903)\nYYYYMMDD (e.g. 20030323)\nYYYYMMwN (e.g. 200303w) for week\nA specific date or can be appended to the MaturityMonthYear. For instance, if multiple standard products exist that mature in the same Year and Month, but actually mature at a different time, a value can be appended, such as "w" or "w2" to indicate week  as opposed to week 2 expiration. Likewise, the date (0-3) can be appended to indicate a specific expiration (maturity date).',
        added: 'FIX.4.1',
        updatedEP: 95,
        AbbrName: 'MMY',
        Tag: 200,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'MaturityMonthYear',
    },
    {
        Type: 'int',
        Description: 'Indicates whether an option contract is a put or call',
        added: 'FIX.4.1',
        AbbrName: 'PutCall',
        Tag: 201,
        NotReqXML: 0,
        Name: 'PutOrCall',
    },
    {
        Type: 'Price',
        Description: 'Strike Price for an Option.',
        added: 'FIX.4.1',
        AbbrName: 'StrkPx',
        Tag: 202,
        NotReqXML: 0,
        Name: 'StrikePrice',
    },
    {
        Type: 'int',
        Description: 'Used for derivative products, such as options',
        added: 'FIX.4.1',
        AbbrName: 'Covered',
        Tag: 203,
        NotReqXML: 0,
        Name: 'CoveredOrUncovered',
    },
    {
        Type: 'char',
        Description:
            'Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions.',
        added: 'FIX.4.1',
        AbbrName: 'OptAt',
        Tag: 206,
        NotReqXML: 0,
        Name: 'OptAttribute',
    },
    {
        Type: 'Exchange',
        Description: 'Market used to help identify a security.\nValid values:\nSee "Appendix 6-C"',
        added: 'FIX.4.1',
        AbbrName: 'Exch',
        Tag: 207,
        NotReqXML: 0,
        Name: 'SecurityExchange',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).',
        added: 'FIX.4.1',
        AbbrName: 'NotifyBrkrOfCredit',
        Tag: 208,
        NotReqXML: 0,
        Name: 'NotifyBrokerOfCredit',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'int',
        Description:
            'Indicates how the receiver (i.e. third party) of Allocation message should handle/process the account details.',
        added: 'FIX.4.1',
        BaseCategoryAbbrName: 'HndInst',
        AbbrName: 'HandlInst',
        Tag: 209,
        NotReqXML: 0,
        Name: 'AllocHandlInst',
    },
    {
        Type: 'Qty',
        Description:
            'Maximum quantity (e.g. number of shares) within an order to be shown to other customers (i.e. sent via an IOI).\n(Prior to FIX 4.2 this field was of type int)',
        added: 'FIX.4.1',
        deprecated: 'FIX.5.0',
        AbbrName: 'MaxShow',
        Tag: 210,
        NotReqXML: 0,
        Name: 'MaxShow',
    },
    {
        Type: 'float',
        Description:
            'Amount (signed) added to the peg for a pegged order in the context of the PegOffsetType (836)\n(Prior to FIX 4.4 this field was of type PriceOffset)',
        added: 'FIX.4.1',
        AbbrName: 'OfstVal',
        Tag: 211,
        NotReqXML: 0,
        Name: 'PegOffsetValue',
    },
    {
        Type: 'Length',
        Description: 'Length of the XmlData data block.',
        added: 'FIX.4.2',
        AssociatedDataTag: 213,
        AbbrName: 'XmlDataLen',
        Tag: 212,
        NotReqXML: 1,
        Name: 'XmlDataLen',
    },
    {
        Type: 'data',
        Description:
            'Actual XML data stream (e.g. FIXML). See approriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters.',
        added: 'FIX.4.2',
        AbbrName: 'XmlData',
        Tag: 213,
        NotReqXML: 1,
        Name: 'XmlData',
    },
    {
        Type: 'String',
        Description:
            'Reference identifier for the SettlInstID (162) with Cancel and Replace SettlInstTransType (163) transaction types.',
        added: 'FIX.4.2',
        AbbrName: 'SettlInstRefID',
        Tag: 214,
        NotReqXML: 0,
        Name: 'SettlInstRefID',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of repeating groups of RoutingID (217) and RoutingType (216) values.\nSee Volume 3: "Pre-Trade Message Targeting/Routing"',
        added: 'FIX.4.2',
        AbbrName: 'NoRtgIDs',
        Tag: 215,
        NotReqXML: 1,
        Name: 'NoRoutingIDs',
    },
    {
        Type: 'int',
        Description: 'Indicates the type of RoutingID (217) specified.',
        added: 'FIX.4.2',
        AbbrName: 'RtgTyp',
        Tag: 216,
        NotReqXML: 0,
        Name: 'RoutingType',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify a specific routing destination.',
        added: 'FIX.4.2',
        AbbrName: 'RtgID',
        Tag: 217,
        NotReqXML: 0,
        Name: 'RoutingID',
    },
    {
        Type: 'PriceOffset',
        Description:
            'For Fixed Income. Either Swap Spread or Spread to Benchmark depending upon the order type.\nSpread to Benchmark: Basis points relative to a benchmark. To be expressed as "count of basis points" (vs. an absolute value). E.g. High Grade Corporate Bonds may express price as basis points relative to benchmark (the BenchmarkCurveName (22) field). Note: Basis points can be negative.\nSwap Spread: Target spread for a swap.',
        added: 'FIX.4.2',
        AbbrName: 'Spread',
        Tag: 218,
        NotReqXML: 0,
        Name: 'Spread',
    },
    {
        Type: 'Currency',
        Description:
            'Identifies currency used for benchmark curve. See "Appendix 6-A: Valid Currency Codes" for information on obtaining valid values.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Ccy',
        Tag: 220,
        NotReqXML: 0,
        Name: 'BenchmarkCurveCurrency',
    },
    {
        Type: 'String',
        Description: 'Name of benchmark curve.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Name',
        Tag: 221,
        NotReqXML: 0,
        Name: 'BenchmarkCurveName',
    },
    {
        Type: 'String',
        Description:
            'Point on benchmark curve. Free form values: e.g. "Y", "7Y", "INTERPOLATED".\nSample values:\nM = combination of a number between 1-12 and a "M" for month\nY = combination of number between 1-100 and a "Y" for year}\n10Y-OLD = see above, then add "-OLD" when appropriate\nINTERPOLATED = the point is mathematically derived\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon\nSee Fixed Income-specific documentation at http://www.fixprotocol.org for additional values.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Point',
        Tag: 222,
        NotReqXML: 0,
        Name: 'BenchmarkCurvePoint',
    },
    {
        Type: 'Percentage',
        Description:
            "The rate of interest that, when multiplied by the principal, par value, or face value of a bond, provides the currency amount of the periodic interest payment. The coupon is always cited, along with maturity, in any quotation of a bond's price.",
        added: 'FIX.4.2',
        AbbrName: 'CpnRt',
        Tag: 223,
        NotReqXML: 0,
        Name: 'CouponRate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Date interest is to be paid. Used in identifying Corporate Bond issues.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'CpnPmt',
        Tag: 224,
        NotReqXML: 0,
        Name: 'CouponPaymentDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The date on which a bond or stock offering is issued. It may or may not be the same as the effective date ("Dated Date") or the date on which interest begins to accrue ("Interest Accrual Date")\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'Issued',
        Tag: 225,
        NotReqXML: 0,
        Name: 'IssueDate',
    },
    {
        Type: 'int',
        Description:
            'Number of business days before repurchase of a repo. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoTrm',
        Tag: 226,
        NotReqXML: 0,
        Name: 'RepurchaseTerm',
    },
    {
        Type: 'Percentage',
        Description:
            'Percent of par at which a Repo will be repaid. Represented as a percent, e.g. .9525 represents 95-/4 percent of par. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoRt',
        Tag: 227,
        NotReqXML: 0,
        Name: 'RepurchaseRate',
    },
    {
        Type: 'float',
        Description:
            'For Fixed Income: Amorization Factor for deriving Current face from Original face for ABS or MBS securities, note the fraction may be greater than, equal to or less than . In TIPS securities this is the Inflation index.\nQty * Factor * Price = Gross Trade Amount\nFor Derivatives: Contract Value Factor by which price must be adjusted to determine the true nominal value of one futures/options contract.\n(Qty * Price) * Factor = Nominal Value\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Fctr',
        Tag: 228,
        NotReqXML: 0,
        Name: 'Factor',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Used with Fixed Income for Muncipal New Issue Market. Agreement in principal between counter-parties prior to actual trade date.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'OrignDt',
        Tag: 229,
        NotReqXML: 0,
        Name: 'TradeOriginationDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The date when a distribution of interest is deducted from a securities assets or set aside for payment to bondholders. On the ex-date, the securities price drops by the amount of the distribution (plus or minus any market activity).\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'ExDt',
        Tag: 230,
        NotReqXML: 0,
        Name: 'ExDate',
    },
    {
        Type: 'float',
        Description:
            'Specifies the ratio or multiply factor to convert from "nominal" units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc). Applicable For Fixed Income, Convertible Bonds, Derivatives, etc.\nIn general quantities for all calsses should be expressed in the basic unit of the instrument, e.g. shares for equities, norminal or par amount for bonds, currency for foreign exchange. When quantity is expressed in contracts, e.g. financing transactions and bond trade reporting, ContractMutliplier should contain the number of units in one contract and can be omitted if the multiplier is the default amount for the instrument, i.e. 1,000 par of bonds, 1,000,000 par for financing transactions.',
        added: 'FIX.4.2',
        AbbrName: 'Mult',
        Tag: 231,
        NotReqXML: 0,
        Name: 'ContractMultiplier',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of stipulation entries\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3).',
        added: 'FIX.4.2',
        AbbrName: 'NoStips',
        Tag: 232,
        NotReqXML: 1,
        Name: 'NoStipulations',
    },
    {
        Type: 'String',
        Description:
            'For Fixed Income.\nType of Stipulation.\nOther types may be used by mutual agreement of the counterparties.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Typ',
        Tag: 233,
        NotReqXML: 0,
        Name: 'StipulationType',
    },
    {
        Type: 'String',
        Description:
            'For Fixed Income. Value of stipulation.\nThe expression can be an absolute single value or a combination of values and logical operators:\n< value\n> value\n<= value\n>= value\nvalue\nvalue - value2\nvalue OR value2\nvalue AND value2\nYES\nNO\nBargain conditions recognized by the London Stock Exchange - to be used when StipulationType is "BGNCON".\nCD = Special cum Dividend\nXD = Special ex Dividend\nCC = Special cum Coupon\nXC = Special ex Coupon\nCB = Special cum Bonus\nXB = Special ex Bonus\nCR = Special cum Rights\nXR = Special ex Rights\nCP = Special cum Capital Repayments\nXP = Special ex Capital Repayments\nCS = Cash Settlement\nSP = Special Price\nTR = Report for European Equity Market Securities in accordance with Chapter 8 of the Rules.\nGD = Guaranteed Delivery\nValues for StipulationType = "PXSOURCE":\nBB GENERIC\nBB FAIRVALUE\nBROKERTEC\nESPEED\nGOVPX\nHILLIARD FARBER\nICAP\nTRADEWEB\nTULLETT LIBERTY\nIf a particular side of the market is wanted append /BID /OFFER or /MID.\nplus appropriate combinations of the above and other expressions by mutual agreement of the counterparties.\nExamples: ">=60", ".25", "ORANGE OR CONTRACOSTA", etc.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Val',
        Tag: 234,
        NotReqXML: 0,
        Name: 'StipulationValue',
    },
    {
        Type: 'String',
        Description: 'Type of yield. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Typ',
        Tag: 235,
        NotReqXML: 0,
        Name: 'YieldType',
    },
    {
        Type: 'Percentage',
        Description: 'Yield percentage.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Yld',
        Tag: 236,
        NotReqXML: 0,
        Name: 'Yield',
    },
    {
        Type: 'Amt',
        Description:
            "The price at which the securities are distributed to the different members of an underwriting group for the primary market in Municipals, total gross underwriter's spread.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'TotTakedown',
        Tag: 237,
        NotReqXML: 0,
        Name: 'TotalTakedown',
    },
    {
        Type: 'Amt',
        Description:
            'Provides the reduction in price for the secondary market in Muncipals.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'Concession',
        Tag: 238,
        NotReqXML: 0,
        Name: 'Concession',
    },
    {
        Type: 'String',
        Description:
            'Identifies the collateral used in the transaction.\nValid values: see SecurityType (167) field (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.4',
        AssociatedDataTag: 167,
        AbbrName: 'RepoCollSecTyp',
        Tag: 239,
        NotReqXML: 0,
        Name: 'RepoCollateralSecurityType',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Return of investor's principal in a security. Bond redemption can occur before maturity date.(Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'Redeem',
        Tag: 240,
        NotReqXML: 0,
        Name: 'RedemptionDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Underlying security's CouponPaymentDate.\nSee CouponPaymentDate (224) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        AbbrName: 'CpnPmt',
        Tag: 241,
        NotReqXML: 0,
        Name: 'UnderlyingCouponPaymentDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Underlying security's IssueDate.\nSee IssueDate (225) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        AbbrName: 'Issued',
        Tag: 242,
        NotReqXML: 0,
        Name: 'UnderlyingIssueDate',
    },
    {
        Type: 'String',
        Description:
            "Underlying security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description.(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.3',
        deprecated: 'FIX.4.4',
        AssociatedDataTag: 167,
        AbbrName: 'RepoCollSecTyp',
        Tag: 243,
        NotReqXML: 0,
        Name: 'UnderlyingRepoCollateralSecurityType',
    },
    {
        Type: 'int',
        Description:
            "Underlying security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoTrm',
        Tag: 244,
        NotReqXML: 0,
        Name: 'UnderlyingRepurchaseTerm',
    },
    {
        Type: 'Percentage',
        Description:
            "Underlying security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoRt',
        Tag: 245,
        NotReqXML: 0,
        Name: 'UnderlyingRepurchaseRate',
    },
    {
        Type: 'float',
        Description:
            "Underlying security's Factor.\nSee Factor (228) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'Fctr',
        Tag: 246,
        NotReqXML: 0,
        Name: 'UnderlyingFactor',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Underlying security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'Redeem',
        Tag: 247,
        NotReqXML: 0,
        Name: 'UnderlyingRedemptionDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Multileg instrument's individual leg security's CouponPaymentDate.\nSee CouponPaymentDate (224) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        AbbrName: 'CpnPmt',
        Tag: 248,
        NotReqXML: 0,
        Name: 'LegCouponPaymentDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Multileg instrument's individual leg security's IssueDate.\nSee IssueDate (225) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        AbbrName: 'Issued',
        Tag: 249,
        NotReqXML: 0,
        Name: 'LegIssueDate',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual leg security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.3',
        deprecated: 'FIX.4.4',
        AssociatedDataTag: 167,
        AbbrName: 'RepoCollSecTyp',
        Tag: 250,
        NotReqXML: 0,
        Name: 'LegRepoCollateralSecurityType',
    },
    {
        Type: 'int',
        Description:
            "Multileg instrument's individual leg security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoTrm',
        Tag: 251,
        NotReqXML: 0,
        Name: 'LegRepurchaseTerm',
    },
    {
        Type: 'Percentage',
        Description:
            "Multileg instrument's individual leg security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'RepoRt',
        Tag: 252,
        NotReqXML: 0,
        Name: 'LegRepurchaseRate',
    },
    {
        Type: 'float',
        Description:
            "Multileg instrument's individual leg security's Factor.\nSee Factor (228) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'Fctr',
        Tag: 253,
        NotReqXML: 0,
        Name: 'LegFactor',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Multileg instrument's individual leg security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
        added: 'FIX.4.2',
        deprecated: 'FIX.4.4',
        AbbrName: 'Redeem',
        Tag: 254,
        NotReqXML: 0,
        Name: 'LegRedemptionDate',
    },
    {
        Type: 'String',
        Description:
            "An evaluation of a company's ability to repay obligations or its likelihood of not defaulting. These evaluation are provided by Credit Rating Agencies, i.e. S&P, Moody's.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'CrdRtg',
        Tag: 255,
        NotReqXML: 0,
        Name: 'CreditRating',
    },
    {
        Type: 'String',
        Description:
            "Underlying security's CreditRating.\nSee CreditRating (255) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'CrdRtg',
        Tag: 256,
        NotReqXML: 0,
        Name: 'UnderlyingCreditRating',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual leg security's CreditRating.\nSee CreditRating (255) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
        added: 'FIX.4.2',
        AbbrName: 'CrdRtg',
        Tag: 257,
        NotReqXML: 0,
        Name: 'LegCreditRating',
    },
    {
        Type: 'Boolean',
        Description:
            'Driver and part of trade in the event that the Security Master file was wrong at the point of entry(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'TrddFlatSwitch',
        Tag: 258,
        NotReqXML: 0,
        Name: 'TradedFlatSwitch',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'BasisFeatureDate allows requesting firms within fixed income the ability to request an alternative yield-to-worst, -maturity, -extended or other call. This flows through the confirm process.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'BasisFeatureDt',
        Tag: 259,
        NotReqXML: 0,
        Name: 'BasisFeatureDate',
    },
    {
        Type: 'Price',
        Description:
            'Price for BasisFeatureDate.\nSee BasisFeatureDate (259)\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
        added: 'FIX.4.2',
        AbbrName: 'BasisFeaturePx',
        Tag: 260,
        NotReqXML: 0,
        Name: 'BasisFeaturePrice',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for Market Data Request',
        added: 'FIX.4.2',
        AbbrName: 'ReqID',
        Tag: 262,
        NotReqXML: 0,
        Name: 'MDReqID',
    },
    {
        Type: 'char',
        Description: 'Subscription Request Type',
        added: 'FIX.4.2',
        AbbrName: 'SubReqTyp',
        Tag: 263,
        NotReqXML: 0,
        Name: 'SubscriptionRequestType',
    },
    {
        Type: 'int',
        Description:
            'Depth of market for Book Snapshot / Incremental updates\n0 - full book depth\n1 - top of book\n2 and above - book depth (number of levels)',
        added: 'FIX.4.2',
        AbbrName: 'MktDepth',
        Tag: 264,
        NotReqXML: 0,
        Name: 'MarketDepth',
    },
    {
        Type: 'int',
        Description: 'Specifies the type of Market Data update.',
        added: 'FIX.4.2',
        AbbrName: 'UpdtTyp',
        Tag: 265,
        NotReqXML: 0,
        Name: 'MDUpdateType',
    },
    {
        Type: 'Boolean',
        Description: 'Specifies whether or not book entries should be aggregated. (Not specified) = broker option',
        added: 'FIX.4.2',
        AbbrName: 'AggBook',
        Tag: 266,
        NotReqXML: 0,
        Name: 'AggregatedBook',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of MDEntryType (269) fields requested.',
        added: 'FIX.4.2',
        AbbrName: 'NoMDEntryTyps',
        Tag: 267,
        NotReqXML: 1,
        Name: 'NoMDEntryTypes',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of entries in Market Data message.',
        added: 'FIX.4.2',
        AbbrName: 'NoMDEntries',
        Tag: 268,
        NotReqXML: 1,
        Name: 'NoMDEntries',
    },
    {
        Type: 'char',
        Description: 'Type Market Data entry.',
        added: 'FIX.4.2',
        AbbrName: 'Typ',
        Tag: 269,
        NotReqXML: 0,
        Name: 'MDEntryType',
    },
    {
        Type: 'Price',
        Description: 'Price of the Market Data Entry.',
        added: 'FIX.4.2',
        AbbrName: 'Px',
        Tag: 270,
        NotReqXML: 0,
        Name: 'MDEntryPx',
    },
    {
        Type: 'Qty',
        Description: 'Quantity or volume represented by the Market Data Entry.',
        added: 'FIX.4.2',
        AbbrName: 'Sz',
        Tag: 271,
        NotReqXML: 0,
        Name: 'MDEntrySize',
    },
    {
        Type: 'UTCDateOnly',
        Description: 'Date of Market Data Entry.\n(prior to FIX 4.4 field was of type UTCDate)',
        added: 'FIX.4.2',
        AbbrName: 'Dt',
        Tag: 272,
        NotReqXML: 0,
        Name: 'MDEntryDate',
    },
    {
        Type: 'UTCTimeOnly',
        Description: 'Time of Market Data Entry.',
        added: 'FIX.4.2',
        AbbrName: 'Tm',
        Tag: 273,
        NotReqXML: 0,
        Name: 'MDEntryTime',
    },
    {
        Type: 'char',
        Description: 'Direction of the "tick".',
        added: 'FIX.4.2',
        AbbrName: 'TickDirctn',
        Tag: 274,
        NotReqXML: 0,
        Name: 'TickDirection',
    },
    {
        Type: 'Exchange',
        Description: 'Market posting quote / trade.\nValid values:\nSee "Appendix 6-C"',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        AbbrName: 'Mkt',
        Tag: 275,
        NotReqXML: 0,
        Name: 'MDMkt',
    },
    {
        Type: 'MultipleStringValue',
        Description: 'Space-delimited list of conditions describing a quote.',
        added: 'FIX.4.2',
        AbbrName: 'QCond',
        Tag: 276,
        NotReqXML: 0,
        Name: 'QuoteCondition',
    },
    {
        Type: 'MultipleStringValue',
        Description: 'Space-delimited list of conditions describing a trade',
        added: 'FIX.4.2',
        AbbrName: 'TrdCond',
        Tag: 277,
        NotReqXML: 0,
        Name: 'TradeCondition',
    },
    {
        Type: 'String',
        Description: 'Unique Market Data Entry identifier.',
        added: 'FIX.4.2',
        AbbrName: 'ID',
        Tag: 278,
        NotReqXML: 0,
        Name: 'MDEntryID',
    },
    {
        Type: 'char',
        Description: 'Type of Market Data update action.',
        added: 'FIX.4.2',
        AbbrName: 'UpdtAct',
        Tag: 279,
        NotReqXML: 0,
        Name: 'MDUpdateAction',
    },
    {
        Type: 'String',
        Description: 'Refers to a previous MDEntryID (278).',
        added: 'FIX.4.2',
        AbbrName: 'RefID',
        Tag: 280,
        NotReqXML: 0,
        Name: 'MDEntryRefID',
    },
    {
        Type: 'char',
        Description: 'Reason for the rejection of a Market Data request.',
        added: 'FIX.4.2',
        AbbrName: 'ReqRejResn',
        Tag: 281,
        NotReqXML: 0,
        Name: 'MDReqRejReason',
    },
    {
        Type: 'String',
        Description: 'Originator of a Market Data Entry',
        added: 'FIX.4.2',
        deprecated: 'FIX.5.0',
        AbbrName: 'Orig',
        Tag: 282,
        NotReqXML: 0,
        Name: 'MDEntryOriginator',
    },
    {
        Type: 'String',
        Description: "Identification of a Market Maker's location",
        added: 'FIX.4.2',
        AbbrName: 'LctnID',
        Tag: 283,
        NotReqXML: 0,
        Name: 'LocationID',
    },
    {
        Type: 'String',
        Description: "Identification of a Market Maker's desk",
        added: 'FIX.4.2',
        AbbrName: 'DeskID',
        Tag: 284,
        NotReqXML: 0,
        Name: 'DeskID',
    },
    {
        Type: 'char',
        Description: 'Reason for deletion.',
        added: 'FIX.4.2',
        AbbrName: 'DelRsn',
        Tag: 285,
        NotReqXML: 0,
        Name: 'DeleteReason',
    },
    {
        Type: 'MultipleCharValue',
        Description: 'Flag that identifies a market data entry. (Prior to FIX 4.3 this field was of type char)',
        added: 'FIX.4.2',
        AbbrName: 'OpenClsSettlFlag',
        Tag: 286,
        NotReqXML: 0,
        Name: 'OpenCloseSettlFlag',
    },
    {
        Type: 'int',
        Description: 'Specifies the number of days that may elapse before delivery of the security',
        added: 'FIX.4.2',
        AbbrName: 'SellerDays',
        Tag: 287,
        NotReqXML: 0,
        Name: 'SellerDays',
    },
    {
        Type: 'String',
        Description: 'Buying party in a trade',
        added: 'FIX.4.2',
        AbbrName: 'Buyer',
        Tag: 288,
        NotReqXML: 0,
        Name: 'MDEntryBuyer',
    },
    {
        Type: 'String',
        Description: 'Selling party in a trade',
        added: 'FIX.4.2',
        AbbrName: 'Seller',
        Tag: 289,
        NotReqXML: 0,
        Name: 'MDEntrySeller',
    },
    {
        Type: 'int',
        Description:
            'Display position of a bid or offer, numbered from most competitive to least competitive, per market side, beginning with .',
        added: 'FIX.4.2',
        AbbrName: 'PosNo',
        Tag: 290,
        NotReqXML: 0,
        Name: 'MDEntryPositionNo',
    },
    {
        Type: 'MultipleCharValue',
        Description: "Identifies a firm's or a security's financial status",
        added: 'FIX.4.2',
        AbbrName: 'FinclStat',
        Tag: 291,
        NotReqXML: 0,
        Name: 'FinancialStatus',
    },
    {
        Type: 'MultipleCharValue',
        Description: 'Identifies the type of Corporate Action.',
        added: 'FIX.4.2',
        AbbrName: 'CorpActn',
        Tag: 292,
        NotReqXML: 0,
        Name: 'CorporateAction',
    },
    {
        Type: 'Qty',
        Description: 'Default Bid Size.',
        added: 'FIX.4.2',
        AbbrName: 'DefBidSz',
        Tag: 293,
        NotReqXML: 0,
        Name: 'DefBidSize',
    },
    {
        Type: 'Qty',
        Description: 'Default Offer Size.',
        added: 'FIX.4.2',
        AbbrName: 'DefOfrSz',
        Tag: 294,
        NotReqXML: 0,
        Name: 'DefOfferSize',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of quote entries for a QuoteSet.',
        added: 'FIX.4.2',
        AbbrName: 'NoQuotEntries',
        Tag: 295,
        NotReqXML: 1,
        Name: 'NoQuoteEntries',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of sets of quotes in the message.',
        added: 'FIX.4.2',
        AbbrName: 'NoQuotSets',
        Tag: 296,
        NotReqXML: 1,
        Name: 'NoQuoteSets',
    },
    {
        Type: 'int',
        Description: 'Identifies the status of the quote acknowledgement.',
        added: 'FIX.4.2',
        AbbrName: 'Stat',
        Tag: 297,
        NotReqXML: 0,
        Name: 'QuoteStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Identifies the type of quote cancel.',
        added: 'FIX.4.2',
        updatedEP: 85,
        AbbrName: 'CxlTyp',
        Tag: 298,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'QuoteCancelType',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier for a quote. The QuoteEntryID stays with the quote as a static identifier even if the quote is updated.',
        added: 'FIX.4.2',
        AbbrName: 'EntryID',
        Tag: 299,
        NotReqXML: 0,
        Name: 'QuoteEntryID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason Quote was rejected:',
        added: 'FIX.4.2',
        AbbrName: 'RejRsn',
        Tag: 300,
        NotReqXML: 0,
        Name: 'QuoteRejectReason',
    },
    {
        Type: 'int',
        Description:
            'Level of Response requested from receiver of quote messages. A default value should be bilaterally agreed.',
        added: 'FIX.4.2',
        AbbrName: 'RspLvl',
        Tag: 301,
        NotReqXML: 0,
        Name: 'QuoteResponseLevel',
    },
    {
        Type: 'String',
        Description: 'Unique id for the Quote Set.',
        added: 'FIX.4.2',
        AbbrName: 'SetID',
        Tag: 302,
        NotReqXML: 0,
        Name: 'QuoteSetID',
    },
    {
        Type: 'int',
        Description: 'Indicates the type of Quote Request being generated',
        added: 'FIX.4.2',
        AbbrName: 'ReqTyp',
        Tag: 303,
        NotReqXML: 0,
        Name: 'QuoteRequestType',
    },
    {
        Type: 'int',
        Description: 'Total number of quotes for the quote set.',
        added: 'FIX.4.2',
        updatedEP: 95,
        AbbrName: 'TotNoQuotEntries',
        Tag: 304,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TotNoQuoteEntries',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description: "Underlying security's SecurityIDSource.\nValid values: see SecurityIDSource (22) field",
        added: 'FIX.4.2',
        AbbrName: 'Src',
        Tag: 305,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityIDSource',
    },
    {
        Type: 'String',
        Description: "Underlying security's Issuer.\nSee Issuer (06) field for description",
        added: 'FIX.4.2',
        AbbrName: 'Issr',
        Tag: 306,
        NotReqXML: 0,
        Name: 'UnderlyingIssuer',
    },
    {
        Type: 'String',
        Description: 'Description of the Underlying security.\nSee SecurityDesc(107).',
        added: 'FIX.4.2',
        updatedEP: 95,
        AbbrName: 'Desc',
        Tag: 307,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingSecurityDesc',
    },
    {
        Type: 'Exchange',
        Description:
            "Underlying security's SecurityExchange. Can be used to identify the underlying security.\nValid values: see SecurityExchange (207)",
        added: 'FIX.4.2',
        AbbrName: 'Exch',
        Tag: 308,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityExchange',
    },
    {
        Type: 'String',
        Description: "Underlying security's SecurityID.\nSee SecurityID (48) field for description",
        added: 'FIX.4.2',
        AbbrName: 'ID',
        Tag: 309,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityID',
    },
    {
        Type: 'String',
        EnumDatatype: 167,
        Description:
            "Underlying security's SecurityType.\nValid values: see SecurityType (167) field\n(see below for details concerning this fields use in conjunction with SecurityType=REPO)\nThe following applies when used in conjunction with SecurityType=REPO\nRepresents the general or specific type of security that underlies a financing agreement\nValid values for SecurityType=REPO:\nIf bonds of a particular issuer or country are wanted in an Order or are in the basket of an Execution and the SecurityType is not granular enough, include the UnderlyingIssuer (306), UnderlyingCountryOfIssue (592), UnderlyingProgram, UnderlyingRegType and/or < UnderlyingStipulations > block e.g.:",
        added: 'FIX.4.2',
        AbbrName: 'SecTyp',
        Tag: 310,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityType',
    },
    {
        Type: 'String',
        Description: "Underlying security's Symbol.\nSee Symbol (55) field for description",
        added: 'FIX.4.2',
        AbbrName: 'Sym',
        Tag: 311,
        NotReqXML: 0,
        Name: 'UnderlyingSymbol',
    },
    {
        Type: 'String',
        EnumDatatype: 65,
        Description: "Underlying security's SymbolSfx.\nSee SymbolSfx (65) field for description",
        added: 'FIX.4.2',
        AbbrName: 'Sfx',
        Tag: 312,
        NotReqXML: 0,
        Name: 'UnderlyingSymbolSfx',
    },
    {
        Type: 'MonthYear',
        Description:
            "Underlying security's MaturityMonthYear. Can be used with standardized derivatives vs. the UnderlyingMaturityDate (542) field.\nSee MaturityMonthYear (200) field for description",
        added: 'FIX.4.2',
        AbbrName: 'MMY',
        Tag: 313,
        NotReqXML: 0,
        Name: 'UnderlyingMaturityMonthYear',
    },
    {
        Type: 'int',
        Description: 'Put or call indicator of the underlying security.\nSee PutOrCall(201).',
        added: 'FIX.4.2',
        updatedEP: 76,
        AbbrName: 'PutCall',
        Tag: 315,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingPutOrCall',
    },
    {
        Type: 'Price',
        Description: "Underlying security's StrikePrice.\nSee StrikePrice (202) field for description",
        added: 'FIX.4.2',
        AbbrName: 'StrkPx',
        Tag: 316,
        NotReqXML: 0,
        Name: 'UnderlyingStrikePrice',
    },
    {
        Type: 'char',
        Description: "Underlying security's OptAttribute.\nSee OptAttribute (206) field for description",
        added: 'FIX.4.2',
        AbbrName: 'OptA',
        Tag: 317,
        NotReqXML: 0,
        Name: 'UnderlyingOptAttribute',
    },
    {
        Type: 'Currency',
        Description: "Underlying security's Currency.\nSee Currency (5) field for description and valid values",
        added: 'FIX.4.2',
        AbbrName: 'Ccy',
        Tag: 318,
        NotReqXML: 0,
        Name: 'UnderlyingCurrency',
    },
    {
        Type: 'String',
        Description: 'Unique ID of a Security Definition Request.',
        added: 'FIX.4.2',
        AbbrName: 'ReqID',
        Tag: 320,
        NotReqXML: 0,
        Name: 'SecurityReqID',
    },
    {
        Type: 'int',
        Description: 'Type of Security Definition Request.',
        added: 'FIX.4.2',
        AbbrName: 'ReqTyp',
        Tag: 321,
        NotReqXML: 0,
        Name: 'SecurityRequestType',
    },
    {
        Type: 'String',
        Description: 'Unique ID of a Security Definition message.',
        added: 'FIX.4.2',
        AbbrName: 'RspID',
        Tag: 322,
        NotReqXML: 0,
        Name: 'SecurityResponseID',
    },
    {
        Type: 'int',
        Description: 'Type of Security Definition message response.',
        added: 'FIX.4.2',
        AbbrName: 'RspTyp',
        Tag: 323,
        NotReqXML: 0,
        Name: 'SecurityResponseType',
    },
    {
        Type: 'String',
        Description: 'Unique ID of a Security Status Request message.',
        added: 'FIX.4.2',
        AbbrName: 'StatReqID',
        Tag: 324,
        NotReqXML: 0,
        Name: 'SecurityStatusReqID',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not message is being sent as a result of a subscription request or not.',
        added: 'FIX.4.2',
        AbbrName: 'Unsol',
        Tag: 325,
        NotReqXML: 0,
        Name: 'UnsolicitedIndicator',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Identifies the trading status applicable to the transaction.',
        added: 'FIX.4.2',
        AbbrName: 'TrdgStat',
        Tag: 326,
        NotReqXML: 0,
        Name: 'SecurityTradingStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Denotes the reason for the Opening Delay or Trading Halt.',
        added: 'FIX.4.2',
        updatedEP: 86,
        AbbrName: 'HaltRsn',
        Tag: 327,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'HaltReason',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not the halt was due to Common Stock trading being halted.',
        added: 'FIX.4.2',
        AbbrName: 'InViewOfCmn',
        Tag: 328,
        NotReqXML: 0,
        Name: 'InViewOfCommon',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not the halt was due to the Related Security being halted.',
        added: 'FIX.4.2',
        AbbrName: 'DueToReltd',
        Tag: 329,
        NotReqXML: 0,
        Name: 'DueToRelated',
    },
    {
        Type: 'Qty',
        Description: 'Quantity bought.',
        added: 'FIX.4.2',
        AbbrName: 'BuyVol',
        Tag: 330,
        NotReqXML: 0,
        Name: 'BuyVolume',
    },
    {
        Type: 'Qty',
        Description: 'Quantity sold.',
        added: 'FIX.4.2',
        AbbrName: 'SellVol',
        Tag: 331,
        NotReqXML: 0,
        Name: 'SellVolume',
    },
    {
        Type: 'Price',
        Description:
            'Represents an indication of the high end of the price range for a security prior to the open or reopen',
        added: 'FIX.4.2',
        AbbrName: 'HighPx',
        Tag: 332,
        NotReqXML: 0,
        Name: 'HighPx',
    },
    {
        Type: 'Price',
        Description:
            'Represents an indication of the low end of the price range for a security prior to the open or reopen',
        added: 'FIX.4.2',
        AbbrName: 'LowPx',
        Tag: 333,
        NotReqXML: 0,
        Name: 'LowPx',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of adjustment.',
        added: 'FIX.4.2',
        AbbrName: 'Adjmt',
        Tag: 334,
        NotReqXML: 0,
        Name: 'Adjustment',
    },
    {
        Type: 'String',
        Description: 'Unique ID of a Trading Session Status message.',
        added: 'FIX.4.2',
        AbbrName: 'ReqID',
        Tag: 335,
        NotReqXML: 0,
        Name: 'TradSesReqID',
    },
    {
        Type: 'String',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Identifier for Trading Session\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\nTo specify good for session where session spans more than one calendar day, use TimeInForce = Day in conjunction with TradingSessionID.\nBilaterally agreed values of data type "String" that start with a character can be used for backward compatibility.',
        added: 'FIX.4.2',
        AbbrName: 'SesID',
        Tag: 336,
        NotReqXML: 0,
        Name: 'TradingSessionID',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description: 'Identifies the trader (e.g. "badge number") of the ContraBroker.',
        added: 'FIX.4.2',
        BaseCategoryAbbrName: 'Trdr',
        AbbrName: 'CntraTrdr',
        Tag: 337,
        NotReqXML: 0,
        Name: 'ContraTrader',
    },
    {
        Type: 'int',
        Description: 'Method of trading',
        added: 'FIX.4.2',
        AbbrName: 'Method',
        Tag: 338,
        NotReqXML: 0,
        Name: 'TradSesMethod',
    },
    {
        Type: 'int',
        Description: 'Trading Session Mode',
        added: 'FIX.4.2',
        AbbrName: 'Mode',
        Tag: 339,
        NotReqXML: 0,
        Name: 'TradSesMode',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'State of the trading session.',
        added: 'FIX.4.2',
        AbbrName: 'Stat',
        Tag: 340,
        NotReqXML: 0,
        Name: 'TradSesStatus',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Starting time of the trading session',
        added: 'FIX.4.2',
        AbbrName: 'StartTm',
        Tag: 341,
        NotReqXML: 0,
        Name: 'TradSesStartTime',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Time of the opening of the trading session',
        added: 'FIX.4.2',
        AbbrName: 'OpenTm',
        Tag: 342,
        NotReqXML: 0,
        Name: 'TradSesOpenTime',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Time of the pre-closed of the trading session',
        added: 'FIX.4.2',
        AbbrName: 'PreClsTm',
        Tag: 343,
        NotReqXML: 0,
        Name: 'TradSesPreCloseTime',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Closing time of the trading session',
        added: 'FIX.4.2',
        AbbrName: 'ClsTm',
        Tag: 344,
        NotReqXML: 0,
        Name: 'TradSesCloseTime',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'End time of the trading session',
        added: 'FIX.4.2',
        AbbrName: 'EndTm',
        Tag: 345,
        NotReqXML: 0,
        Name: 'TradSesEndTime',
    },
    {
        Type: 'int',
        Description: 'Number of orders in the market.',
        added: 'FIX.4.2',
        AbbrName: 'NumOfOrds',
        Tag: 346,
        NotReqXML: 0,
        Name: 'NumberOfOrders',
    },
    {
        Type: 'String',
        Description:
            'Type of message encoding (non-ASCII (non-English) characters) used in a message\'s "Encoded" fields.',
        added: 'FIX.4.2',
        AbbrName: 'MsgEncd',
        Tag: 347,
        NotReqXML: 0,
        Name: 'MessageEncoding',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedIssuer (349) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 349,
        AbbrName: 'EncIssrLen',
        Tag: 348,
        NotReqXML: 0,
        Name: 'EncodedIssuerLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the Issuer field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Issuer field.',
        added: 'FIX.4.2',
        AbbrName: 'EncIssr',
        Tag: 349,
        NotReqXML: 0,
        Name: 'EncodedIssuer',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedSecurityDesc (351) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 351,
        AbbrName: 'EncSecDescLen',
        Tag: 350,
        NotReqXML: 0,
        Name: 'EncodedSecurityDescLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the SecurityDesc (107) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityDesc field.',
        added: 'FIX.4.2',
        AbbrName: 'EncSecDesc',
        Tag: 351,
        NotReqXML: 0,
        Name: 'EncodedSecurityDesc',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedListExecInst (353) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 353,
        AbbrName: 'EncListExecInstLen',
        Tag: 352,
        NotReqXML: 0,
        Name: 'EncodedListExecInstLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the ListExecInst (69) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListExecInst field.',
        added: 'FIX.4.2',
        AbbrName: 'EncListExecInst',
        Tag: 353,
        NotReqXML: 0,
        Name: 'EncodedListExecInst',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedText (355) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 355,
        AbbrName: 'EncTxtLen',
        Tag: 354,
        NotReqXML: 0,
        Name: 'EncodedTextLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the Text (58) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Text field.',
        added: 'FIX.4.2',
        AbbrName: 'EncTxt',
        Tag: 355,
        NotReqXML: 0,
        Name: 'EncodedText',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedSubject (357) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 357,
        AbbrName: 'EncSubjectLen',
        Tag: 356,
        NotReqXML: 0,
        Name: 'EncodedSubjectLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the Subject (147) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Subject field.',
        added: 'FIX.4.2',
        AbbrName: 'EncSubject',
        Tag: 357,
        NotReqXML: 0,
        Name: 'EncodedSubject',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedHeadline (359) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 359,
        AbbrName: 'EncHeadlineLen',
        Tag: 358,
        NotReqXML: 0,
        Name: 'EncodedHeadlineLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the Headline (148) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Headline field.',
        added: 'FIX.4.2',
        AbbrName: 'EncHeadline',
        Tag: 359,
        NotReqXML: 0,
        Name: 'EncodedHeadline',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedAllocText (361) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 361,
        AbbrName: 'EncAllocTextLen',
        Tag: 360,
        NotReqXML: 0,
        Name: 'EncodedAllocTextLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the AllocText (161) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AllocText field.',
        added: 'FIX.4.2',
        AbbrName: 'EncAllocText',
        Tag: 361,
        NotReqXML: 0,
        Name: 'EncodedAllocText',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingIssuer (363) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 363,
        AbbrName: 'EncUndIssrLen',
        Tag: 362,
        NotReqXML: 0,
        Name: 'EncodedUnderlyingIssuerLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the UnderlyingIssuer (306) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingIssuer field.',
        added: 'FIX.4.2',
        AbbrName: 'EncUndIssr',
        Tag: 363,
        NotReqXML: 0,
        Name: 'EncodedUnderlyingIssuer',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingSecurityDesc (365) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 365,
        AbbrName: 'EncUndSecDescLen',
        Tag: 364,
        NotReqXML: 0,
        Name: 'EncodedUnderlyingSecurityDescLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the UnderlyingSecurityDesc (307) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingSecurityeDesc field.',
        added: 'FIX.4.2',
        AbbrName: 'EncUndSecDesc',
        Tag: 365,
        NotReqXML: 0,
        Name: 'EncodedUnderlyingSecurityDesc',
    },
    {
        Type: 'Price',
        Description:
            'Executed price for an AllocAccount (79) entry used when using "executed price" vs. "average price" allocations (e.g. Japan).',
        added: 'FIX.4.2',
        AbbrName: 'Px',
        Tag: 366,
        NotReqXML: 0,
        Name: 'AllocPrice',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Indicates expiration time of this particular QuoteSet (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
        added: 'FIX.4.2',
        AbbrName: 'ValidTil',
        Tag: 367,
        NotReqXML: 0,
        Name: 'QuoteSetValidUntilTime',
    },
    {
        Type: 'int',
        EnumDatatype: 300,
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason Quote Entry was rejected:',
        added: 'FIX.4.2',
        AbbrName: 'EntryRejRsn',
        Tag: 368,
        NotReqXML: 0,
        Name: 'QuoteEntryRejectReason',
    },
    {
        Type: 'SeqNum',
        Description:
            'The last MsgSeqNum (34) value received by the FIX engine and processed by downstream application, such as trading engine or order routing system. Can be specified on every message sent. Useful for detecting a backlog with a counterparty.',
        added: 'FIX.4.2',
        AbbrName: 'LastMsgSeqNumProced',
        Tag: 369,
        NotReqXML: 1,
        Name: 'LastMsgSeqNumProcessed',
    },
    {
        Type: 'int',
        Description: 'The tag number of the FIX field being referenced.',
        added: 'FIX.4.2',
        AbbrName: 'RefTagID',
        Tag: 371,
        NotReqXML: 0,
        Name: 'RefTagID',
    },
    {
        Type: 'String',
        EnumDatatype: 35,
        Description: 'The MsgType (35) of the FIX message being referenced.',
        added: 'FIX.4.2',
        AbbrName: 'RefMsgTyp',
        Tag: 372,
        NotReqXML: 0,
        Name: 'RefMsgType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Code to identify reason for a session-level Reject message.',
        added: 'FIX.4.2',
        AbbrName: 'SessRejRsn',
        Tag: 373,
        NotReqXML: 1,
        Name: 'SessionRejectReason',
    },
    {
        Type: 'char',
        Description: 'Identifies the Bid Request message type.',
        added: 'FIX.4.2',
        AbbrName: 'BidReqTransTyp',
        Tag: 374,
        NotReqXML: 0,
        Name: 'BidRequestTransType',
    },
    {
        Type: 'String',
        Description: 'Identifies contra broker. Standard NASD market-maker mnemonic is preferred.',
        added: 'FIX.4.2',
        AbbrName: 'CntraBrkr',
        Tag: 375,
        NotReqXML: 0,
        Name: 'ContraBroker',
    },
    {
        Type: 'String',
        Description: 'ID used to represent this transaction for compliance purposes (e.g. OATS reporting).',
        added: 'FIX.4.2',
        AbbrName: 'ComplianceID',
        Tag: 376,
        NotReqXML: 0,
        Name: 'ComplianceID',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not the order was solicited.',
        added: 'FIX.4.2',
        AbbrName: 'SolFlag',
        Tag: 377,
        NotReqXML: 0,
        Name: 'SolicitedFlag',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Code to identify reason for an ExecutionRpt message sent with ExecType=Restated or used when communicating an unsolicited cancel.',
        added: 'FIX.4.2',
        AbbrName: 'ExecRstmtRsn',
        Tag: 378,
        NotReqXML: 0,
        Name: 'ExecRestatementReason',
    },
    {
        Type: 'String',
        Description: 'The value of the business-level "ID" field on the message being referenced.',
        added: 'FIX.4.2',
        AbbrName: 'BizRejRefID',
        Tag: 379,
        NotReqXML: 0,
        Name: 'BusinessRejectRefID',
    },
    {
        Type: 'int',
        Description: 'Code to identify reason for a Business Message Reject message.',
        added: 'FIX.4.2',
        AbbrName: 'BizRejRsn',
        Tag: 380,
        NotReqXML: 0,
        Name: 'BusinessRejectReason',
    },
    {
        Type: 'Amt',
        Description:
            'Total amount traded (i.e. quantity * price) expressed in units of currency. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size).',
        added: 'FIX.4.2',
        updatedEP: 95,
        AbbrName: 'GrossTrdAmt',
        Tag: 381,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'GrossTradeAmt',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of ContraBroker (375) entries.',
        added: 'FIX.4.2',
        AbbrName: 'NoCntraBrkrs',
        Tag: 382,
        NotReqXML: 1,
        Name: 'NoContraBrokers',
    },
    {
        Type: 'Length',
        Description: 'Maximum number of bytes supported for a single message.',
        added: 'FIX.4.2',
        AbbrName: 'MaxMsgSz',
        Tag: 383,
        NotReqXML: 1,
        Name: 'MaxMessageSize',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of MsgTypes (35) in repeating group.',
        added: 'FIX.4.2',
        AbbrName: 'NoMsgTyps',
        Tag: 384,
        NotReqXML: 1,
        Name: 'NoMsgTypes',
    },
    {
        Type: 'char',
        Description: 'Specifies the direction of the messsage.',
        added: 'FIX.4.2',
        AbbrName: 'MsgDirctn',
        Tag: 385,
        NotReqXML: 1,
        Name: 'MsgDirection',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of TradingSessionIDs (336) in repeating group.',
        added: 'FIX.4.2',
        AbbrName: 'NoTrdgSesss',
        Tag: 386,
        NotReqXML: 1,
        Name: 'NoTradingSessions',
    },
    {
        Type: 'Qty',
        Description: 'Total volume (quantity) traded.',
        added: 'FIX.4.2',
        AbbrName: 'TotVolTrdd',
        Tag: 387,
        NotReqXML: 0,
        Name: 'TotalVolumeTraded',
    },
    {
        Type: 'char',
        Description:
            'Code to identify the price a DiscretionOffsetValue (389) is related to and should be mathematically added to.',
        added: 'FIX.4.2',
        AbbrName: 'DsctnInst',
        Tag: 388,
        NotReqXML: 0,
        Name: 'DiscretionInst',
    },
    {
        Type: 'float',
        Description:
            'Amount (signed) added to the "related to" price specified via DiscretionInst (388), in the context of DiscretionOffsetType (842)\n(Prior to FIX 4.4 this field was of type PriceOffset)',
        added: 'FIX.4.2',
        AbbrName: 'OfstValu',
        Tag: 389,
        NotReqXML: 0,
        Name: 'DiscretionOffsetValue',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier for Bid Response as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day.',
        added: 'FIX.4.2',
        AbbrName: 'BidID',
        Tag: 390,
        NotReqXML: 0,
        Name: 'BidID',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day.',
        added: 'FIX.4.2',
        AbbrName: 'ClBidID',
        Tag: 391,
        NotReqXML: 0,
        Name: 'ClientBidID',
    },
    {
        Type: 'String',
        Description: 'Descriptive name for list order.',
        added: 'FIX.4.2',
        AbbrName: 'ListName',
        Tag: 392,
        NotReqXML: 0,
        Name: 'ListName',
    },
    {
        Type: 'int',
        Description: 'Total number of securities.\n(Prior to FIX 4.4 this field was named TotalNumSecurities)',
        added: 'FIX.4.2',
        AbbrName: 'TotNoReltdSym',
        Tag: 393,
        NotReqXML: 0,
        Name: 'TotNoRelatedSym',
    },
    {
        Type: 'int',
        Description: 'Code to identify the type of Bid Request.',
        added: 'FIX.4.2',
        AbbrName: 'BidTyp',
        Tag: 394,
        NotReqXML: 0,
        Name: 'BidType',
    },
    {
        Type: 'int',
        Description: 'Total number of tickets.',
        added: 'FIX.4.2',
        AbbrName: 'NumTkts',
        Tag: 395,
        NotReqXML: 0,
        Name: 'NumTickets',
    },
    {
        Type: 'Amt',
        Description: 'Amounts in currency',
        added: 'FIX.4.2',
        AbbrName: 'SideValu1',
        Tag: 396,
        NotReqXML: 0,
        Name: 'SideValue1',
    },
    {
        Type: 'Amt',
        Description: 'Amounts in currency',
        added: 'FIX.4.2',
        AbbrName: 'SideValu2',
        Tag: 397,
        NotReqXML: 0,
        Name: 'SideValue2',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of BidDescriptor (400) entries.',
        added: 'FIX.4.2',
        AbbrName: 'NoBidDescptrs',
        Tag: 398,
        NotReqXML: 1,
        Name: 'NoBidDescriptors',
    },
    {
        Type: 'int',
        Description: 'Code to identify the type of BidDescriptor (400).',
        added: 'FIX.4.2',
        AbbrName: 'BidDescptrTyp',
        Tag: 399,
        NotReqXML: 0,
        Name: 'BidDescriptorType',
    },
    {
        Type: 'String',
        Description:
            'BidDescriptor value. Usage depends upon BidDescriptorTyp (399).\nIf BidDescriptorType = 1\nIndustrials etc - Free text\nIf BidDescriptorType = 2\n"FR" etc - ISO Country Codes\nIf BidDescriptorType = 3\nFT00, FT250, STOX - Free text',
        added: 'FIX.4.2',
        AbbrName: 'BidDescptr',
        Tag: 400,
        NotReqXML: 0,
        Name: 'BidDescriptor',
    },
    {
        Type: 'int',
        Description:
            'Code to identify which "SideValue" the value refers to. SideValue1 and SideValue2 are used as opposed to Buy or Sell so that the basket can be quoted either way as Buy or Sell.',
        added: 'FIX.4.2',
        AbbrName: 'SideValuInd',
        Tag: 401,
        NotReqXML: 0,
        Name: 'SideValueInd',
    },
    {
        Type: 'Percentage',
        Description: 'Liquidity indicator or lower limit if TotalNumSecurities (393) > 1. Represented as a percentage.',
        added: 'FIX.4.2',
        AbbrName: 'LqdtyPctLow',
        Tag: 402,
        NotReqXML: 0,
        Name: 'LiquidityPctLow',
    },
    {
        Type: 'Percentage',
        Description: 'Upper liquidity indicator if TotalNumSecurities (393) > 1. Represented as a percentage.',
        added: 'FIX.4.2',
        AbbrName: 'LqdtyPctHigh',
        Tag: 403,
        NotReqXML: 0,
        Name: 'LiquidityPctHigh',
    },
    {
        Type: 'Amt',
        Description: 'Value between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency',
        added: 'FIX.4.2',
        AbbrName: 'LqdtyValu',
        Tag: 404,
        NotReqXML: 0,
        Name: 'LiquidityValue',
    },
    {
        Type: 'Percentage',
        Description: 'Eg Used in EFP trades 2% (EFP - Exchange for Physical ). Represented as a percentage.',
        added: 'FIX.4.2',
        AbbrName: 'EFPTrkngErr',
        Tag: 405,
        NotReqXML: 0,
        Name: 'EFPTrackingError',
    },
    {
        Type: 'Amt',
        Description: 'Used in EFP trades',
        added: 'FIX.4.2',
        AbbrName: 'FairValu',
        Tag: 406,
        NotReqXML: 0,
        Name: 'FairValue',
    },
    {
        Type: 'Percentage',
        Description: 'Used in EFP trades. Represented as a percentage.',
        added: 'FIX.4.2',
        AbbrName: 'OutsideNdxPct',
        Tag: 407,
        NotReqXML: 0,
        Name: 'OutsideIndexPct',
    },
    {
        Type: 'Amt',
        Description: 'Used in EFP trades',
        added: 'FIX.4.2',
        AbbrName: 'ValuOfFuts',
        Tag: 408,
        NotReqXML: 0,
        Name: 'ValueOfFutures',
    },
    {
        Type: 'int',
        Description: 'Code to identify the type of liquidity indicator.',
        added: 'FIX.4.2',
        AbbrName: 'LqdtyIndTyp',
        Tag: 409,
        NotReqXML: 0,
        Name: 'LiquidityIndType',
    },
    {
        Type: 'Percentage',
        Description:
            'Overall weighted average liquidity expressed as a % of average daily volume. Represented as a percentage.',
        added: 'FIX.4.2',
        AbbrName: 'WtAvgLqdty',
        Tag: 410,
        NotReqXML: 0,
        Name: 'WtAverageLiquidity',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not to exchange for phsyical.',
        added: 'FIX.4.2',
        AbbrName: 'EFP',
        Tag: 411,
        NotReqXML: 0,
        Name: 'ExchangeForPhysical',
    },
    {
        Type: 'Amt',
        Description: 'Value of stocks in Currency',
        added: 'FIX.4.2',
        AbbrName: 'OutMainCntryUNdx',
        Tag: 412,
        NotReqXML: 0,
        Name: 'OutMainCntryUIndex',
    },
    {
        BaseCategory: 'CrossOrders',
        Type: 'Percentage',
        Description: 'Percentage of program that crosses in Currency. Represented as a percentage.',
        added: 'FIX.4.2',
        BaseCategoryAbbrName: 'Pct',
        AbbrName: 'CrssPct',
        Tag: 413,
        NotReqXML: 0,
        Name: 'CrossPercent',
    },
    {
        Type: 'int',
        Description: 'Code to identify the desired frequency of progress reports.',
        added: 'FIX.4.2',
        AbbrName: 'ProgRptReqs',
        Tag: 414,
        NotReqXML: 0,
        Name: 'ProgRptReqs',
    },
    {
        Type: 'int',
        Description: "Time in minutes between each ListStatus report sent by SellSide. Zero means don't send status.",
        added: 'FIX.4.2',
        AbbrName: 'ProgPeriodIntvl',
        Tag: 415,
        NotReqXML: 0,
        Name: 'ProgPeriodInterval',
    },
    {
        Type: 'int',
        Description: 'Code to represent whether value is net (inclusive of tax) or gross.',
        added: 'FIX.4.2',
        AbbrName: 'IncTaxInd',
        Tag: 416,
        NotReqXML: 0,
        Name: 'IncTaxInd',
    },
    {
        Type: 'int',
        Description: 'Indicates the total number of bidders on the list',
        added: 'FIX.4.2',
        AbbrName: 'NumBidders',
        Tag: 417,
        NotReqXML: 0,
        Name: 'NumBidders',
    },
    {
        Type: 'char',
        Description: 'Code to represent the type of trade.\n(Prior to FIX 4.4 this field was named "TradeType")',
        added: 'FIX.4.2',
        AbbrName: 'BidTrdTyp',
        Tag: 418,
        NotReqXML: 0,
        Name: 'BidTradeType',
    },
    {
        Type: 'char',
        Description: 'Code to represent the basis price type.',
        added: 'FIX.4.2',
        AbbrName: 'BasisPxTyp',
        Tag: 419,
        NotReqXML: 0,
        Name: 'BasisPxType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Indicates the number of list entries.',
        added: 'FIX.4.2',
        AbbrName: 'NoBidComponents',
        Tag: 420,
        NotReqXML: 1,
        Name: 'NoBidComponents',
    },
    {
        Type: 'Country',
        Description: 'ISO Country Code in field',
        added: 'FIX.4.2',
        AbbrName: 'Ctry',
        Tag: 421,
        NotReqXML: 0,
        Name: 'Country',
    },
    {
        Type: 'int',
        Description:
            'Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation.',
        added: 'FIX.4.2',
        AbbrName: 'TotNoStrks',
        Tag: 422,
        NotReqXML: 0,
        Name: 'TotNoStrikes',
    },
    {
        Type: 'int',
        Description:
            'Code to represent the price type.\n(For Financing transactions PriceType implies the "repo type" - Fixed or Floating - 9 (Yield) or 6 (Spread) respectively - and Price (44) gives the corresponding "repo rate".\nSee Volume : "Glossary" for further value definitions)',
        added: 'FIX.4.2',
        AbbrName: 'PxTyp',
        Tag: 423,
        NotReqXML: 0,
        Name: 'PriceType',
    },
    {
        Type: 'Qty',
        Description:
            'For GT orders, the OrderQty (38) less all quantity (adjusted for stock splits) that traded on previous days. DayOrderQty (424) = OrderQty - (CumQty (14) - DayCumQty (425))',
        added: 'FIX.4.2',
        AbbrName: 'DayOrdQty',
        Tag: 424,
        NotReqXML: 0,
        Name: 'DayOrderQty',
    },
    {
        Type: 'Qty',
        Description: 'Quantity on a GT order that has traded today.',
        added: 'FIX.4.2',
        AbbrName: 'DayCumQty',
        Tag: 425,
        NotReqXML: 0,
        Name: 'DayCumQty',
    },
    {
        Type: 'Price',
        Description: 'The average price for quantity on a GT order that has traded today.',
        added: 'FIX.4.2',
        AbbrName: 'DayAvgPx',
        Tag: 426,
        NotReqXML: 0,
        Name: 'DayAvgPx',
    },
    {
        Type: 'int',
        Description:
            'Code to identify whether to book out executions on a part-filled GT order on the day of execution or to accumulate.',
        added: 'FIX.4.2',
        AbbrName: 'GTBkngInst',
        Tag: 427,
        NotReqXML: 0,
        Name: 'GTBookingInst',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of list strike price entries.',
        added: 'FIX.4.2',
        AbbrName: 'NoStrks',
        Tag: 428,
        NotReqXML: 1,
        Name: 'NoStrikes',
    },
    {
        Type: 'int',
        Description: 'Code to represent the status type.',
        added: 'FIX.4.2',
        AbbrName: 'ListStatTyp',
        Tag: 429,
        NotReqXML: 0,
        Name: 'ListStatusType',
    },
    {
        Type: 'int',
        Description: 'Code to represent whether value is net (inclusive of tax) or gross.',
        added: 'FIX.4.2',
        AbbrName: 'NetGrossInd',
        Tag: 430,
        NotReqXML: 0,
        Name: 'NetGrossInd',
    },
    {
        Type: 'int',
        Description: 'Code to represent the status of a list order.',
        added: 'FIX.4.2',
        AbbrName: 'ListOrdStat',
        Tag: 431,
        NotReqXML: 0,
        Name: 'ListOrderStatus',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Date of order expiration (last day the order can trade), always expressed in terms of the local market date. The time at which the order expires is determined by the local market's business practices",
        added: 'FIX.4.2',
        AbbrName: 'ExpireDt',
        Tag: 432,
        NotReqXML: 0,
        Name: 'ExpireDate',
    },
    {
        Type: 'char',
        Description: 'Identifies the type of ListExecInst (69).',
        added: 'FIX.4.2',
        AbbrName: 'ListExecInstTyp',
        Tag: 433,
        NotReqXML: 0,
        Name: 'ListExecInstType',
    },
    {
        Type: 'char',
        Description: 'Identifies the type of request that a Cancel Reject is in response to.',
        added: 'FIX.4.2',
        AbbrName: 'CxlRejRspTo',
        Tag: 434,
        NotReqXML: 0,
        Name: 'CxlRejResponseTo',
    },
    {
        Type: 'Percentage',
        Description: "Underlying security's CouponRate.\nSee CouponRate (223) field for description",
        added: 'FIX.4.2',
        AbbrName: 'CpnRt',
        Tag: 435,
        NotReqXML: 0,
        Name: 'UnderlyingCouponRate',
    },
    {
        Type: 'float',
        Description: "Underlying security's ContractMultiplier.\nSee ContractMultiplier (231) field for description",
        added: 'FIX.4.2',
        AbbrName: 'Mult',
        Tag: 436,
        NotReqXML: 0,
        Name: 'UnderlyingContractMultiplier',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'Qty',
        Description: 'Quantity traded with the ContraBroker (375).',
        added: 'FIX.4.2',
        BaseCategoryAbbrName: 'TrdQty',
        AbbrName: 'CntraTrdQty',
        Tag: 437,
        NotReqXML: 0,
        Name: 'ContraTradeQty',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'UTCTimestamp',
        Description:
            'Identifes the time of the trade with the ContraBroker (375). (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
        added: 'FIX.4.2',
        BaseCategoryAbbrName: 'TrdTm',
        AbbrName: 'CntraTrdTm',
        Tag: 438,
        NotReqXML: 0,
        Name: 'ContraTradeTime',
    },
    {
        Type: 'int',
        Description: 'Number of Securites between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency.',
        added: 'FIX.4.2',
        AbbrName: 'LqdtyNumSecurities',
        Tag: 441,
        NotReqXML: 0,
        Name: 'LiquidityNumSecurities',
    },
    {
        Type: 'char',
        Description:
            'Used to indicate what an Execution Report represents (e.g. used with multi-leg securities, such as option strategies, spreads, etc.).',
        added: 'FIX.4.2',
        AbbrName: 'MLegRptTyp',
        Tag: 442,
        NotReqXML: 0,
        Name: 'MultiLegReportingType',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'The time at which current market prices are used to determine the value of a basket.',
        added: 'FIX.4.2',
        AbbrName: 'StrkTm',
        Tag: 443,
        NotReqXML: 0,
        Name: 'StrikeTime',
    },
    {
        Type: 'String',
        Description: 'Free format text string related to List Status.',
        added: 'FIX.4.2',
        AbbrName: 'ListStatText',
        Tag: 444,
        NotReqXML: 0,
        Name: 'ListStatusText',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedListStatusText (446) field.',
        added: 'FIX.4.2',
        AssociatedDataTag: 446,
        AbbrName: 'EncListStatTextLen',
        Tag: 445,
        NotReqXML: 0,
        Name: 'EncodedListStatusTextLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the ListStatusText (444) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListStatusText field.',
        added: 'FIX.4.2',
        AbbrName: 'EncListStatText',
        Tag: 446,
        NotReqXML: 0,
        Name: 'EncodedListStatusText',
    },
    {
        Type: 'char',
        Description:
            'Identifies class or source of the PartyID (448) value. Required if PartyID is specified. Note: applicable values depend upon PartyRole (452) specified.\nSee "Appendix 6-G - Use of <Parties> Component Block"',
        added: 'FIX.4.3',
        AbbrName: 'Src',
        Tag: 447,
        NotReqXML: 0,
        Name: 'PartyIDSource',
    },
    {
        Type: 'String',
        Description:
            'Party identifier/code. See PartyIDSource (447) and PartyRole (452).\nSee "Appendix 6-G - Use of <Parties> Component Block"',
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 448,
        NotReqXML: 0,
        Name: 'PartyID',
    },
    {
        Type: 'PriceOffset',
        Description: "Net change from previous day's closing price vs. last traded price.",
        added: 'FIX.4.3',
        AbbrName: 'NetChgPrevDay',
        Tag: 451,
        NotReqXML: 0,
        Name: 'NetChgPrevDay',
    },
    {
        Type: 'int',
        Description:
            'Identifies the type or role of the PartyID (448) specified.\nSee "Appendix 6-G - Use of <Parties> Component Block"\n(see Volume : "Glossary" for value definitions)',
        added: 'FIX.4.3',
        AbbrName: 'R',
        Tag: 452,
        NotReqXML: 0,
        Name: 'PartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of PartyID (448), PartyIDSource (447), and PartyRole (452) entries',
        added: 'FIX.4.3',
        AbbrName: 'NoPtyIDs',
        Tag: 453,
        NotReqXML: 1,
        Name: 'NoPartyIDs',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of SecurityAltID (455) entries.',
        added: 'FIX.4.3',
        AbbrName: 'NoSecAltID',
        Tag: 454,
        NotReqXML: 1,
        Name: 'NoSecurityAltID',
    },
    {
        Type: 'String',
        Description:
            'Alternate Security identifier value for this security of SecurityAltIDSource (456) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityAltIDSource.',
        added: 'FIX.4.3',
        AbbrName: 'AltID',
        Tag: 455,
        NotReqXML: 0,
        Name: 'SecurityAltID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            'Identifies class or source of the SecurityAltID (455) value. Required if SecurityAltID is specified.\nValid values:\nSame valid values as the SecurityIDSource (22) field',
        added: 'FIX.4.3',
        AbbrName: 'AltIDSrc',
        Tag: 456,
        NotReqXML: 0,
        Name: 'SecurityAltIDSource',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of UnderlyingSecurityAltID (458) entries.',
        added: 'FIX.4.3',
        AbbrName: 'NoUndSecAltID',
        Tag: 457,
        NotReqXML: 1,
        Name: 'NoUnderlyingSecurityAltID',
    },
    {
        Type: 'String',
        Description:
            'Alternate Security identifier value for this underlying security of UnderlyingSecurityAltIDSource (459) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires UnderlyingSecurityAltIDSource.',
        added: 'FIX.4.3',
        AbbrName: 'AltID',
        Tag: 458,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityAltID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            'Identifies class or source of the UnderlyingSecurityAltID (458) value. Required if UnderlyingSecurityAltID is specified.\nValid values:\nSame valid values as the SecurityIDSource (22) field',
        added: 'FIX.4.3',
        AbbrName: 'AltIDSrc',
        Tag: 459,
        NotReqXML: 0,
        Name: 'UnderlyingSecurityAltIDSource',
    },
    {
        Type: 'int',
        Description:
            'Indicates the type of product the security is associated with. See also the CFICode (461) and SecurityType (167) fields.',
        added: 'FIX.4.3',
        AbbrName: 'Prod',
        Tag: 460,
        NotReqXML: 0,
        Name: 'Product',
    },
    {
        Type: 'String',
        Description:
            'Indicates the type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values. ISO 10962 is maintained by ANNA (Association of National Numbering Agencies) acting as Registration Authority. See "Appendix 6-B FIX Fields Based Upon Other Standards". See also the Product (460) and SecurityType (167) fields. It is recommended that CFICode be used instead of SecurityType (167) for non-Fixed Income instruments.\nA subset of possible values applicable to FIX usage are identified in "Appendix 6-D CFICode Usage - ISO 10962 Classification of Financial Instruments (CFI code)"',
        added: 'FIX.4.3',
        AbbrName: 'CFI',
        Tag: 461,
        NotReqXML: 0,
        Name: 'CFICode',
    },
    {
        Type: 'int',
        EnumDatatype: 460,
        Description: "Underlying security's Product.\nValid values: see Product(460) field",
        added: 'FIX.4.3',
        AbbrName: 'Prod',
        Tag: 462,
        NotReqXML: 0,
        Name: 'UnderlyingProduct',
    },
    {
        Type: 'String',
        Description: "Underlying security's CFICode.\nValid values: see CFICode (461) field",
        added: 'FIX.4.3',
        AbbrName: 'CFI',
        Tag: 463,
        NotReqXML: 0,
        Name: 'UnderlyingCFICode',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates whether or not this FIX Session is a "test" vs. "production" connection. Useful for preventing "accidents".',
        added: 'FIX.4.3',
        AbbrName: 'TestMsgInd',
        Tag: 464,
        NotReqXML: 1,
        Name: 'TestMessageIndicator',
    },
    {
        Type: 'String',
        Description: 'Common reference passed to a post-trade booking process (e.g. industry matching utility).',
        added: 'FIX.4.3',
        AbbrName: 'BkngRefID',
        Tag: 466,
        NotReqXML: 0,
        Name: 'BookingRefID',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier for a specific NoAllocs (78) repeating group instance (e.g. for an AllocAccount).',
        added: 'FIX.4.3',
        AbbrName: 'IndAllocID',
        Tag: 467,
        NotReqXML: 0,
        Name: 'IndividualAllocID',
    },
    {
        Type: 'char',
        Description:
            'Specifies which direction to round For CIV - indicates whether or not the quantity of shares/units is to be rounded and in which direction where CashOrdQty (152) or (for CIV only) OrderPercent (516) are specified on an order.\nThe default is for rounding to be at the discretion of the executing broker or fund manager.\ne.g. for an order specifying CashOrdQty or OrderPercent if the calculated number of shares/units was 325.76 and RoundingModulus (469) was 0 - "round down" would give 320 units, 1 - "round up" would give 330 units and "round to nearest" would give 320 units.',
        added: 'FIX.4.3',
        AbbrName: 'RndDir',
        Tag: 468,
        NotReqXML: 0,
        Name: 'RoundingDirection',
    },
    {
        Type: 'float',
        Description:
            'For CIV - a float value indicating the value to which rounding is required.\ni.e. 0 means round to a multiple of 0 units/shares; 0.5 means round to a multiple of 0.5 units/shares.\nThe default, if RoundingDirection (468) is specified without RoundingModulus, is to round to a whole unit/share.',
        added: 'FIX.4.3',
        AbbrName: 'RndMod',
        Tag: 469,
        NotReqXML: 0,
        Name: 'RoundingModulus',
    },
    {
        Type: 'Country',
        Description:
            'ISO Country code of instrument issue (e.g. the country portion typically used in ISIN). Can be used in conjunction with non-ISIN SecurityID (48) (e.g. CUSIP for Municipal Bonds without ISIN) to provide uniqueness.',
        added: 'FIX.4.3',
        AbbrName: 'IssuCtry',
        Tag: 470,
        NotReqXML: 0,
        Name: 'CountryOfIssue',
    },
    {
        Type: 'String',
        Description: 'A two-character state or province abbreviation.',
        added: 'FIX.4.3',
        AbbrName: 'StPrv',
        Tag: 471,
        NotReqXML: 0,
        Name: 'StateOrProvinceOfIssue',
    },
    {
        Type: 'String',
        Description:
            'Identifies the locale. For Municipal Security Issuers other than state or province. Refer to\nhttp://www.atmos.albany.edu/cgi/stagrep-cgi\nReference the IATA city codes for values.\nNote IATA (International Air Transport Association) maintains the codes at www.iata.org.',
        added: 'FIX.4.3',
        AbbrName: 'Lcl',
        Tag: 472,
        NotReqXML: 0,
        Name: 'LocaleOfIssue',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of registration details on a Registration Instructions message',
        added: 'FIX.4.3',
        AbbrName: 'NoRegistDtls',
        Tag: 473,
        NotReqXML: 1,
        Name: 'NoRegistDtls',
    },
    {
        Type: 'String',
        Description: 'Set of Correspondence address details, possibly including phone, fax, etc.',
        added: 'FIX.4.3',
        AbbrName: 'MailingDtls',
        Tag: 474,
        NotReqXML: 0,
        Name: 'MailingDtls',
    },
    {
        Type: 'Country',
        Description:
            'The ISO 366 Country code (2 character) identifying which country the beneficial investor is resident for tax purposes.',
        added: 'FIX.4.3',
        AbbrName: 'InvestorCtryOfResidence',
        Tag: 475,
        NotReqXML: 0,
        Name: 'InvestorCountryOfResidence',
    },
    {
        Type: 'String',
        Description:
            '"Settlement Payment Reference" - A free format Payment reference to assist with reconciliation, e.g. a Client and/or Order ID number.',
        added: 'FIX.4.3',
        AbbrName: 'PmtRef',
        Tag: 476,
        NotReqXML: 0,
        Name: 'PaymentRef',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'A code identifying the payment method for a (fractional) distribution.\n13 through 998 are reserved for future use\nValues above 1000 are available for use by private agreement among counterparties',
        added: 'FIX.4.3',
        AbbrName: 'DistribPmtMethod',
        Tag: 477,
        NotReqXML: 0,
        Name: 'DistribPaymentMethod',
    },
    {
        Type: 'Currency',
        Description: 'Specifies currency to be used for Cash Distributions see "Appendix 6-A Valid Currency Codes".',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribCurr',
        Tag: 478,
        NotReqXML: 0,
        Name: 'CashDistribCurr',
    },
    {
        Type: 'Currency',
        Description:
            'Specifies currency to be use for Commission (12) if the Commission currency is different from the Deal Currency - see "Appendix 6-A; Valid Currency Codes".',
        added: 'FIX.4.3',
        AbbrName: 'Ccy',
        Tag: 479,
        NotReqXML: 0,
        Name: 'CommCurrency',
    },
    {
        Type: 'char',
        Description:
            'For CIV - A one character code identifying whether Cancellation rights/Cooling off period applies.',
        added: 'FIX.4.3',
        AbbrName: 'CxllationRights',
        Tag: 480,
        NotReqXML: 0,
        Name: 'CancellationRights',
    },
    {
        Type: 'char',
        Description: 'A one character code identifying Money laundering status.',
        added: 'FIX.4.3',
        AbbrName: 'MnyLaunderingStat',
        Tag: 481,
        NotReqXML: 0,
        Name: 'MoneyLaunderingStatus',
    },
    {
        Type: 'String',
        Description: 'Free format text to specify mailing instruction requirements, e.g. "no third party mailings".',
        added: 'FIX.4.3',
        AbbrName: 'MailingInst',
        Tag: 482,
        NotReqXML: 0,
        Name: 'MailingInst',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'For CIV A date and time stamp to indicate the time a CIV order was booked by the fund manager.\nFor derivatives a date and time stamp to indicate when this order was booked with the agent prior to submission to the VMU. Indicates the time at which the order was finalized between the buyer and seller prior to submission.',
        added: 'FIX.4.3',
        AbbrName: 'TransBkdTm',
        Tag: 483,
        NotReqXML: 0,
        Name: 'TransBkdTime',
    },
    {
        Type: 'char',
        Description:
            'For CIV - Identifies how the execution price LastPx (31) was calculated from the fund unit/share price(s) calculated at the fund valuation point.',
        added: 'FIX.4.3',
        AbbrName: 'ExecPxTyp',
        Tag: 484,
        NotReqXML: 0,
        Name: 'ExecPriceType',
    },
    {
        Type: 'float',
        Description:
            'For CIV the amount or percentage by which the fund unit/share price was adjusted, as indicated by ExecPriceType (484)',
        added: 'FIX.4.3',
        AbbrName: 'ExecPxAdjment',
        Tag: 485,
        NotReqXML: 0,
        Name: 'ExecPriceAdjustment',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The date of birth applicable to the individual, e.g. required to open some types of tax-exempt account.',
        added: 'FIX.4.3',
        AbbrName: 'DtOfBirth',
        Tag: 486,
        NotReqXML: 0,
        Name: 'DateOfBirth',
    },
    {
        Type: 'int',
        Description: 'Identifies Trade Report message transaction type\n(Prior to FIX 4.4 this field was of type char)',
        added: 'FIX.4.3',
        AbbrName: 'TransTyp',
        Tag: 487,
        NotReqXML: 0,
        Name: 'TradeReportTransType',
    },
    {
        Type: 'String',
        Description: 'The name of the payment card holder as specified on the card being used for payment.',
        added: 'FIX.4.3',
        AbbrName: 'CardHolderName',
        Tag: 488,
        NotReqXML: 0,
        Name: 'CardHolderName',
    },
    {
        Type: 'String',
        Description: 'The number of the payment card as specified on the card being used for payment.',
        added: 'FIX.4.3',
        AbbrName: 'CardNum',
        Tag: 489,
        NotReqXML: 0,
        Name: 'CardNumber',
    },
    {
        Type: 'LocalMktDate',
        Description: 'The expiry date of the payment card as specified on the card being used for payment.',
        added: 'FIX.4.3',
        AbbrName: 'CardExpDt',
        Tag: 490,
        NotReqXML: 0,
        Name: 'CardExpDate',
    },
    {
        Type: 'String',
        Description:
            'The issue number of the payment card as specified on the card being used for payment. This is only applicable to certain types of card.',
        added: 'FIX.4.3',
        AbbrName: 'CardIssNum',
        Tag: 491,
        NotReqXML: 0,
        Name: 'CardIssNum',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved1000Plus',
        Description:
            'A code identifying the Settlement payment method. 16 through 998 are reserved for future use\nValues above 1000 are available for use by private agreement among counterparties',
        added: 'FIX.4.3',
        AbbrName: 'PmtMethod',
        Tag: 492,
        NotReqXML: 0,
        Name: 'PaymentMethod',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description:
            "For CIV - a fund manager-defined code identifying which of the fund manager's account types is required.",
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'AcctTyp',
        AbbrName: 'AcctTyp',
        Tag: 493,
        NotReqXML: 0,
        Name: 'RegistAcctType',
    },
    {
        Type: 'String',
        Description:
            "Free format text defining the designation to be associated with a holding on the register. Used to identify assets of a specific underlying investor using a common registration, e.g. a broker's nominee or street name.",
        added: 'FIX.4.3',
        AbbrName: 'Designation',
        Tag: 494,
        NotReqXML: 0,
        Name: 'Designation',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved1000Plus',
        Description:
            'For CIV - a code identifying the type of tax exempt account in which purchased shares/units are to be held.\n30 - 998 are reserved for future use by recognized taxation authorities\n999=Other\nvalues above 1000 are available for use by private agreement among counterparties',
        added: 'FIX.4.3',
        AbbrName: 'TaxAdvantageTyp',
        Tag: 495,
        NotReqXML: 0,
        Name: 'TaxAdvantageType',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description: 'Text indicating reason(s) why a Registration Instruction has been rejected.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Dtls',
        AbbrName: 'RejRsnTxt',
        Tag: 496,
        NotReqXML: 0,
        Name: 'RegistRejReasonText',
    },
    {
        Type: 'char',
        Description: 'A one character code identifying whether the Fund based renewal commission is to be waived.',
        added: 'FIX.4.3',
        AbbrName: 'FundRenewWaiv',
        Tag: 497,
        NotReqXML: 0,
        Name: 'FundRenewWaiv',
    },
    {
        Type: 'String',
        Description: 'Name of local agent bank if for cash distributions',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribAgentName',
        Tag: 498,
        NotReqXML: 0,
        Name: 'CashDistribAgentName',
    },
    {
        Type: 'String',
        Description: 'BIC (Bank Identification Code--Swift managed) code of agent bank for cash distributions',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribAgentCode',
        Tag: 499,
        NotReqXML: 0,
        Name: 'CashDistribAgentCode',
    },
    {
        Type: 'String',
        Description: 'Account number at agent bank for distributions.',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribAgentAcctNum',
        Tag: 500,
        NotReqXML: 0,
        Name: 'CashDistribAgentAcctNumber',
    },
    {
        Type: 'String',
        Description: 'Free format Payment reference to assist with reconciliation of distributions.',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribPayRef',
        Tag: 501,
        NotReqXML: 0,
        Name: 'CashDistribPayRef',
    },
    {
        Type: 'String',
        Description: 'Name of account at agent bank for distributions.',
        added: 'FIX.4.3',
        AbbrName: 'CshDistribAgentAcctName',
        Tag: 502,
        NotReqXML: 0,
        Name: 'CashDistribAgentAcctName',
    },
    {
        Type: 'LocalMktDate',
        Description: 'The start date of the card as specified on the card being used for payment.',
        added: 'FIX.4.3',
        AbbrName: 'CardStartDt',
        Tag: 503,
        NotReqXML: 0,
        Name: 'CardStartDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The date written on a cheque or date payment should be submitted to the relevant clearing system.',
        added: 'FIX.4.3',
        AbbrName: 'PmtDt',
        Tag: 504,
        NotReqXML: 0,
        Name: 'PaymentDate',
    },
    {
        Type: 'String',
        Description: 'Identifies sender of a payment, e.g. the payment remitter or a customer reference number.',
        added: 'FIX.4.3',
        AbbrName: 'PmtRemtrID',
        Tag: 505,
        NotReqXML: 0,
        Name: 'PaymentRemitterID',
    },
    {
        Type: 'char',
        Description: 'Registration status as returned by the broker or (for CIV) the fund manager:',
        added: 'FIX.4.3',
        AbbrName: 'RegStat',
        Tag: 506,
        NotReqXML: 0,
        Name: 'RegistStatus',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Reason(s) why Registration Instructions has been rejected.\nThe reason may be further amplified in the RegistRejReasonCode field.\nPossible values of reason code include:',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'RejRsnCd',
        AbbrName: 'RejRsnCd',
        Tag: 507,
        NotReqXML: 0,
        Name: 'RegistRejReasonCode',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description:
            'Reference identifier for the RegistID (53) with Cancel and Replace RegistTransType (54) transaction types.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'RefID',
        AbbrName: 'RefID',
        Tag: 508,
        NotReqXML: 0,
        Name: 'RegistRefID',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description: 'Set of Registration name and address details, possibly including phone, fax etc.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'RejRsnTxt',
        AbbrName: 'Dtls',
        Tag: 509,
        NotReqXML: 0,
        Name: 'RegistDtls',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of Distribution Instructions on a Registration Instructions message',
        added: 'FIX.4.3',
        AbbrName: 'NoDistribInsts',
        Tag: 510,
        NotReqXML: 1,
        Name: 'NoDistribInsts',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description: 'Email address relating to Registration name and address details',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Email',
        AbbrName: 'Email',
        Tag: 511,
        NotReqXML: 0,
        Name: 'RegistEmail',
    },
    {
        Type: 'Percentage',
        Description: 'The amount of each distribution to go to this beneficiary, expressed as a percentage',
        added: 'FIX.4.3',
        AbbrName: 'DistribPctage',
        Tag: 512,
        NotReqXML: 0,
        Name: 'DistribPercentage',
    },
    {
        BaseCategory: 'RegistrationInstruction',
        Type: 'String',
        Description: 'Unique identifier of the registration details as assigned by institution or intermediary.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'RegistID',
        Tag: 513,
        NotReqXML: 0,
        Name: 'RegistID',
    },
    {
        Type: 'char',
        Description: 'Identifies Registration Instructions transaction type',
        added: 'FIX.4.3',
        AbbrName: 'TransTyp',
        Tag: 514,
        NotReqXML: 0,
        Name: 'RegistTransType',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'For CIV - a date and time stamp to indicate the fund valuation point with respect to which a order was priced by the fund manager.',
        added: 'FIX.4.3',
        AbbrName: 'ExecValuationPoint',
        Tag: 515,
        NotReqXML: 0,
        Name: 'ExecValuationPoint',
    },
    {
        Type: 'Percentage',
        Description:
            "For CIV specifies the approximate order quantity desired. For a CIV Sale it specifies percentage of investor's total holding to be sold. For a CIV switch/exchange it specifies percentage of investor's cash realised from sales to be re-invested. The executing broker, intermediary or fund manager is responsible for converting and calculating OrderQty (38) in shares/units for subsequent messages.",
        added: 'FIX.4.3',
        AbbrName: 'Pct',
        Tag: 516,
        NotReqXML: 0,
        Name: 'OrderPercent',
    },
    {
        Type: 'char',
        Description: 'The relationship between Registration parties.',
        added: 'FIX.4.3',
        AbbrName: 'OwnershipTyp',
        Tag: 517,
        NotReqXML: 0,
        Name: 'OwnershipType',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of Contract Amount details on an Execution Report message',
        added: 'FIX.4.3',
        AbbrName: 'NoContAmts',
        Tag: 518,
        NotReqXML: 1,
        Name: 'NoContAmts',
    },
    {
        Type: 'int',
        Description:
            'Type of ContAmtValue (520).\nNOTE That Commission Amount / % in Contract Amounts is the commission actually charged, rather than the commission instructions given in Fields 2/3.',
        added: 'FIX.4.3',
        AbbrName: 'ContAmtTyp',
        Tag: 519,
        NotReqXML: 0,
        Name: 'ContAmtType',
    },
    {
        Type: 'float',
        Description:
            'Value of Contract Amount, e.g. a financial amount or percentage as indicated by ContAmtType (519).',
        added: 'FIX.4.3',
        AbbrName: 'ContAmtValu',
        Tag: 520,
        NotReqXML: 0,
        Name: 'ContAmtValue',
    },
    {
        Type: 'Currency',
        Description:
            'Specifies currency for the Contract amount if different from the Deal Currency - see "Appendix 6-A; Valid Currency Codes".',
        added: 'FIX.4.3',
        AbbrName: 'ContAmtCurr',
        Tag: 521,
        NotReqXML: 0,
        Name: 'ContAmtCurr',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of owner.',
        added: 'FIX.4.3',
        AbbrName: 'OwnerTyp',
        Tag: 522,
        NotReqXML: 0,
        Name: 'OwnerType',
    },
    {
        Type: 'String',
        Description:
            'Sub-identifier (e.g. Clearing Account for PartyRole (452)=Clearing Firm, Locate ID # for PartyRole=Locate/Lending Firm, etc). Not required when using PartyID (448), PartyIDSource (447), and PartyRole.',
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 523,
        NotReqXML: 0,
        Name: 'PartySubID',
    },
    {
        Type: 'String',
        Description: 'PartyID value within a nested repeating group.\nSame values as PartyID (448)',
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 524,
        NotReqXML: 0,
        Name: 'NestedPartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description: 'PartyIDSource value within a nested repeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.3',
        AbbrName: 'Src',
        Tag: 525,
        NotReqXML: 0,
        Name: 'NestedPartyIDSource',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description:
            'Assigned by the party which originates the order. Can be used to provide the ClOrdID (11) used by an exchange or executing system.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'ID2',
        AbbrName: 'ClOrdID2',
        Tag: 526,
        NotReqXML: 0,
        Name: 'SecondaryClOrdID',
    },
    {
        Type: 'String',
        Description:
            'Assigned by the party which accepts the order. Can be used to provide the ExecID (17) used by an exchange or executing system.',
        added: 'FIX.4.3',
        AbbrName: 'ExecID2',
        Tag: 527,
        NotReqXML: 0,
        Name: 'SecondaryExecID',
    },
    {
        Type: 'char',
        Description:
            'Designates the capacity of the firm placing the order.\n(as of FIX 4.3, this field replaced Rule80A (tag 47) --used in conjunction with OrderRestrictions (529) field)\n(see Volume : "Glossary" for value definitions)',
        added: 'FIX.4.3',
        AbbrName: 'Cpcty',
        Tag: 528,
        NotReqXML: 0,
        Name: 'OrderCapacity',
    },
    {
        Type: 'MultipleCharValue',
        Description:
            'Restrictions associated with an order. If more than one restriction is applicable to an order, this field can contain multiple instructions separated by space.',
        added: 'FIX.4.3',
        AbbrName: 'Rstctions',
        Tag: 529,
        NotReqXML: 0,
        Name: 'OrderRestrictions',
    },
    {
        BaseCategory: 'OrderMassHandling',
        Type: 'char',
        Description: 'Specifies scope of Order Mass Cancel Request.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'ReqTyp',
        AbbrName: 'MassCxlReqTyp',
        Tag: 530,
        NotReqXML: 0,
        Name: 'MassCancelRequestType',
    },
    {
        BaseCategory: 'OrderMassHandling',
        Type: 'char',
        Description:
            'Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Rsp',
        AbbrName: 'MassCxlRsp',
        Tag: 531,
        NotReqXML: 0,
        Name: 'MassCancelResponse',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason Order Mass Cancel Request was rejected',
        added: 'FIX.4.3',
        AbbrName: 'MassCxlRejRsn',
        Tag: 532,
        NotReqXML: 0,
        Name: 'MassCancelRejectReason',
    },
    {
        Type: 'int',
        Description:
            'Total number of orders affected by either the OrderMassActionRequest(MsgType=CA) or OrderMassCancelRequest(MsgType=Q).',
        added: 'FIX.4.3',
        updatedEP: 95,
        AbbrName: 'TotAffctdOrds',
        Tag: 533,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TotalAffectedOrders',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of affected orders in the repeating group of order ids.',
        added: 'FIX.4.3',
        AbbrName: 'NoAffctdOrds',
        Tag: 534,
        NotReqXML: 0,
        Name: 'NoAffectedOrders',
    },
    {
        Type: 'String',
        Description: 'OrderID (37) of an order affected by a mass cancel request.',
        added: 'FIX.4.3',
        AbbrName: 'AffctdOrdID',
        Tag: 535,
        NotReqXML: 0,
        Name: 'AffectedOrderID',
    },
];

const batch2: ISpecFields[] = [
    {
        Type: 'String',
        Description: 'SecondaryOrderID (198) of an order affected by a mass cancel request.',
        added: 'FIX.4.3',
        AbbrName: 'AffctdScndOrdID',
        Tag: 536,
        NotReqXML: 0,
        Name: 'AffectedSecondaryOrderID',
    },
    {
        Type: 'int',
        Description:
            'Identifies the type of quote.\nAn indicative quote is used to inform a counterparty of a market. An indicative quote does not result directly in a trade.\nA tradeable quote is submitted to a market and will result directly in a trade against other orders and quotes in a market.\nA restricted tradeable quote is submitted to a market and within a certain restriction (possibly based upon price or quantity) will automatically trade against orders. Order that do not comply with restrictions are sent to the quote issuer who can choose to accept or decline the order.\nA counter quote is used in the negotiation model. See Volume 7 - Product: Fixed Income for example usage.',
        added: 'FIX.4.3',
        AbbrName: 'Typ',
        Tag: 537,
        NotReqXML: 0,
        Name: 'QuoteType',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'PartyRole value within a nested repeating group.\nSame values as PartyRole (452)',
        added: 'FIX.4.3',
        AbbrName: 'R',
        Tag: 538,
        NotReqXML: 0,
        Name: 'NestedPartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of NestedPartyID (524), NestedPartyIDSource (525), and NestedPartyRole (538) entries',
        added: 'FIX.4.3',
        AbbrName: 'NoNstPtyIDs',
        Tag: 539,
        NotReqXML: 1,
        Name: 'NoNestedPartyIDs',
    },
    {
        Type: 'Amt',
        Description: 'Total Amount of Accrued Interest for convertible bonds and fixed income',
        added: 'FIX.4.3',
        deprecated: 'FIX.4.4',
        AbbrName: 'TotAcrdIntAmt',
        Tag: 540,
        NotReqXML: 0,
        Name: 'TotalAccruedInterestAmt',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Date of maturity.',
        added: 'FIX.4.3',
        AbbrName: 'MatDt',
        Tag: 541,
        NotReqXML: 0,
        Name: 'MaturityDate',
    },
    {
        Type: 'LocalMktDate',
        Description: "Underlying security's maturity date.\nSee MaturityDate (541) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Mat',
        Tag: 542,
        NotReqXML: 0,
        Name: 'UnderlyingMaturityDate',
    },
    {
        Type: 'String',
        Description:
            'Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value "ZZ" to specify physical ownership of the security (e.g. stock certificate).',
        added: 'FIX.4.3',
        AbbrName: 'Rgstry',
        Tag: 543,
        NotReqXML: 0,
        Name: 'InstrRegistry',
    },
    {
        Type: 'char',
        Description:
            'Identifies whether an order is a margin order or a non-margin order. This is primarily used when sending orders to Japanese exchanges to indicate sell margin or buy to cover. The same tag could be assigned also by buy-side to indicate the intent to sell or buy margin and the sell-side to accept or reject (base on some validation criteria) the margin request.',
        added: 'FIX.4.3',
        AbbrName: 'CshMgn',
        Tag: 544,
        NotReqXML: 0,
        Name: 'CashMargin',
    },
    {
        Type: 'String',
        Description: 'PartySubID value within a nested repeating group.\nSame values as PartySubID (523)',
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 545,
        NotReqXML: 0,
        Name: 'NestedPartySubID',
    },
    {
        Type: 'MultipleCharValue',
        Description: 'Specifies the market scope of the market data.',
        added: 'FIX.4.3',
        updatedEP: 95,
        AbbrName: 'Scope',
        Tag: 546,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'Scope',
    },
    {
        Type: 'Boolean',
        Description: 'Defines how a server handles distribution of a truncated book. Defaults to broker option.',
        added: 'FIX.4.3',
        AbbrName: 'ImplctDel',
        Tag: 547,
        NotReqXML: 0,
        Name: 'MDImplicitDelete',
    },
    {
        BaseCategory: 'CrossOrders',
        Type: 'String',
        Description:
            'Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'ID',
        AbbrName: 'CrssID',
        Tag: 548,
        NotReqXML: 0,
        Name: 'CrossID',
    },
    {
        BaseCategory: 'CrossOrders',
        Type: 'int',
        Description: 'Type of cross being submitted to a market',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Typ',
        AbbrName: 'CrssTyp',
        Tag: 549,
        NotReqXML: 0,
        Name: 'CrossType',
    },
    {
        BaseCategory: 'CrossOrders',
        Type: 'int',
        Description:
            'Indicates if one side or the other of a cross order should be prioritized.\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected).',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Priorty',
        AbbrName: 'CrssPriortstn',
        Tag: 550,
        NotReqXML: 0,
        Name: 'CrossPrioritization',
    },
    {
        BaseCategory: 'CrossOrders',
        Type: 'String',
        Description:
            'CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'OrigID',
        AbbrName: 'OrigCrssID',
        Tag: 551,
        NotReqXML: 0,
        Name: 'OrigCrossID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Side repeating group instances.',
        added: 'FIX.4.3',
        AbbrName: 'NoSides',
        Tag: 552,
        NotReqXML: 1,
        Name: 'NoSides',
    },
    {
        Type: 'String',
        Description: 'Userid or username.',
        added: 'FIX.4.3',
        AbbrName: 'Username',
        Tag: 553,
        NotReqXML: 0,
        Name: 'Username',
    },
    {
        Type: 'String',
        Description: 'Password or passphrase.',
        added: 'FIX.4.3',
        AbbrName: 'Password',
        Tag: 554,
        NotReqXML: 0,
        Name: 'Password',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of InstrumentLeg repeating group instances.',
        added: 'FIX.4.3',
        AbbrName: 'NoLegs',
        Tag: 555,
        NotReqXML: 1,
        Name: 'NoLegs',
    },
    {
        Type: 'Currency',
        Description: "Currency associated with a particular Leg's quantity",
        added: 'FIX.4.3',
        AbbrName: 'Ccy',
        Tag: 556,
        NotReqXML: 0,
        Name: 'LegCurrency',
    },
    {
        Type: 'int',
        Description:
            'Used to support fragmentation. Indicates total number of security types when multiple Security Type messages are used to return results.',
        added: 'FIX.4.3',
        updatedEP: 95,
        AbbrName: 'TotNoSecTyps',
        Tag: 557,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TotNoSecurityTypes',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Security Type repeating group instances.',
        added: 'FIX.4.3',
        AbbrName: 'NoSecTyps',
        Tag: 558,
        NotReqXML: 1,
        Name: 'NoSecurityTypes',
    },
    {
        Type: 'int',
        Description: 'Identifies the type/criteria of Security List Request',
        added: 'FIX.4.3',
        AbbrName: 'ListReqTyp',
        Tag: 559,
        NotReqXML: 0,
        Name: 'SecurityListRequestType',
    },
    {
        Type: 'int',
        Description: 'The results returned to a Security Request message',
        added: 'FIX.4.3',
        AbbrName: 'ReqRslt',
        Tag: 560,
        NotReqXML: 0,
        Name: 'SecurityRequestResult',
    },
    {
        Type: 'Qty',
        Description: 'The trading lot size of a security',
        added: 'FIX.4.3',
        AbbrName: 'RndLot',
        Tag: 561,
        NotReqXML: 0,
        Name: 'RoundLot',
    },
    {
        Type: 'Qty',
        Description: 'The minimum trading volume for a security',
        added: 'FIX.4.3',
        AbbrName: 'MinTrdVol',
        Tag: 562,
        NotReqXML: 0,
        Name: 'MinTradeVol',
    },
    {
        Type: 'int',
        Description: 'Indicates the method of execution reporting requested by issuer of the order.',
        added: 'FIX.4.3',
        AbbrName: 'MLEGRptTypReq',
        Tag: 563,
        NotReqXML: 0,
        Name: 'MultiLegRptTypeReq',
    },
    {
        Type: 'char',
        EnumDatatype: 77,
        Description: 'PositionEffect for leg of a multileg\nSee PositionEffect (77) field for description',
        added: 'FIX.4.3',
        AbbrName: 'PosEfct',
        Tag: 564,
        NotReqXML: 0,
        Name: 'LegPositionEffect',
    },
    {
        Type: 'int',
        EnumDatatype: 203,
        Description: 'CoveredOrUncovered for leg of a multileg\nSee CoveredOrUncovered (203) field for description',
        added: 'FIX.4.3',
        AbbrName: 'Cover',
        Tag: 565,
        NotReqXML: 0,
        Name: 'LegCoveredOrUncovered',
    },
    {
        Type: 'Price',
        Description: 'Price for leg of a multileg\nSee Price (44) field for description',
        added: 'FIX.4.3',
        AbbrName: 'Px',
        Tag: 566,
        NotReqXML: 0,
        Name: 'LegPrice',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Indicates the reason a Trading Session Status Request was rejected.',
        added: 'FIX.4.3',
        AbbrName: 'StatRejRsn',
        Tag: 567,
        NotReqXML: 0,
        Name: 'TradSesStatusRejReason',
    },
    {
        Type: 'String',
        Description: 'Trade Capture Report Request ID',
        added: 'FIX.4.3',
        AbbrName: 'ReqID',
        Tag: 568,
        NotReqXML: 0,
        Name: 'TradeRequestID',
    },
    {
        Type: 'int',
        Description: 'Type of Trade Capture Report.',
        added: 'FIX.4.3',
        AbbrName: 'ReqTyp',
        Tag: 569,
        NotReqXML: 0,
        Name: 'TradeRequestType',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates if the trade capture report was previously reported to the counterparty',
        added: 'FIX.4.3',
        AbbrName: 'PrevlyRpted',
        Tag: 570,
        NotReqXML: 0,
        Name: 'PreviouslyReported',
    },
    {
        Type: 'String',
        Description: 'Unique identifier of trade capture report',
        added: 'FIX.4.3',
        AbbrName: 'RptID',
        Tag: 571,
        NotReqXML: 0,
        Name: 'TradeReportID',
    },
    {
        Type: 'String',
        Description: 'Reference identifier used with CANCEL and REPLACE transaction types.',
        added: 'FIX.4.3',
        AbbrName: 'RptRefID',
        Tag: 572,
        NotReqXML: 0,
        Name: 'TradeReportRefID',
    },
    {
        Type: 'char',
        Description: 'The status of this trade with respect to matching or comparison.',
        added: 'FIX.4.3',
        AbbrName: 'MtchStat',
        Tag: 573,
        NotReqXML: 0,
        Name: 'MatchStatus',
    },
    {
        Type: 'String',
        Description: 'The point in the matching process at which this trade was matched.',
        added: 'FIX.4.3',
        AbbrName: 'MtchTyp',
        Tag: 574,
        NotReqXML: 0,
        Name: 'MatchType',
    },
    {
        Type: 'Boolean',
        Description:
            'This trade is to be treated as an odd lot\nIf this field is not specified, the default will be "N"',
        added: 'FIX.4.3',
        deprecated: 'FIX.5.0',
        AbbrName: 'OddLot',
        Tag: 575,
        NotReqXML: 0,
        Name: 'OddLot',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of clearing instructions',
        added: 'FIX.4.3',
        AbbrName: 'NoClrngInstrctns',
        Tag: 576,
        NotReqXML: 1,
        Name: 'NoClearingInstructions',
    },
    {
        Type: 'int',
        Description:
            'Eligibility of this trade for clearing and central counterparty processing\nvalues above 4000 are reserved for agreement between parties',
        added: 'FIX.4.3',
        AbbrName: 'ClrngInstrctn',
        Tag: 577,
        NotReqXML: 0,
        Name: 'ClearingInstruction',
    },
    {
        Type: 'String',
        Description: 'Type of input device or system from which the trade was entered.',
        added: 'FIX.4.3',
        AbbrName: 'InptSrc',
        Tag: 578,
        NotReqXML: 0,
        Name: 'TradeInputSource',
    },
    {
        Type: 'String',
        Description: 'Specific device number, terminal number or station where trade was entered',
        added: 'FIX.4.3',
        AbbrName: 'InptDev',
        Tag: 579,
        NotReqXML: 0,
        Name: 'TradeInputDevice',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Date fields provided in date range',
        added: 'FIX.4.3',
        AbbrName: 'NoDts',
        Tag: 580,
        NotReqXML: 0,
        Name: 'NoDates',
    },
    {
        Type: 'int',
        Description: 'Type of account associated with an order',
        added: 'FIX.4.3',
        AbbrName: 'AcctTyp',
        Tag: 581,
        NotReqXML: 0,
        Name: 'AccountType',
    },
    {
        Type: 'int',
        Description:
            'Capacity of customer placing the order\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).',
        added: 'FIX.4.3',
        AbbrName: 'CustCpcty',
        Tag: 582,
        NotReqXML: 0,
        Name: 'CustOrderCapacity',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description:
            'Permits order originators to tie together groups of orders in which trades resulting from orders are associated for a specific purpose, for example the calculation of average execution price for a customer or to associate lists submitted to a broker as waves of a larger program trade.',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'LnkID',
        AbbrName: 'ClOrdLinkID',
        Tag: 583,
        NotReqXML: 0,
        Name: 'ClOrdLinkID',
    },
    {
        BaseCategory: 'OrderMassHandling',
        Type: 'String',
        Description: 'Value assigned by issuer of Mass Status Request to uniquely identify the request',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'ReqID',
        AbbrName: 'MassStatReqID',
        Tag: 584,
        NotReqXML: 0,
        Name: 'MassStatusReqID',
    },
    {
        BaseCategory: 'OrderMassHandling',
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Mass Status Request Type',
        added: 'FIX.4.3',
        updatedEP: 85,
        BaseCategoryAbbrName: 'ReqTyp',
        AbbrName: 'MassStatReqTyp',
        Tag: 585,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'MassStatusReqType',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'The most recent (or current) modification TransactTime (tag 60) reported on an Execution Report for the order. The OrigOrdModTime is provided as an optional field on Order Cancel Request and Order Cancel Replace Requests to identify that the state of the order has not changed since the request was issued. The use of this approach is not recommended.',
        added: 'FIX.4.3',
        AbbrName: 'OrigOrdModTm',
        Tag: 586,
        NotReqXML: 0,
        Name: 'OrigOrdModTime',
    },
    {
        Type: 'char',
        EnumDatatype: 63,
        Description: 'Refer to values for SettlType[63]',
        added: 'FIX.4.3',
        AbbrName: 'SettlTyp',
        Tag: 587,
        NotReqXML: 0,
        Name: 'LegSettlType',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Refer to description for SettlDate[64]',
        added: 'FIX.4.3',
        AbbrName: 'SettlDt',
        Tag: 588,
        NotReqXML: 0,
        Name: 'LegSettlDate',
    },
    {
        Type: 'char',
        Description: 'Indicates whether or not automatic booking can occur.',
        added: 'FIX.4.3',
        AbbrName: 'DayBkngInst',
        Tag: 589,
        NotReqXML: 0,
        Name: 'DayBookingInst',
    },
    {
        Type: 'char',
        Description: 'Indicates what constitutes a bookable unit.',
        added: 'FIX.4.3',
        AbbrName: 'BkngUnit',
        Tag: 590,
        NotReqXML: 0,
        Name: 'BookingUnit',
    },
    {
        Type: 'char',
        Description: 'Indicates the method of preallocation.',
        added: 'FIX.4.3',
        AbbrName: 'PreallocMeth',
        Tag: 591,
        NotReqXML: 0,
        Name: 'PreallocMethod',
    },
    {
        Type: 'Country',
        Description: "Underlying security's CountryOfIssue.\nSee CountryOfIssue (470) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Ctry',
        Tag: 592,
        NotReqXML: 0,
        Name: 'UnderlyingCountryOfIssue',
    },
    {
        Type: 'String',
        Description:
            "Underlying security's StateOrProvinceOfIssue.\nSee StateOrProvinceOfIssue (471) field for description",
        added: 'FIX.4.3',
        AbbrName: 'StOrProvnc',
        Tag: 593,
        NotReqXML: 0,
        Name: 'UnderlyingStateOrProvinceOfIssue',
    },
    {
        Type: 'String',
        Description: "Underlying security's LocaleOfIssue.\nSee LocaleOfIssue (472) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Lcl',
        Tag: 594,
        NotReqXML: 0,
        Name: 'UnderlyingLocaleOfIssue',
    },
    {
        Type: 'String',
        Description: "Underlying security's InstrRegistry.\nSee InstrRegistry (543) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Rgstry',
        Tag: 595,
        NotReqXML: 0,
        Name: 'UnderlyingInstrRegistry',
    },
    {
        Type: 'Country',
        Description:
            "Multileg instrument's individual leg security's CountryOfIssue.\nSee CountryOfIssue (470) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Ctry',
        Tag: 596,
        NotReqXML: 0,
        Name: 'LegCountryOfIssue',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual leg security's StateOrProvinceOfIssue.\nSee StateOrProvinceOfIssue (471) field for description",
        added: 'FIX.4.3',
        AbbrName: 'StOrProvnc',
        Tag: 597,
        NotReqXML: 0,
        Name: 'LegStateOrProvinceOfIssue',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual leg security's LocaleOfIssue.\nSee LocaleOfIssue (472) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Lcl',
        Tag: 598,
        NotReqXML: 0,
        Name: 'LegLocaleOfIssue',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual leg security's InstrRegistry.\nSee InstrRegistry (543) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Rgstry',
        Tag: 599,
        NotReqXML: 0,
        Name: 'LegInstrRegistry',
    },
    {
        Type: 'String',
        Description: "Multileg instrument's individual security's Symbol.\nSee Symbol (55) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Sym',
        Tag: 600,
        NotReqXML: 0,
        Name: 'LegSymbol',
    },
    {
        Type: 'String',
        EnumDatatype: 65,
        Description: "Multileg instrument's individual security's SymbolSfx.\nSee SymbolSfx (65) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Sfx',
        Tag: 601,
        NotReqXML: 0,
        Name: 'LegSymbolSfx',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual security's SecurityID.\nSee SecurityID (48) field for description",
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 602,
        NotReqXML: 0,
        Name: 'LegSecurityID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            "Multileg instrument's individual security's SecurityIDSource.\nSee SecurityIDSource (22) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Src',
        Tag: 603,
        NotReqXML: 0,
        Name: 'LegSecurityIDSource',
    },
    {
        Type: 'NumInGroup',
        Description:
            "Multileg instrument's individual security's NoSecurityAltID.\nSee NoSecurityAltID (454) field for description",
        added: 'FIX.4.3',
        AbbrName: 'NoLegSecAltID',
        Tag: 604,
        NotReqXML: 0,
        Name: 'NoLegSecurityAltID',
    },
    {
        Type: 'String',
        Description:
            "Multileg instrument's individual security's SecurityAltID.\nSee SecurityAltID (455) field for description",
        added: 'FIX.4.3',
        AbbrName: 'SecAltID',
        Tag: 605,
        NotReqXML: 0,
        Name: 'LegSecurityAltID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            "Multileg instrument's individual security's SecurityAltIDSource.\nSee SecurityAltIDSource (456) field for description",
        added: 'FIX.4.3',
        AbbrName: 'SecAltIDSrc',
        Tag: 606,
        NotReqXML: 0,
        Name: 'LegSecurityAltIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 460,
        Description: "Multileg instrument's individual security's Product.\nSee Product (460) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Prod',
        Tag: 607,
        NotReqXML: 0,
        Name: 'LegProduct',
    },
    {
        Type: 'String',
        Description: "Multileg instrument's individual security's CFICode.\nSee CFICode (461) field for description",
        added: 'FIX.4.3',
        AbbrName: 'CFI',
        Tag: 608,
        NotReqXML: 0,
        Name: 'LegCFICode',
    },
    {
        Type: 'String',
        EnumDatatype: 167,
        Description: 'Refer to definition of SecurityType(167)',
        added: 'FIX.4.3',
        AbbrName: 'SecTyp',
        Tag: 609,
        NotReqXML: 0,
        Name: 'LegSecurityType',
    },
    {
        Type: 'MonthYear',
        Description:
            "Multileg instrument's individual security's MaturityMonthYear.\nSee MaturityMonthYear (200) field for description",
        added: 'FIX.4.3',
        AbbrName: 'MMY',
        Tag: 610,
        NotReqXML: 0,
        Name: 'LegMaturityMonthYear',
    },
    {
        Type: 'LocalMktDate',
        Description:
            "Multileg instrument's individual security's MaturityDate.\nSee MaturityDate (54) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Mat',
        Tag: 611,
        NotReqXML: 0,
        Name: 'LegMaturityDate',
    },
    {
        Type: 'Price',
        Description:
            "Multileg instrument's individual security's StrikePrice.\nSee StrikePrice (202) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Strk',
        Tag: 612,
        NotReqXML: 0,
        Name: 'LegStrikePrice',
    },
    {
        Type: 'char',
        Description:
            "Multileg instrument's individual security's OptAttribute.\nSee OptAttribute (206) field for description",
        added: 'FIX.4.3',
        AbbrName: 'OptA',
        Tag: 613,
        NotReqXML: 0,
        Name: 'LegOptAttribute',
    },
    {
        Type: 'float',
        Description:
            "Multileg instrument's individual security's ContractMultiplier.\nSee ContractMultiplier (23) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Cmult',
        Tag: 614,
        NotReqXML: 0,
        Name: 'LegContractMultiplier',
    },
    {
        Type: 'Percentage',
        Description:
            "Multileg instrument's individual security's CouponRate.\nSee CouponRate (223) field for description",
        added: 'FIX.4.3',
        AbbrName: 'CpnRt',
        Tag: 615,
        NotReqXML: 0,
        Name: 'LegCouponRate',
    },
    {
        Type: 'Exchange',
        Description:
            "Multileg instrument's individual security's SecurityExchange.\nSee SecurityExchange (207) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Exch',
        Tag: 616,
        NotReqXML: 0,
        Name: 'LegSecurityExchange',
    },
    {
        Type: 'String',
        Description: "Multileg instrument's individual security's Issuer.\nSee Issuer (106) field for description",
        added: 'FIX.4.3',
        AbbrName: 'Issr',
        Tag: 617,
        NotReqXML: 0,
        Name: 'LegIssuer',
    },
    {
        Type: 'Length',
        Description:
            "Multileg instrument's individual security's EncodedIssuerLen.\nSee EncodedIssuerLen (348) field for description",
        added: 'FIX.4.3',
        AssociatedDataTag: 619,
        AbbrName: 'EncLegIssrLen',
        Tag: 618,
        NotReqXML: 0,
        Name: 'EncodedLegIssuerLen',
    },
    {
        Type: 'data',
        Description:
            "Multileg instrument's individual security's EncodedIssuer.\nSee EncodedIssuer (349) field for description",
        added: 'FIX.4.3',
        AbbrName: 'EncLegIssr',
        Tag: 619,
        NotReqXML: 0,
        Name: 'EncodedLegIssuer',
    },
    {
        Type: 'String',
        Description: 'Description of a leg of a multileg instrument.\nSee SecurityDesc(107).',
        added: 'FIX.4.3',
        updatedEP: 95,
        AbbrName: 'Desc',
        Tag: 620,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'LegSecurityDesc',
    },
    {
        Type: 'Length',
        Description:
            "Multileg instrument's individual security's EncodedSecurityDescLen.\nSee EncodedSecurityDescLen (350) field for description",
        added: 'FIX.4.3',
        AssociatedDataTag: 622,
        AbbrName: 'EncLegSecDescLen',
        Tag: 621,
        NotReqXML: 0,
        Name: 'EncodedLegSecurityDescLen',
    },
    {
        Type: 'data',
        Description:
            "Multileg instrument's individual security's EncodedSecurityDesc.\nSee EncodedSecurityDesc (35) field for description",
        added: 'FIX.4.3',
        AbbrName: 'EncLegSecDesc',
        Tag: 622,
        NotReqXML: 0,
        Name: 'EncodedLegSecurityDesc',
    },
    {
        Type: 'float',
        Description: 'The ratio of quantity for this individual leg relative to the entire multileg security.',
        added: 'FIX.4.3',
        AbbrName: 'RatioQty',
        Tag: 623,
        NotReqXML: 0,
        Name: 'LegRatioQty',
    },
    {
        Type: 'char',
        EnumDatatype: 54,
        Description:
            'The side of this individual leg (multileg security).\nSee Side (54) field for description and values',
        added: 'FIX.4.3',
        AbbrName: 'Side',
        Tag: 624,
        NotReqXML: 0,
        Name: 'LegSide',
    },
    {
        Type: 'String',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Optional market assigned sub identifier for a trading phase within a trading session. Usage is determined by market or counterparties. Used by US based futures markets to identify exchange specific execution time bracket codes as required by US market regulations. Bilaterally agreed values of data type "String" that start with a character can be used for backward compatibility',
        added: 'FIX.4.3',
        AbbrName: 'SesSub',
        Tag: 625,
        NotReqXML: 0,
        Name: 'TradingSessionSubID',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'int',
        Description:
            'Describes the specific type or purpose of an Allocation message (i.e. "Buyside Calculated")\n(see Volume : "Glossary" for value definitions)\n*** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'Typ',
        AbbrName: 'AllocType',
        Tag: 626,
        NotReqXML: 0,
        Name: 'AllocType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of HopCompID entries in repeating group.',
        added: 'FIX.4.3',
        AbbrName: 'NoHops',
        Tag: 627,
        NotReqXML: 1,
        Name: 'NoHops',
    },
    {
        Type: 'String',
        Description:
            'Assigned value used to identify the third party firm which delivered a specific message either from the firm which originated the message or from another third party (if multiple "hops" are performed). It is recommended that this value be the SenderCompID (49) of the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
        added: 'FIX.4.3',
        AbbrName: 'ID',
        Tag: 628,
        NotReqXML: 0,
        Name: 'HopCompID',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Time that HopCompID (628) sent the message. It is recommended that this value be the SendingTime (52) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
        added: 'FIX.4.3',
        AbbrName: 'Snt',
        Tag: 629,
        NotReqXML: 0,
        Name: 'HopSendingTime',
    },
    {
        Type: 'SeqNum',
        Description:
            'Reference identifier assigned by HopCompID (628) associated with the message sent. It is recommended that this value be the MsgSeqNum (34) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
        added: 'FIX.4.3',
        AbbrName: 'Ref',
        Tag: 630,
        NotReqXML: 0,
        Name: 'HopRefID',
    },
    {
        Type: 'Price',
        Description: 'Mid price/rate',
        added: 'FIX.4.3',
        AbbrName: 'MidPx',
        Tag: 631,
        NotReqXML: 0,
        Name: 'MidPx',
    },
    {
        Type: 'Percentage',
        Description: 'Bid yield',
        added: 'FIX.4.3',
        AbbrName: 'BidYld',
        Tag: 632,
        NotReqXML: 0,
        Name: 'BidYield',
    },
    {
        Type: 'Percentage',
        Description: 'Mid yield',
        added: 'FIX.4.3',
        AbbrName: 'MidYld',
        Tag: 633,
        NotReqXML: 0,
        Name: 'MidYield',
    },
    {
        Type: 'Percentage',
        Description: 'Offer yield',
        added: 'FIX.4.3',
        AbbrName: 'OfrYld',
        Tag: 634,
        NotReqXML: 0,
        Name: 'OfferYield',
    },
    {
        Type: 'String',
        Description:
            'Indicates type of fee being assessed of the customer for trade executions at an exchange. Applicable for futures markets only at this time.\n(Values source CBOT, CME, NYBOT, and NYMEX):',
        added: 'FIX.4.3',
        AbbrName: 'ClrFeeInd',
        Tag: 635,
        NotReqXML: 0,
        Name: 'ClearingFeeIndicator',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates if the order is currently being worked. Applicable only for OrdStatus = "New". For open outcry markets this indicates that the order is being worked in the crowd. For electronic markets it indicates that the order has transitioned from a contingent order to a market order.',
        added: 'FIX.4.3',
        AbbrName: 'WorkingInd',
        Tag: 636,
        NotReqXML: 0,
        Name: 'WorkingIndicator',
    },
    {
        Type: 'Price',
        Description:
            'Execution price assigned to a leg of a multileg instrument.\nSee LastPx (31) field for description and values',
        added: 'FIX.4.3',
        AbbrName: 'LastPx',
        Tag: 637,
        NotReqXML: 0,
        Name: 'LegLastPx',
    },
    {
        Type: 'int',
        Description: 'Indicates if a Cancel/Replace has caused an order to lose book priority.',
        added: 'FIX.4.3',
        AbbrName: 'PriInd',
        Tag: 638,
        NotReqXML: 0,
        Name: 'PriorityIndicator',
    },
    {
        Type: 'PriceOffset',
        Description: 'Amount of price improvement.',
        added: 'FIX.4.3',
        AbbrName: 'PxImprvmnt',
        Tag: 639,
        NotReqXML: 0,
        Name: 'PriceImprovement',
    },
    {
        Type: 'Price',
        Description: 'Price of the future part of a F/X swap order.\nSee Price (44) for description.',
        added: 'FIX.4.3',
        deprecated: 'FIX.5.0',
        AbbrName: 'Px2',
        Tag: 640,
        NotReqXML: 0,
        Name: 'Price2',
    },
    {
        Type: 'PriceOffset',
        Description:
            'F/X forward points of the future part of a F/X swap order added to LastSpotRate (94). May be a negative value.',
        added: 'FIX.4.3',
        deprecated: 'FIX.5.0',
        AbbrName: 'LastFwdPnts2',
        Tag: 641,
        NotReqXML: 0,
        Name: 'LastForwardPoints2',
    },
    {
        Type: 'PriceOffset',
        Description:
            'Bid F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
        added: 'FIX.4.3',
        deprecated: 'FIX.5.0',
        AbbrName: 'BidFwdPnts2',
        Tag: 642,
        NotReqXML: 0,
        Name: 'BidForwardPoints2',
    },
    {
        Type: 'PriceOffset',
        Description:
            'Offer F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
        added: 'FIX.4.3',
        deprecated: 'FIX.5.0',
        AbbrName: 'OfrFwdPnts2',
        Tag: 643,
        NotReqXML: 0,
        Name: 'OfferForwardPoints2',
    },
    {
        Type: 'String',
        Description: 'RFQ Request ID - used to identify an RFQ Request.',
        added: 'FIX.4.3',
        AbbrName: 'RFQReqID',
        Tag: 644,
        NotReqXML: 0,
        Name: 'RFQReqID',
    },
    {
        Type: 'Price',
        Description: 'Used to indicate the best bid in a market',
        added: 'FIX.4.3',
        AbbrName: 'MktBidPx',
        Tag: 645,
        NotReqXML: 0,
        Name: 'MktBidPx',
    },
    {
        Type: 'Price',
        Description: 'Used to indicate the best offer in a market',
        added: 'FIX.4.3',
        AbbrName: 'MktOfrPx',
        Tag: 646,
        NotReqXML: 0,
        Name: 'MktOfferPx',
    },
    {
        Type: 'Qty',
        Description:
            'Used to indicate a minimum quantity for a bid. If this field is used the BidSize (134) field is interpreted as the maximum bid size',
        added: 'FIX.4.3',
        AbbrName: 'MinBidSz',
        Tag: 647,
        NotReqXML: 0,
        Name: 'MinBidSize',
    },
    {
        Type: 'Qty',
        Description:
            'Used to indicate a minimum quantity for an offer. If this field is used the OfferSize (135) field is interpreted as the maximum offer size.',
        added: 'FIX.4.3',
        AbbrName: 'MinOfrSz',
        Tag: 648,
        NotReqXML: 0,
        Name: 'MinOfferSize',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for Quote Status Request.',
        added: 'FIX.4.3',
        AbbrName: 'StatReqID',
        Tag: 649,
        NotReqXML: 0,
        Name: 'QuoteStatusReqID',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates that this message is to serve as the final and legal confirmation.',
        added: 'FIX.4.3',
        AbbrName: 'LegalCnfm',
        Tag: 650,
        NotReqXML: 0,
        Name: 'LegalConfirm',
    },
    {
        Type: 'Price',
        Description:
            'The calculated or traded price for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
        added: 'FIX.4.3',
        AbbrName: 'UndLastPx',
        Tag: 651,
        NotReqXML: 0,
        Name: 'UnderlyingLastPx',
    },
    {
        Type: 'Qty',
        Description:
            'The calculated or traded quantity for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
        added: 'FIX.4.3',
        AbbrName: 'UndLastQty',
        Tag: 652,
        NotReqXML: 0,
        Name: 'UnderlyingLastQty',
    },
    {
        Type: 'String',
        Description: 'Unique indicator for a specific leg.',
        added: 'FIX.4.3',
        AbbrName: 'RefID',
        Tag: 654,
        NotReqXML: 0,
        Name: 'LegRefID',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'String',
        Description: 'Unique indicator for a specific leg for the ContraBroker (375).',
        added: 'FIX.4.3',
        BaseCategoryAbbrName: 'LegRefID',
        AbbrName: 'CntraLegRefID',
        Tag: 655,
        NotReqXML: 0,
        Name: 'ContraLegRefID',
    },
    {
        Type: 'float',
        Description:
            'Foreign exchange rate used to compute the bid "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
        added: 'FIX.4.3',
        AbbrName: 'SettlCurrBidFxRt',
        Tag: 656,
        NotReqXML: 0,
        Name: 'SettlCurrBidFxRate',
    },
    {
        Type: 'float',
        Description:
            'Foreign exchange rate used to compute the offer "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
        added: 'FIX.4.3',
        AbbrName: 'SettlCurrOfrFxRt',
        Tag: 657,
        NotReqXML: 0,
        Name: 'SettlCurrOfferFxRate',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason Quote was rejected:',
        added: 'FIX.4.3',
        AbbrName: 'ReqRejRsn',
        Tag: 658,
        NotReqXML: 0,
        Name: 'QuoteRequestRejectReason',
    },
    {
        Type: 'String',
        Description:
            'ID within repeating group of sides which is used to represent this transaction for compliance purposes (e.g. OATS reporting).',
        added: 'FIX.4.3',
        AbbrName: 'SideComplianceID',
        Tag: 659,
        NotReqXML: 0,
        Name: 'SideComplianceID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Used to identify the source of the Account (1) code. This is especially useful if the account is a new account that the Respondent may not have setup yet in their system.',
        added: 'FIX.4.4',
        AbbrName: 'AcctIDSrc',
        Tag: 660,
        NotReqXML: 0,
        Name: 'AcctIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 660,
        Description:
            'Used to identify the source of the AllocAccount (79) code.\nSee AcctIDSource (660) for valid values.',
        added: 'FIX.4.4',
        AbbrName: 'ActIDSrc',
        Tag: 661,
        NotReqXML: 0,
        Name: 'AllocAcctIDSource',
    },
    {
        Type: 'Price',
        Description: 'Specifies the price of the benchmark.',
        added: 'FIX.4.4',
        AbbrName: 'Px',
        Tag: 662,
        NotReqXML: 0,
        Name: 'BenchmarkPrice',
    },
    {
        Type: 'int',
        EnumDatatype: 423,
        Description: 'Identifies type of BenchmarkPrice (662).\nSee PriceType (423) for valid values.',
        added: 'FIX.4.4',
        AbbrName: 'PxTyp',
        Tag: 663,
        NotReqXML: 0,
        Name: 'BenchmarkPriceType',
    },
    {
        Type: 'String',
        Description: 'Message reference for Confirmation',
        added: 'FIX.4.4',
        AbbrName: 'CnfmID',
        Tag: 664,
        NotReqXML: 0,
        Name: 'ConfirmID',
    },
    {
        Type: 'int',
        Description: 'Identifies the status of the Confirmation.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmStat',
        Tag: 665,
        NotReqXML: 0,
        Name: 'ConfirmStatus',
    },
    {
        Type: 'int',
        Description: 'Identifies the Confirmation transaction type.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmTransTyp',
        Tag: 666,
        NotReqXML: 0,
        Name: 'ConfirmTransType',
    },
    {
        Type: 'MonthYear',
        Description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
        added: 'FIX.4.4',
        AbbrName: 'CSetMo',
        Tag: 667,
        NotReqXML: 0,
        Name: 'ContractSettlMonth',
    },
    {
        Type: 'int',
        Description: 'Identifies the form of delivery.',
        added: 'FIX.4.4',
        AbbrName: 'DlvryForm',
        Tag: 668,
        NotReqXML: 0,
        Name: 'DeliveryForm',
    },
    {
        Type: 'Price',
        Description:
            'Last price expressed in percent-of-par. Conditionally required for Fixed Income trades when LastPx (31) is expressed in Yield, Spread, Discount or any other type.\nUsage: Execution Report and Allocation Report repeating executions block (from sellside).',
        added: 'FIX.4.4',
        AbbrName: 'LastParPx',
        Tag: 669,
        NotReqXML: 0,
        Name: 'LastParPx',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Allocations for the leg',
        added: 'FIX.4.4',
        AbbrName: 'NoLegAllocs',
        Tag: 670,
        NotReqXML: 1,
        Name: 'NoLegAllocs',
    },
    {
        Type: 'String',
        Description: 'Allocation Account for the leg\nSee AllocAccount (79) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'AllocAcct',
        Tag: 671,
        NotReqXML: 0,
        Name: 'LegAllocAccount',
    },
    {
        Type: 'String',
        Description:
            'Reference for the individual allocation ticket\nSee IndividualAllocID (467) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'IndAllocID',
        Tag: 672,
        NotReqXML: 0,
        Name: 'LegIndividualAllocID',
    },
    {
        Type: 'Qty',
        Description: 'Leg allocation quantity.\nSee AllocQty (80) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'AllocQty',
        Tag: 673,
        NotReqXML: 0,
        Name: 'LegAllocQty',
    },
    {
        Type: 'String',
        Description:
            'The source of the LegAllocAccount (671)\nSee AllocAcctIDSource (661) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'AllocAcctIDSrc',
        Tag: 674,
        NotReqXML: 0,
        Name: 'LegAllocAcctIDSource',
    },
    {
        Type: 'Currency',
        Description:
            'Identifies settlement currency for the Leg.\nSee SettlCurrency (20) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'SettlCcy',
        Tag: 675,
        NotReqXML: 0,
        Name: 'LegSettlCurrency',
    },
    {
        Type: 'Currency',
        Description:
            'LegBenchmarkPrice (679) currency\nSee BenchmarkCurveCurrency (220) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Ccy',
        Tag: 676,
        NotReqXML: 0,
        Name: 'LegBenchmarkCurveCurrency',
    },
    {
        Type: 'String',
        EnumDatatype: 221,
        Description: 'Name of the Leg Benchmark Curve.\nSee BenchmarkCurveName (22) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Name',
        Tag: 677,
        NotReqXML: 0,
        Name: 'LegBenchmarkCurveName',
    },
    {
        Type: 'String',
        Description:
            'Identifies the point on the Leg Benchmark Curve.\nSee BenchmarkCurvePoint (222) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Point',
        Tag: 678,
        NotReqXML: 0,
        Name: 'LegBenchmarkCurvePoint',
    },
    {
        Type: 'Price',
        Description:
            'Used to identify the price of the benchmark security.\nSee BenchmarkPrice (662) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Px',
        Tag: 679,
        NotReqXML: 0,
        Name: 'LegBenchmarkPrice',
    },
    {
        Type: 'int',
        Description:
            'The price type of the LegBenchmarkPrice.\nSee BenchmarkPriceType (663) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'PxTyp',
        Tag: 680,
        NotReqXML: 0,
        Name: 'LegBenchmarkPriceType',
    },
    {
        Type: 'Price',
        Description: 'Bid price of this leg.\nSee BidPx (32) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'BidPx',
        Tag: 681,
        NotReqXML: 0,
        Name: 'LegBidPx',
    },
    {
        Type: 'String',
        EnumDatatype: 27,
        UnionDataType: 'Qty',
        Description: 'Leg-specific IOI quantity.\nSee IOIQty (27) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'IOIQty',
        Tag: 682,
        NotReqXML: 0,
        Name: 'LegIOIQty',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of leg stipulation entries',
        added: 'FIX.4.4',
        AbbrName: 'NoLegStips',
        Tag: 683,
        NotReqXML: 1,
        Name: 'NoLegStipulations',
    },
    {
        Type: 'Price',
        Description: 'Offer price of this leg.\nSee OfferPx (133) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'OfrPx',
        Tag: 684,
        NotReqXML: 0,
        Name: 'LegOfferPx',
    },
    {
        Type: 'Qty',
        Description: 'Quantity ordered of this leg.\nSee OrderQty (38) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'OrdQty',
        Tag: 685,
        NotReqXML: 0,
        Name: 'LegOrderQty',
    },
    {
        Type: 'int',
        EnumDatatype: 423,
        Description:
            'The price type of the LegBidPx (681) and/or LegOfferPx (684).\nSee PriceType (423) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'PxTyp',
        Tag: 686,
        NotReqXML: 0,
        Name: 'LegPriceType',
    },
    {
        Type: 'Qty',
        Description: 'Quantity of this leg, e.g. in Quote dialog.\nSee Quantity (53) for description and valid values',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0SP1',
        AbbrName: 'Qty',
        Tag: 687,
        NotReqXML: 0,
        Name: 'LegQty',
    },
    {
        Type: 'String',
        EnumDatatype: 233,
        Description:
            'For Fixed Income, type of Stipulation for this leg.\nSee StipulationType (233) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'StipTyp',
        Tag: 688,
        NotReqXML: 0,
        Name: 'LegStipulationType',
    },
    {
        Type: 'String',
        Description:
            'For Fixed Income, value of stipulation.\nSee StipulationValue (234) for description and valid values',
        added: 'FIX.4.4',
        AbbrName: 'StipVal',
        Tag: 689,
        NotReqXML: 0,
        Name: 'LegStipulationValue',
    },
    {
        Type: 'int',
        Description:
            'For Fixed Income, used instead of LegQty (687) or LegOrderQty (685) to requests the respondent to calculate the quantity based on the quantity on the opposite side of the swap.',
        added: 'FIX.4.4',
        AbbrName: 'SwapTyp',
        Tag: 690,
        NotReqXML: 0,
        Name: 'LegSwapType',
    },
    {
        Type: 'String',
        Description: 'For Fixed Income, identifies MBS / ABS pool.',
        added: 'FIX.4.4',
        AbbrName: 'Pool',
        Tag: 691,
        NotReqXML: 0,
        Name: 'Pool',
    },
    {
        Type: 'int',
        Description:
            'Code to represent price type requested in Quote.\nIf the Quote Request is for a Swap values 1-8 apply to all legs.',
        added: 'FIX.4.4',
        AbbrName: 'QuotPxTyp',
        Tag: 692,
        NotReqXML: 0,
        Name: 'QuotePriceType',
    },
    {
        Type: 'String',
        Description: 'Message reference for Quote Response',
        added: 'FIX.4.4',
        AbbrName: 'RspID',
        Tag: 693,
        NotReqXML: 0,
        Name: 'QuoteRespID',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of Quote Response.',
        added: 'FIX.4.4',
        AbbrName: 'RspTyp',
        Tag: 694,
        NotReqXML: 0,
        Name: 'QuoteRespType',
    },
    {
        Type: 'char',
        EnumDatatype: 104,
        Description: 'Code to qualify Quote use\nSee IOIQualifier (104) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Qual',
        Tag: 695,
        NotReqXML: 0,
        Name: 'QuoteQualifier',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Date to which the yield has been calculated (i.e. maturity, par call or current call, pre-refunded date).',
        added: 'FIX.4.4',
        AbbrName: 'RedDt',
        Tag: 696,
        NotReqXML: 0,
        Name: 'YieldRedemptionDate',
    },
    {
        Type: 'Price',
        Description: 'Price to which the yield has been calculated.',
        added: 'FIX.4.4',
        AbbrName: 'RedPx',
        Tag: 697,
        NotReqXML: 0,
        Name: 'YieldRedemptionPrice',
    },
    {
        Type: 'int',
        EnumDatatype: 423,
        Description:
            'The price type of the YieldRedemptionPrice (697)\nSee PriceType (423) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'RedPxTyp',
        Tag: 698,
        NotReqXML: 0,
        Name: 'YieldRedemptionPriceType',
    },
    {
        Type: 'String',
        Description:
            'The identifier of the benchmark security, e.g. Treasury against Corporate bond.\nSee SecurityID (tag 48) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'SecID',
        Tag: 699,
        NotReqXML: 0,
        Name: 'BenchmarkSecurityID',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates a trade that reverses a previous trade.',
        added: 'FIX.4.4',
        AbbrName: 'ReversalInd',
        Tag: 700,
        NotReqXML: 0,
        Name: 'ReversalIndicator',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Include as needed to clarify yield irregularities associated with date, e.g. when it falls on a non-business day.',
        added: 'FIX.4.4',
        AbbrName: 'CalcDt',
        Tag: 701,
        NotReqXML: 0,
        Name: 'YieldCalcDate',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of position entries.',
        added: 'FIX.4.4',
        AbbrName: 'NoPoss',
        Tag: 702,
        NotReqXML: 1,
        Name: 'NoPositions',
    },
    {
        Type: 'String',
        Description: 'Used to identify the type of quantity that is being returned.',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 703,
        NotReqXML: 0,
        Name: 'PosType',
    },
    {
        Type: 'Qty',
        Description: 'Long Quantity',
        added: 'FIX.4.4',
        AbbrName: 'Long',
        Tag: 704,
        NotReqXML: 0,
        Name: 'LongQty',
    },
    {
        Type: 'Qty',
        Description: 'Short Quantity',
        added: 'FIX.4.4',
        AbbrName: 'Short',
        Tag: 705,
        NotReqXML: 0,
        Name: 'ShortQty',
    },
    {
        Type: 'int',
        Description: 'Status of this position.',
        added: 'FIX.4.4',
        AbbrName: 'Stat',
        Tag: 706,
        NotReqXML: 0,
        Name: 'PosQtyStatus',
    },
    {
        Type: 'String',
        Description: 'Type of Position amount',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 707,
        NotReqXML: 0,
        Name: 'PosAmtType',
    },
    {
        Type: 'Amt',
        Description: 'Position amount',
        added: 'FIX.4.4',
        AbbrName: 'Amt',
        Tag: 708,
        NotReqXML: 0,
        Name: 'PosAmt',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of position transaction',
        added: 'FIX.4.4',
        AbbrName: 'TxnTyp',
        Tag: 709,
        NotReqXML: 0,
        Name: 'PosTransType',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for the position maintenance request as assigned by the submitter',
        added: 'FIX.4.4',
        AbbrName: 'ReqID',
        Tag: 710,
        NotReqXML: 0,
        Name: 'PosReqID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of underlying legs that make up the security.',
        added: 'FIX.4.4',
        AbbrName: 'NoUnds',
        Tag: 711,
        NotReqXML: 1,
        Name: 'NoUnderlyings',
    },
    {
        Type: 'int',
        Description: 'Maintenance Action to be performed.',
        added: 'FIX.4.4',
        AbbrName: 'Actn',
        Tag: 712,
        NotReqXML: 0,
        Name: 'PosMaintAction',
    },
    {
        BaseCategory: 'PositionMaintenance',
        Type: 'String',
        Description:
            'Reference to the PosReqID (710) of a previous maintenance request that is being replaced or canceled.',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'OrigReqRefID',
        AbbrName: 'OrigPosReqRefID',
        Tag: 713,
        NotReqXML: 0,
        Name: 'OrigPosReqRefID',
    },
    {
        Type: 'String',
        Description:
            'Reference to a PosMaintRptID (721) from a previous Position Maintenance Report that is being replaced or canceled.',
        added: 'FIX.4.4',
        AbbrName: 'RptRefID',
        Tag: 714,
        NotReqXML: 0,
        Name: 'PosMaintRptRefID',
    },
    {
        Type: 'LocalMktDate',
        Description: 'The "Clearing Business Date" referred to by this maintenance request.',
        added: 'FIX.4.4',
        AbbrName: 'BizDt',
        Tag: 715,
        NotReqXML: 0,
        Name: 'ClearingBusinessDate',
    },
    {
        Type: 'String',
        Description: 'Identifies a specific settlement session',
        added: 'FIX.4.4',
        AbbrName: 'SetSesID',
        Tag: 716,
        NotReqXML: 0,
        Name: 'SettlSessID',
    },
    {
        Type: 'String',
        Description: 'SubID value associated with SettlSessID(716)',
        added: 'FIX.4.4',
        AbbrName: 'SetSesSub',
        Tag: 717,
        NotReqXML: 0,
        Name: 'SettlSessSubID',
    },
    {
        Type: 'int',
        Description: 'Type of adjustment to be applied, used for PCS and PAJ',
        added: 'FIX.4.4',
        AbbrName: 'AdjTyp',
        Tag: 718,
        NotReqXML: 0,
        Name: 'AdjustmentType',
    },
    {
        BaseCategory: 'SingleGeneralOrderHandling',
        Type: 'Boolean',
        Description: 'Used to indicate when a contrary instruction for exercise or abandonment is being submitted',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'InstrctnInd',
        AbbrName: 'CntraryInstrctnInd',
        Tag: 719,
        NotReqXML: 0,
        Name: 'ContraryInstructionIndicator',
    },
    {
        Type: 'Boolean',
        Description: "Indicates if requesting a rollover of prior day's spread submissions.",
        added: 'FIX.4.4',
        AbbrName: 'PriorSpreadInd',
        Tag: 720,
        NotReqXML: 0,
        Name: 'PriorSpreadIndicator',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for this position report',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        Tag: 721,
        NotReqXML: 0,
        Name: 'PosMaintRptID',
    },
    {
        Type: 'int',
        Description: 'Status of Position Maintenance Request',
        added: 'FIX.4.4',
        AbbrName: 'Stat',
        Tag: 722,
        NotReqXML: 0,
        Name: 'PosMaintStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Result of Position Maintenance Request.\n4000+ Reserved and available for bi-laterally agreed upon user-defined values',
        added: 'FIX.4.4',
        AbbrName: 'Rslt',
        Tag: 723,
        NotReqXML: 0,
        Name: 'PosMaintResult',
    },
    {
        Type: 'int',
        Description: 'Used to specify the type of position request being made.',
        added: 'FIX.4.4',
        AbbrName: 'ReqTyp',
        Tag: 724,
        NotReqXML: 0,
        Name: 'PosReqType',
    },
    {
        Type: 'int',
        Description:
            'Identifies how the response to the request should be transmitted.\nDetails specified via ResponseDestination (726).',
        added: 'FIX.4.4',
        AbbrName: 'RspTransportTyp',
        Tag: 725,
        NotReqXML: 0,
        Name: 'ResponseTransportType',
    },
    {
        Type: 'String',
        Description:
            'URI (Uniform Resource Identifier) for details) or other pre-arranged value. Used in conjunction with ResponseTransportType (725) value of Out-of-Band to identify the out-of-band destination.\nSee "Appendix 6-B FIX Fields Based Upon Other Standards"',
        added: 'FIX.4.4',
        AbbrName: 'RspDest',
        Tag: 726,
        NotReqXML: 0,
        Name: 'ResponseDestination',
    },
    {
        Type: 'int',
        Description: 'Total number of Position Reports being returned.',
        added: 'FIX.4.4',
        AbbrName: 'TotRpts',
        Tag: 727,
        NotReqXML: 0,
        Name: 'TotalNumPosReports',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Result of Request for Position\n4000+ Reserved and available for bi-laterally agreed upon user-defined values',
        added: 'FIX.4.4',
        AbbrName: 'Rslt',
        Tag: 728,
        NotReqXML: 0,
        Name: 'PosReqResult',
    },
    {
        Type: 'int',
        Description: 'Status of Request for Positions',
        added: 'FIX.4.4',
        AbbrName: 'Stat',
        Tag: 729,
        NotReqXML: 0,
        Name: 'PosReqStatus',
    },
    {
        Type: 'Price',
        Description: 'Settlement price',
        added: 'FIX.4.4',
        AbbrName: 'SetPx',
        Tag: 730,
        NotReqXML: 0,
        Name: 'SettlPrice',
    },
    {
        Type: 'int',
        Description: 'Type of settlement price',
        added: 'FIX.4.4',
        AbbrName: 'SetPxTyp',
        Tag: 731,
        NotReqXML: 0,
        Name: 'SettlPriceType',
    },
    {
        Type: 'Price',
        Description: "Underlying security's SettlPrice.\nSee SettlPrice (730) field for description",
        added: 'FIX.4.4',
        AbbrName: 'UndSetPx',
        Tag: 732,
        NotReqXML: 0,
        Name: 'UnderlyingSettlPrice',
    },
    {
        Type: 'int',
        EnumDatatype: 731,
        Description: "Underlying security's SettlPriceType.\nSee SettlPriceType (731) field for description",
        added: 'FIX.4.4',
        AbbrName: 'UndSetPxTyp',
        Tag: 733,
        NotReqXML: 0,
        Name: 'UnderlyingSettlPriceType',
    },
    {
        Type: 'Price',
        Description: 'Previous settlement price',
        added: 'FIX.4.4',
        AbbrName: 'PriSetPx',
        Tag: 734,
        NotReqXML: 0,
        Name: 'PriorSettlPrice',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating groups of QuoteQualifiers (695).',
        added: 'FIX.4.4',
        AbbrName: 'NoQuotQuals',
        Tag: 735,
        NotReqXML: 1,
        Name: 'NoQuoteQualifiers',
    },
    {
        Type: 'Currency',
        Description: 'Currency code of settlement denomination for a specific AllocAccount (79).',
        added: 'FIX.4.4',
        AbbrName: 'AllocSettlCcy',
        Tag: 736,
        NotReqXML: 0,
        Name: 'AllocSettlCurrency',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'Amt',
        Description:
            'Total amount due expressed in settlement currency (includes the effect of the forex transaction) for a specific AllocAccount (79).',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'SettlCcyAmt',
        AbbrName: 'AllocSettlCurrAmt',
        Tag: 737,
        NotReqXML: 0,
        Name: 'AllocSettlCurrAmt',
    },
    {
        Type: 'Amt',
        Description: 'Amount of interest (i.e. lump-sum) at maturity.',
        added: 'FIX.4.4',
        AbbrName: 'IntAtMat',
        Tag: 738,
        NotReqXML: 0,
        Name: 'InterestAtMaturity',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
        added: 'FIX.4.4',
        AbbrName: 'Dated',
        Tag: 739,
        NotReqXML: 0,
        Name: 'LegDatedDate',
    },
    {
        Type: 'String',
        Description:
            'For Fixed Income, identifies MBS / ABS pool for a specific leg of a multi-leg instrument.\nSee Pool (691) for description and valid values.',
        added: 'FIX.4.4',
        AbbrName: 'Pool',
        Tag: 740,
        NotReqXML: 0,
        Name: 'LegPool',
    },
    {
        Type: 'Amt',
        Description: 'Amount of interest (i.e. lump-sum) at maturity at the account-level.',
        added: 'FIX.4.4',
        AbbrName: 'IntAtMat',
        Tag: 741,
        NotReqXML: 0,
        Name: 'AllocInterestAtMaturity',
    },
    {
        Type: 'Amt',
        Description: 'Amount of Accrued Interest for convertible bonds and fixed income at the allocation-level.',
        added: 'FIX.4.4',
        AbbrName: 'AcrdIntAmt',
        Tag: 742,
        NotReqXML: 0,
        Name: 'AllocAccruedInterestAmt',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Date of delivery.',
        added: 'FIX.4.4',
        AbbrName: 'DlvDt',
        Tag: 743,
        NotReqXML: 0,
        Name: 'DeliveryDate',
    },
    {
        Type: 'char',
        Description:
            'Method by which short positions are assigned to an exercise notice during exercise and assignment processing',
        added: 'FIX.4.4',
        AbbrName: 'AsgnMeth',
        Tag: 744,
        NotReqXML: 0,
        Name: 'AssignmentMethod',
    },
    {
        Type: 'Qty',
        Description: 'Quantity Increment used in performing assignment.',
        added: 'FIX.4.4',
        AbbrName: 'Unit',
        Tag: 745,
        NotReqXML: 0,
        Name: 'AssignmentUnit',
    },
    {
        Type: 'Amt',
        Description: 'Open interest that was eligible for assignment.',
        added: 'FIX.4.4',
        AbbrName: 'OpenInt',
        Tag: 746,
        NotReqXML: 0,
        Name: 'OpenInterest',
    },
    {
        Type: 'char',
        Description: 'Exercise Method used to in performing assignment.',
        added: 'FIX.4.4',
        AbbrName: 'ExrMethod',
        Tag: 747,
        NotReqXML: 0,
        Name: 'ExerciseMethod',
    },
    {
        Type: 'int',
        Description: 'Total number of trade reports returned.',
        added: 'FIX.4.4',
        AbbrName: 'TotNumTrdRpts',
        Tag: 748,
        NotReqXML: 0,
        Name: 'TotNumTradeReports',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Result of Trade Request',
        added: 'FIX.4.4',
        AbbrName: 'ReqRslt',
        Tag: 749,
        NotReqXML: 0,
        Name: 'TradeRequestResult',
    },
    {
        Type: 'int',
        Description: 'Status of Trade Request.',
        added: 'FIX.4.4',
        AbbrName: 'ReqStat',
        Tag: 750,
        NotReqXML: 0,
        Name: 'TradeRequestStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Reason Trade Capture Request was rejected.\n100+ Reserved and available for bi-laterally agreed upon user-defined values',
        added: 'FIX.4.4',
        AbbrName: 'RejRsn',
        Tag: 751,
        NotReqXML: 0,
        Name: 'TradeReportRejectReason',
    },
    {
        Type: 'int',
        Description:
            'Used to indicate if the side being reported on Trade Capture Report represents a leg of a multileg instrument or a single security.',
        added: 'FIX.4.4',
        AbbrName: 'MLegRptTyp',
        Tag: 752,
        NotReqXML: 0,
        Name: 'SideMultiLegReportingType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of position amount entries.',
        added: 'FIX.4.4',
        AbbrName: 'NoPosAmt',
        Tag: 753,
        NotReqXML: 1,
        Name: 'NoPosAmt',
    },
    {
        Type: 'Boolean',
        Description:
            'Identifies whether or not an allocation has been automatically accepted on behalf of the Carry Firm by the Clearing House.',
        added: 'FIX.4.4',
        AbbrName: 'AutoAcceptInd',
        Tag: 754,
        NotReqXML: 0,
        Name: 'AutoAcceptIndicator',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for Allocation Report message.',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        Tag: 755,
        NotReqXML: 0,
        Name: 'AllocReportID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Nested2PartyID (757), Nested2PartyIDSource (758), and Nested2PartyRole (759) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoNst2PtyIDs',
        Tag: 756,
        NotReqXML: 1,
        Name: 'NoNested2PartyIDs',
    },
    {
        Type: 'String',
        Description: 'PartyID value within a "second instance" Nested repeating group.\nSame values as PartyID (448)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 757,
        NotReqXML: 0,
        Name: 'Nested2PartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description:
            'PartyIDSource value within a "second instance" Nested repeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        Tag: 758,
        NotReqXML: 0,
        Name: 'Nested2PartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description:
            'PartyRole value within a "second instance" Nested repeating group.\nSame values as PartyRole (452)',
        added: 'FIX.4.4',
        AbbrName: 'R',
        Tag: 759,
        NotReqXML: 0,
        Name: 'Nested2PartyRole',
    },
    {
        Type: 'String',
        Description:
            'PartySubID value within a "second instance" Nested repeating group.\nSame values as PartySubID (523)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 760,
        NotReqXML: 0,
        Name: 'Nested2PartySubID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            'Identifies class or source of the BenchmarkSecurityID (699) value. Required if BenchmarkSecurityID is specified.\nSame values as the SecurityIDSource (22) field',
        added: 'FIX.4.4',
        AbbrName: 'SecIDSrc',
        Tag: 761,
        NotReqXML: 0,
        Name: 'BenchmarkSecurityIDSource',
    },
    {
        Type: 'String',
        Description:
            'Sub-type qualification/identification of the SecurityType. As an example for SecurityType(167)="REPO", the SecuritySubType="General Collateral" can be used to further specify the type of REPO.\nIf SecuritySubType is used then SecurityType is required.\nFor SecurityType="MLEG" a name of the option or futures strategy name can be specified, such as "Calendar", "Vertical", "Butterfly".',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'SubTyp',
        Tag: 762,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'SecuritySubType',
    },
    {
        Type: 'String',
        Description: "Underlying security's SecuritySubType.\nSee SecuritySubType (762) field for description",
        added: 'FIX.4.4',
        AbbrName: 'SubTyp',
        Tag: 763,
        NotReqXML: 0,
        Name: 'UnderlyingSecuritySubType',
    },
    {
        Type: 'String',
        Description: 'SecuritySubType of the leg instrument.\nSee SecuritySubType (762) field for description',
        added: 'FIX.4.4',
        AbbrName: 'SecSubTyp',
        Tag: 764,
        NotReqXML: 0,
        Name: 'LegSecuritySubType',
    },
    {
        Type: 'Percentage',
        Description:
            'The maximum percentage that execution of one side of a program trade can exceed execution of the other.',
        added: 'FIX.4.4',
        AbbrName: 'AOSPct',
        Tag: 765,
        NotReqXML: 0,
        Name: 'AllowableOneSidednessPct',
    },
    {
        Type: 'Amt',
        Description:
            'The maximum amount that execution of one side of a program trade can exceed execution of the other.',
        added: 'FIX.4.4',
        AbbrName: 'AOSValu',
        Tag: 766,
        NotReqXML: 0,
        Name: 'AllowableOneSidednessValue',
    },
    {
        Type: 'Currency',
        Description:
            'The currency that AllowableOneSidednessValue (766) is expressed in if AllowableOneSidednessValue is used.',
        added: 'FIX.4.4',
        AbbrName: 'AOSCurr',
        Tag: 767,
        NotReqXML: 0,
        Name: 'AllowableOneSidednessCurr',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of TrdRegTimestamp (769) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoTrdRegTmstamps',
        Tag: 768,
        NotReqXML: 1,
        Name: 'NoTrdRegTimestamps',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Traded / Regulatory timestamp value. Use to store time information required by government regulators or self regulatory organizations (such as an exchange or clearing house).',
        added: 'FIX.4.4',
        AbbrName: 'TS',
        Tag: 769,
        NotReqXML: 0,
        Name: 'TrdRegTimestamp',
    },
    {
        Type: 'int',
        Description:
            'Traded / Regulatory timestamp type.\nNote of Applicability: values are required in US futures markets by the CFTC to support computerized trade reconstruction.\n(see Volume : "Glossary" for value definitions)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 770,
        NotReqXML: 0,
        Name: 'TrdRegTimestampType',
    },
    {
        Type: 'String',
        Description:
            'Text which identifies the "origin" (i.e. system which was used to generate the time stamp) for the Traded / Regulatory timestamp value.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'Src',
        Tag: 771,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TrdRegTimestampOrigin',
    },
    {
        Type: 'String',
        Description: 'Reference identifier to be used with ConfirmTransType (666) = Replace or Cancel',
        added: 'FIX.4.4',
        AbbrName: 'CnfmRefID',
        Tag: 772,
        NotReqXML: 0,
        Name: 'ConfirmRefID',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of Confirmation message being sent.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmTyp',
        Tag: 773,
        NotReqXML: 0,
        Name: 'ConfirmType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Identifies the reason for rejecting a Confirmation.',
        added: 'FIX.4.4',
        AbbrName: 'CnfmRejRsn',
        Tag: 774,
        NotReqXML: 0,
        Name: 'ConfirmRejReason',
    },
    {
        Type: 'int',
        Description:
            'Method for booking out this order. Used when notifying a broker that an order to be settled by that broker is to be booked out as an OTC derivative (e.g. CFD or similar).',
        added: 'FIX.4.4',
        AbbrName: 'BkngTyp',
        Tag: 775,
        NotReqXML: 0,
        Name: 'BookingType',
    },
    {
        Type: 'int',
        EnumDatatype: 88,
        Description:
            'Identified reason for rejecting an individual AllocAccount (79) detail.\nSame values as AllocRejCode (88)',
        added: 'FIX.4.4',
        AbbrName: 'IndAllocRejCode',
        Tag: 776,
        NotReqXML: 0,
        Name: 'IndividualAllocRejCode',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for Settlement Instruction message.',
        added: 'FIX.4.4',
        AbbrName: 'SettlInstMsgID',
        Tag: 777,
        NotReqXML: 0,
        Name: 'SettlInstMsgID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of settlement instructions within repeating group.',
        added: 'FIX.4.4',
        AbbrName: 'NoSettlInst',
        Tag: 778,
        NotReqXML: 1,
        Name: 'NoSettlInst',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Timestamp of last update to data item (or creation if no updates made since creation).',
        added: 'FIX.4.4',
        AbbrName: 'LastUpdateTm',
        Tag: 779,
        NotReqXML: 0,
        Name: 'LastUpdateTime',
    },
    {
        Type: 'int',
        Description:
            'Used to indicate whether settlement instructions are provided on an allocation instruction message, and if not, how they are to be derived.',
        added: 'FIX.4.4',
        AbbrName: 'SettlInstTyp',
        Tag: 780,
        NotReqXML: 0,
        Name: 'AllocSettlInstType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of SettlPartyID (782), SettlPartyIDSource (783), and SettlPartyRole (784) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoSettlPtyIDs',
        Tag: 781,
        NotReqXML: 1,
        Name: 'NoSettlPartyIDs',
    },
    {
        Type: 'String',
        Description:
            'PartyID value within a settlement parties component. Nested repeating group.\nSame values as PartyID (448)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 782,
        NotReqXML: 0,
        Name: 'SettlPartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description: 'PartyIDSource value within a settlement parties component.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        Tag: 783,
        NotReqXML: 0,
        Name: 'SettlPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'PartyRole value within a settlement parties component.\nSame values as PartyRole (452)',
        added: 'FIX.4.4',
        AbbrName: 'R',
        Tag: 784,
        NotReqXML: 0,
        Name: 'SettlPartyRole',
    },
    {
        Type: 'String',
        Description: 'PartySubID value within a settlement parties component.\nSame values as PartySubID (523)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 785,
        NotReqXML: 0,
        Name: 'SettlPartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Type of SettlPartySubID (785) value.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 786,
        NotReqXML: 0,
        Name: 'SettlPartySubIDType',
    },
    {
        Type: 'char',
        Description: 'Used to indicate whether a delivery instruction is used for securities or cash settlement.',
        added: 'FIX.4.4',
        AbbrName: 'InstTyp',
        Tag: 787,
        NotReqXML: 0,
        Name: 'DlvyInstType',
    },
    {
        Type: 'int',
        Description: 'Type of financing termination.',
        added: 'FIX.4.4',
        AbbrName: 'TrmTyp',
        Tag: 788,
        NotReqXML: 0,
        Name: 'TerminationType',
    },
    {
        Type: 'SeqNum',
        Description: 'Next expected MsgSeqNum value to be received.',
        added: 'FIX.4.4',
        AbbrName: 'NextExpectedMsgSeqNum',
        Tag: 789,
        NotReqXML: 1,
        Name: 'NextExpectedMsgSeqNum',
    },
    {
        Type: 'String',
        Description: 'Can be used to uniquely identify a specific Order Status Request message.',
        added: 'FIX.4.4',
        AbbrName: 'StatReqID',
        Tag: 790,
        NotReqXML: 0,
        Name: 'OrdStatusReqID',
    },
    {
        Type: 'String',
        Description: 'Unique ID of settlement instruction request message',
        added: 'FIX.4.4',
        AbbrName: 'SettlInstReqID',
        Tag: 791,
        NotReqXML: 0,
        Name: 'SettlInstReqID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Identifies reason for rejection (of a settlement instruction request message).',
        added: 'FIX.4.4',
        AbbrName: 'SettlInstReqRejCode',
        Tag: 792,
        NotReqXML: 0,
        Name: 'SettlInstReqRejCode',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'String',
        Description:
            'Secondary allocation identifier. Unlike the AllocID (70), this can be shared across a number of allocation instruction or allocation report messages, thereby making it possible to pass an identifier for an original allocation message on multiple messages (e.g. from one party to a second to a third, across cancel and replace messages etc.).',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'ID2',
        AbbrName: 'AllocID2',
        Tag: 793,
        NotReqXML: 0,
        Name: 'SecondaryAllocID',
    },
    {
        Type: 'int',
        Description: 'Describes the specific type or purpose of an Allocation Report message',
        added: 'FIX.4.4',
        AbbrName: 'RptTyp',
        Tag: 794,
        NotReqXML: 0,
        Name: 'AllocReportType',
    },
    {
        Type: 'String',
        Description: 'Reference identifier to be used with AllocTransType (7) = Replace or Cancel',
        added: 'FIX.4.4',
        AbbrName: 'RptRefID',
        Tag: 795,
        NotReqXML: 0,
        Name: 'AllocReportRefID',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason for cancelling or replacing an Allocation Instruction or Allocation Report message',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'CxlRplcRsn',
        AbbrName: 'CxlRplcRsn',
        Tag: 796,
        NotReqXML: 0,
        Name: 'AllocCancReplaceReason',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates whether or not this message is a drop copy of another message.',
        added: 'FIX.4.4',
        AbbrName: 'CopyMsgInd',
        Tag: 797,
        NotReqXML: 0,
        Name: 'CopyMsgIndicator',
    },
    {
        Type: 'int',
        Description: 'Type of account associated with a confirmation or other trade-level message',
        added: 'FIX.4.4',
        AbbrName: 'AcctTyp',
        Tag: 798,
        NotReqXML: 0,
        Name: 'AllocAccountType',
    },
    {
        Type: 'Price',
        Description: 'Average price for a specific order',
        added: 'FIX.4.4',
        AbbrName: 'AvgPx',
        Tag: 799,
        NotReqXML: 0,
        Name: 'OrderAvgPx',
    },
    {
        Type: 'Qty',
        Description:
            'Quantity of the order that is being booked out as part of an Allocation Instruction or Allocation Report message',
        added: 'FIX.4.4',
        AbbrName: 'BkngQty',
        Tag: 800,
        NotReqXML: 0,
        Name: 'OrderBookingQty',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of SettlPartySubID (785) and SettlPartySubIDType (786) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoSettlPtySubIDs',
        Tag: 801,
        NotReqXML: 1,
        Name: 'NoSettlPartySubIDs',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of PartySubID (523)and PartySubIDType (803) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoPtySubIDs',
        Tag: 802,
        NotReqXML: 1,
        Name: 'NoPartySubIDs',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved4000Plus',
        Description:
            'Type of PartySubID (523) value\n4000+ = Reserved and available for bi-laterally agreed upon user defined values',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 803,
        NotReqXML: 0,
        Name: 'PartySubIDType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of NestedPartySubID (545) and NestedPartySubIDType (805) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoNstPtySubIDs',
        Tag: 804,
        NotReqXML: 1,
        Name: 'NoNestedPartySubIDs',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Type of NestedPartySubID (545) value.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 805,
        NotReqXML: 0,
        Name: 'NestedPartySubIDType',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of Nested2PartySubID (760) and Nested2PartySubIDType (807) entries. Second instance of <NestedParties>.',
        added: 'FIX.4.4',
        AbbrName: 'NoNst2PtySubIDs',
        Tag: 806,
        NotReqXML: 1,
        Name: 'NoNested2PartySubIDs',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description:
            'Type of Nested2PartySubID (760) value. Second instance of <NestedParties>.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 807,
        NotReqXML: 0,
        Name: 'Nested2PartySubIDType',
    },
    {
        BaseCategory: 'Allocation',
        Type: 'int',
        Description:
            'Response to allocation to be communicated to a counterparty through an intermediary, i.e. clearing house. Used in conjunction with AllocType = "Request to Intermediary" and AllocReportType = "Request to Intermediary"',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'ImReqTyp',
        AbbrName: 'IntermedReqTyp',
        Tag: 808,
        NotReqXML: 0,
        Name: 'AllocIntermedReqType',
    },
    {
        Type: 'Price',
        Description: 'Underlying price associate with a derivative instrument.',
        added: 'FIX.4.4',
        AbbrName: 'Px',
        Tag: 810,
        NotReqXML: 0,
        Name: 'UnderlyingPx',
    },
    {
        Type: 'float',
        Description:
            'The rate of change in the price of a derivative with respect to the movement in the price of the underlying instrument(s) upon which the derivative instrument price is based.\nThis value is normally between -1.0 and 1.0.',
        added: 'FIX.4.4',
        AbbrName: 'PxDelta',
        Tag: 811,
        NotReqXML: 0,
        Name: 'PriceDelta',
    },
    {
        Type: 'int',
        Description:
            'Used to specify the maximum number of application messages that can be queued bedore a corrective action needs to take place to resolve the queuing issue.',
        added: 'FIX.4.4',
        AbbrName: 'ApplQuMax',
        Tag: 812,
        NotReqXML: 0,
        Name: 'ApplQueueMax',
    },
    {
        Type: 'int',
        Description:
            'Current number of application messages that were queued at the time that the message was created by the counterparty.',
        added: 'FIX.4.4',
        AbbrName: 'ApplQuDepth',
        Tag: 813,
        NotReqXML: 0,
        Name: 'ApplQueueDepth',
    },
    {
        Type: 'int',
        Description:
            'Resolution taken when ApplQueueDepth (813) exceeds ApplQueueMax (812) or system specified maximum queue size.',
        added: 'FIX.4.4',
        AbbrName: 'ApplQuResolution',
        Tag: 814,
        NotReqXML: 0,
        Name: 'ApplQueueResolution',
    },
    {
        Type: 'int',
        Description: 'Action to take to resolve an application message queue (backlog).',
        added: 'FIX.4.4',
        AbbrName: 'ApplQuActn',
        Tag: 815,
        NotReqXML: 0,
        Name: 'ApplQueueAction',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of alternative market data sources',
        added: 'FIX.4.4',
        AbbrName: 'NoAltMDSrc',
        Tag: 816,
        NotReqXML: 1,
        Name: 'NoAltMDSource',
    },
    {
        Type: 'String',
        Description:
            'Session layer source for market data\n(For the standard FIX session layer, this would be the TargetCompID (56) where market data can be obtained).',
        added: 'FIX.4.4',
        AbbrName: 'AltMDSrcID',
        Tag: 817,
        NotReqXML: 0,
        Name: 'AltMDSourceID',
    },
    {
        BaseCategory: 'TradeCapture',
        Type: 'String',
        Description:
            'Secondary trade report identifier - can be used to associate an additional identifier with a trade.',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        BaseCategoryAbbrName: 'RptID2',
        AbbrName: 'TrdRptID2',
        Tag: 818,
        NotReqXML: 0,
        Name: 'SecondaryTradeReportID',
    },
    {
        Type: 'int',
        Description: 'Average Pricing Indicator',
        added: 'FIX.4.4',
        AbbrName: 'AvgPxInd',
        Tag: 819,
        NotReqXML: 0,
        Name: 'AvgPxIndicator',
    },
    {
        BaseCategory: 'TradeCapture',
        Type: 'String',
        Description:
            'Used to link a group of trades together. Useful for linking a group of trades together for average price calculations.',
        added: 'FIX.4.4',
        BaseCategoryAbbrName: 'LinkID',
        AbbrName: 'LinkID',
        Tag: 820,
        NotReqXML: 0,
        Name: 'TradeLinkID',
    },
    {
        Type: 'String',
        Description: 'Specific device number, terminal number or station where order was entered',
        added: 'FIX.4.4',
        AbbrName: 'OrdInptDev',
        Tag: 821,
        NotReqXML: 0,
        Name: 'OrderInputDevice',
    },
    {
        Type: 'String',
        Description: 'Trading Session in which the underlying instrument trades',
        added: 'FIX.4.4',
        AbbrName: 'UndSesID',
        Tag: 822,
        NotReqXML: 0,
        Name: 'UnderlyingTradingSessionID',
    },
    {
        Type: 'String',
        Description: 'Trading Session sub identifier in which the underlying instrument trades',
        added: 'FIX.4.4',
        AbbrName: 'UndSesSub',
        Tag: 823,
        NotReqXML: 0,
        Name: 'UnderlyingTradingSessionSubID',
    },
    {
        Type: 'String',
        Description: 'Reference to the leg of a multileg instrument to which this trade refers',
        added: 'FIX.4.4',
        AbbrName: 'TrdLegRefID',
        Tag: 824,
        NotReqXML: 0,
        Name: 'TradeLegRefID',
    },
    {
        Type: 'String',
        Description:
            'Used to report any exchange rules that apply to this trade.\nPrimarily intended for US futures markets. Certain trading practices are permitted by the CFTC, such as large lot trading, block trading, all or none trades. If the rules are used, the exchanges are required to indicate these rules on the trade.',
        added: 'FIX.4.4',
        AbbrName: 'ExchRule',
        Tag: 825,
        NotReqXML: 0,
        Name: 'ExchangeRule',
    },
    {
        Type: 'int',
        Description: 'Identifies how the trade is to be allocated',
        added: 'FIX.4.4',
        AbbrName: 'AllocInd',
        Tag: 826,
        NotReqXML: 0,
        Name: 'TradeAllocIndicator',
    },
    {
        Type: 'int',
        Description: 'Part of trading cycle when an instrument expires. Field is applicable for derivatives.',
        added: 'FIX.4.4',
        AbbrName: 'ExpirationCycle',
        Tag: 827,
        NotReqXML: 0,
        Name: 'ExpirationCycle',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved1000Plus',
        Description: 'Type of Trade:',
        added: 'FIX.4.4',
        AbbrName: 'TrdTyp',
        Tag: 828,
        NotReqXML: 0,
        Name: 'TrdType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved1000Plus',
        Description: 'Further qualification to the trade type',
        added: 'FIX.4.4',
        AbbrName: 'TrdSubTyp',
        Tag: 829,
        NotReqXML: 0,
        Name: 'TrdSubType',
    },
    {
        Type: 'String',
        Description: 'Reason trade is being transferred',
        added: 'FIX.4.4',
        AbbrName: 'TrnsfrRsn',
        Tag: 830,
        NotReqXML: 0,
        Name: 'TransferReason',
    },
    {
        Type: 'int',
        Description: 'Total Number of Assignment Reports being returned to a firm',
        added: 'FIX.4.4',
        AbbrName: 'TotNumAsgnRpts',
        Tag: 832,
        NotReqXML: 0,
        Name: 'TotNumAssignmentReports',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for the Assignment Report',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        Tag: 833,
        NotReqXML: 0,
        Name: 'AsgnRptID',
    },
    {
        Type: 'PriceOffset',
        Description: 'Amount that a position has to be in the money before it is exercised.',
        added: 'FIX.4.4',
        AbbrName: 'ThresholdAmt',
        Tag: 834,
        NotReqXML: 0,
        Name: 'ThresholdAmount',
    },
    {
        Type: 'int',
        Description: 'Describes whether peg is static or floats',
        added: 'FIX.4.4',
        AbbrName: 'MoveTyp',
        Tag: 835,
        NotReqXML: 0,
        Name: 'PegMoveType',
    },
    {
        Type: 'int',
        Description: 'Type of Peg Offset value',
        added: 'FIX.4.4',
        AbbrName: 'OfstTyp',
        Tag: 836,
        NotReqXML: 0,
        Name: 'PegOffsetType',
    },
    {
        Type: 'int',
        Description: 'Type of Peg Limit',
        added: 'FIX.4.4',
        AbbrName: 'LmtTyp',
        Tag: 837,
        NotReqXML: 0,
        Name: 'PegLimitType',
    },
    {
        Type: 'int',
        Description:
            'If the calculated peg price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
        added: 'FIX.4.4',
        AbbrName: 'RndDir',
        Tag: 838,
        NotReqXML: 0,
        Name: 'PegRoundDirection',
    },
    {
        Type: 'Price',
        Description: 'The price the order is currently pegged at',
        added: 'FIX.4.4',
        AbbrName: 'PeggedPx',
        Tag: 839,
        NotReqXML: 0,
        Name: 'PeggedPrice',
    },
    {
        Type: 'int',
        Description: 'The scope of the peg',
        added: 'FIX.4.4',
        AbbrName: 'Scope',
        Tag: 840,
        NotReqXML: 0,
        Name: 'PegScope',
    },
    {
        Type: 'int',
        Description: 'Describes whether discretionay price is static or floats',
        added: 'FIX.4.4',
        AbbrName: 'MoveTyp',
        Tag: 841,
        NotReqXML: 0,
        Name: 'DiscretionMoveType',
    },
    {
        Type: 'int',
        Description: 'Type of Discretion Offset value',
        added: 'FIX.4.4',
        AbbrName: 'OfstTyp',
        Tag: 842,
        NotReqXML: 0,
        Name: 'DiscretionOffsetType',
    },
    {
        Type: 'int',
        Description: 'Type of Discretion Limit',
        added: 'FIX.4.4',
        AbbrName: 'LimitTyp',
        Tag: 843,
        NotReqXML: 0,
        Name: 'DiscretionLimitType',
    },
    {
        Type: 'int',
        Description:
            'If the calculated discretionary price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
        added: 'FIX.4.4',
        AbbrName: 'RndDir',
        Tag: 844,
        NotReqXML: 0,
        Name: 'DiscretionRoundDirection',
    },
    {
        Type: 'Price',
        Description: 'The current discretionary price of the order',
        added: 'FIX.4.4',
        AbbrName: 'DsctnPx',
        Tag: 845,
        NotReqXML: 0,
        Name: 'DiscretionPrice',
    },
    {
        Type: 'int',
        Description: 'The scope of the discretion',
        added: 'FIX.4.4',
        AbbrName: 'Scope',
        Tag: 846,
        NotReqXML: 0,
        Name: 'DiscretionScope',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved1000Plus',
        Description:
            'The target strategy of the order\n1000+ = Reserved and available for bi-laterally agreed upon user defined values',
        added: 'FIX.4.4',
        AbbrName: 'TgtStrategy',
        Tag: 847,
        NotReqXML: 0,
        Name: 'TargetStrategy',
    },
    {
        Type: 'String',
        Description:
            'Field to allow further specification of the TargetStrategy - usage to be agreed between counterparties',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        AbbrName: 'TgtStrategyParameters',
        Tag: 848,
        NotReqXML: 0,
        Name: 'TargetStrategyParameters',
    },
    {
        Type: 'Percentage',
        Description:
            'For a TargetStrategy=Participate order specifies the target particpation rate. For other order types this is a volume limit (i.e. do not be more than this percent of the market volume)',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        AbbrName: 'ParticipationRt',
        Tag: 849,
        NotReqXML: 0,
        Name: 'ParticipationRate',
    },
    {
        Type: 'float',
        Description: 'For communication of the performance of the order versus the target strategy',
        added: 'FIX.4.4',
        AbbrName: 'TgtStrategyPerformance',
        Tag: 850,
        NotReqXML: 0,
        Name: 'TargetStrategyPerformance',
    },
    {
        Type: 'int',
        Description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled.',
        added: 'FIX.4.4',
        AbbrName: 'LastLqdtyInd',
        Tag: 851,
        NotReqXML: 0,
        Name: 'LastLiquidityInd',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates if a trade should be reported via a market reporting service.',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        AbbrName: 'PubTrdInd',
        Tag: 852,
        NotReqXML: 0,
        Name: 'PublishTrdIndicator',
    },
    {
        Type: 'int',
        Description: 'Reason for short sale.',
        added: 'FIX.4.4',
        AbbrName: 'ShrtSaleRsn',
        Tag: 853,
        NotReqXML: 0,
        Name: 'ShortSaleReason',
    },
    {
        Type: 'int',
        Description: 'Type of quantity specified in a quantity field:',
        added: 'FIX.4.4',
        AbbrName: 'QtyTyp',
        Tag: 854,
        NotReqXML: 0,
        Name: 'QtyType',
    },
    {
        Type: 'int',
        EnumDatatype: 828,
        Description: 'Additional TrdType(828) assigned to a trade by trade match system.',
        added: 'FIX.4.4',
        AbbrName: 'TrdTyp2',
        Tag: 855,
        NotReqXML: 0,
        Name: 'SecondaryTrdType',
    },
    {
        Type: 'int',
        Description: 'Type of Trade Report',
        added: 'FIX.4.4',
        AbbrName: 'RptTyp',
        Tag: 856,
        NotReqXML: 0,
        Name: 'TradeReportType',
    },
    {
        Type: 'int',
        Description:
            'Indicates how the orders being booked and allocated by an Allocation Instruction or Allocation Report message are identified, i.e. by explicit definition in the NoOrders group or not.',
        added: 'FIX.4.4',
        AbbrName: 'NoOrdsTyp',
        Tag: 857,
        NotReqXML: 0,
        Name: 'AllocNoOrdersType',
    },
    {
        Type: 'Amt',
        Description:
            'Commission to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
        added: 'FIX.4.4',
        AbbrName: 'SharedComm',
        Tag: 858,
        NotReqXML: 0,
        Name: 'SharedCommission',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a Confirmation Request message',
        added: 'FIX.4.4',
        AbbrName: 'CnfmReqID',
        Tag: 859,
        NotReqXML: 0,
        Name: 'ConfirmReqID',
    },
    {
        Type: 'Price',
        Description:
            'Used to express average price as percent of par (used where AvgPx field is expressed in some other way)',
        added: 'FIX.4.4',
        AbbrName: 'AvgParPx',
        Tag: 860,
        NotReqXML: 0,
        Name: 'AvgParPx',
    },
    {
        Type: 'Price',
        Description:
            'Reported price (used to differentiate from AvgPx on a confirmation of a marked-up or marked-down principal trade)',
        added: 'FIX.4.4',
        AbbrName: 'RptedPx',
        Tag: 861,
        NotReqXML: 0,
        Name: 'ReportedPx',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating OrderCapacity entries.',
        added: 'FIX.4.4',
        AbbrName: 'NoCapacities',
        Tag: 862,
        NotReqXML: 1,
        Name: 'NoCapacities',
    },
    {
        Type: 'Qty',
        Description:
            'Quantity executed under a specific OrderCapacity (e.g. quantity executed as agent, quantity executed as principal)',
        added: 'FIX.4.4',
        AbbrName: 'CpctyQty',
        Tag: 863,
        NotReqXML: 0,
        Name: 'OrderCapacityQty',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating EventType entries.',
        added: 'FIX.4.4',
        AbbrName: 'NoEvents',
        Tag: 864,
        NotReqXML: 1,
        Name: 'NoEvents',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Code to represent the type of event',
        added: 'FIX.4.4',
        AbbrName: 'EventTyp',
        Tag: 865,
        NotReqXML: 0,
        Name: 'EventType',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Date of event',
        added: 'FIX.4.4',
        AbbrName: 'Dt',
        Tag: 866,
        NotReqXML: 0,
        Name: 'EventDate',
    },
    {
        Type: 'Price',
        Description: 'Predetermined price of issue at event, if applicable',
        added: 'FIX.4.4',
        AbbrName: 'Px',
        Tag: 867,
        NotReqXML: 0,
        Name: 'EventPx',
    },
    {
        Type: 'String',
        Description: 'Comments related to the event.',
        added: 'FIX.4.4',
        AbbrName: 'Txt',
        Tag: 868,
        NotReqXML: 0,
        Name: 'EventText',
    },
    {
        Type: 'Percentage',
        Description: 'Percent at risk due to lowest possible call.',
        added: 'FIX.4.4',
        AbbrName: 'PctAtRisk',
        Tag: 869,
        NotReqXML: 0,
        Name: 'PctAtRisk',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of repeating InstrAttribType entries.',
        added: 'FIX.4.4',
        AbbrName: 'NoInstrAttrib',
        Tag: 870,
        NotReqXML: 1,
        Name: 'NoInstrAttrib',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Code to represent the type of instrument attribute',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 871,
        NotReqXML: 0,
        Name: 'InstrAttribType',
    },
    {
        Type: 'String',
        Description: 'Attribute value appropriate to the InstrAttribType (87) field.',
        added: 'FIX.4.4',
        AbbrName: 'Val',
        Tag: 872,
        NotReqXML: 0,
        Name: 'InstrAttribValue',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
        added: 'FIX.4.4',
        AbbrName: 'Dated',
        Tag: 873,
        NotReqXML: 0,
        Name: 'DatedDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
        added: 'FIX.4.4',
        AbbrName: 'IntAcrl',
        Tag: 874,
        NotReqXML: 0,
        Name: 'InterestAccrualDate',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'The program under which a commercial paper is issued',
        added: 'FIX.4.4',
        AbbrName: 'CPPgm',
        Tag: 875,
        NotReqXML: 0,
        Name: 'CPProgram',
    },
    {
        Type: 'String',
        Description: 'The registration type of a commercial paper issuance',
        added: 'FIX.4.4',
        AbbrName: 'CPRegT',
        Tag: 876,
        NotReqXML: 0,
        Name: 'CPRegType',
    },
    {
        Type: 'String',
        Description: 'The program under which the underlying commercial paper is issued',
        added: 'FIX.4.4',
        AbbrName: 'CPPgm',
        Tag: 877,
        NotReqXML: 0,
        Name: 'UnderlyingCPProgram',
    },
    {
        Type: 'String',
        Description: 'The registration type of the underlying commercial paper issuance',
        added: 'FIX.4.4',
        AbbrName: 'CPRegTyp',
        Tag: 878,
        NotReqXML: 0,
        Name: 'UnderlyingCPRegType',
    },
    {
        Type: 'Qty',
        Description: 'Unit amount of the underlying security (par, shares, currency, etc.)',
        added: 'FIX.4.4',
        AbbrName: 'Qty',
        Tag: 879,
        NotReqXML: 0,
        Name: 'UnderlyingQty',
    },
    {
        Type: 'String',
        Description: 'Identifier assigned to a trade by a matching system.',
        added: 'FIX.4.4',
        AbbrName: 'MtchID',
        Tag: 880,
        NotReqXML: 0,
        Name: 'TrdMatchID',
    },
    {
        BaseCategory: 'TradeCapture',
        Type: 'String',
        Description:
            'Used to refer to a previous SecondaryTradeReportRefID when amending the transaction (cancel, replace, release, or reversal).',
        added: 'FIX.4.4',
        deprecated: 'FIX.5.0',
        BaseCategoryAbbrName: 'RptRefID2',
        AbbrName: 'TrdRptRefID2',
        Tag: 881,
        NotReqXML: 0,
        Name: 'SecondaryTradeReportRefID',
    },
    {
        Type: 'Price',
        Description:
            'Price (percent-of-par or per unit) of the underlying security or basket. "Dirty" means it includes accrued interest',
        added: 'FIX.4.4',
        AbbrName: 'DirtPx',
        Tag: 882,
        NotReqXML: 0,
        Name: 'UnderlyingDirtyPrice',
    },
    {
        Type: 'Price',
        Description:
            'Price (percent-of-par or per unit) of the underlying security or basket at the end of the agreement.',
        added: 'FIX.4.4',
        AbbrName: 'EndPx',
        Tag: 883,
        NotReqXML: 0,
        Name: 'UnderlyingEndPrice',
    },
    {
        Type: 'Amt',
        Description: 'Currency value attributed to this collateral at the start of the agreement',
        added: 'FIX.4.4',
        AbbrName: 'StartVal',
        Tag: 884,
        NotReqXML: 0,
        Name: 'UnderlyingStartValue',
    },
    {
        Type: 'Amt',
        Description: 'Currency value currently attributed to this collateral',
        added: 'FIX.4.4',
        AbbrName: 'CurVal',
        Tag: 885,
        NotReqXML: 0,
        Name: 'UnderlyingCurrentValue',
    },
    {
        Type: 'Amt',
        Description: 'Currency value attributed to this collateral at the end of the agreement',
        added: 'FIX.4.4',
        AbbrName: 'EndVal',
        Tag: 886,
        NotReqXML: 0,
        Name: 'UnderlyingEndValue',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of underlying stipulation entries',
        added: 'FIX.4.4',
        AbbrName: 'NoUndStips',
        Tag: 887,
        NotReqXML: 1,
        Name: 'NoUnderlyingStips',
    },
    {
        Type: 'String',
        EnumDatatype: 233,
        Description: 'Type of stipulation.\nSame values as StipulationType (233)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 888,
        NotReqXML: 0,
        Name: 'UnderlyingStipType',
    },
    {
        Type: 'String',
        Description: 'Value of stipulation.\nSame values as StipulationValue (234)',
        added: 'FIX.4.4',
        AbbrName: 'Val',
        Tag: 889,
        NotReqXML: 0,
        Name: 'UnderlyingStipValue',
    },
    {
        Type: 'Amt',
        Description: 'Net Money at maturity if Zero Coupon and maturity value is different from par value',
        added: 'FIX.4.4',
        AbbrName: 'MatNetMny',
        Tag: 890,
        NotReqXML: 0,
        Name: 'MaturityNetMoney',
    },
    {
        Type: 'int',
        Description: 'Defines the unit for a miscellaneous fee.',
        added: 'FIX.4.4',
        AbbrName: 'Basis',
        Tag: 891,
        NotReqXML: 0,
        Name: 'MiscFeeBasis',
    },
    {
        Type: 'int',
        Description:
            'Total number of NoAlloc entries across all messages. Should be the sum of all NoAllocs in each message that has repeating NoAlloc entries related to the same AllocID or AllocReportID. Used to support fragmentation.',
        added: 'FIX.4.4',
        AbbrName: 'TotNoAllocs',
        Tag: 892,
        NotReqXML: 0,
        Name: 'TotNoAllocs',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates whether this message is the last in a sequence of messages for those messages that support fragmentation, such as Allocation Instruction, Mass Quote, Security List, Derivative Security List',
        added: 'FIX.4.4',
        AbbrName: 'LastFragment',
        Tag: 893,
        NotReqXML: 0,
        Name: 'LastFragment',
    },
    {
        Type: 'String',
        Description: 'Collateral Request Identifier',
        added: 'FIX.4.4',
        AbbrName: 'ReqID',
        Tag: 894,
        NotReqXML: 0,
        Name: 'CollReqID',
    },
    {
        Type: 'int',
        Description: 'Reason for Collateral Assignment',
        added: 'FIX.4.4',
        AbbrName: 'AsgnRsn',
        Tag: 895,
        NotReqXML: 0,
        Name: 'CollAsgnReason',
    },
    {
        Type: 'int',
        Description: 'Collateral inquiry qualifiers:',
        added: 'FIX.4.4',
        AbbrName: 'Qual',
        Tag: 896,
        NotReqXML: 0,
        Name: 'CollInquiryQualifier',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of trades in repeating group.',
        added: 'FIX.4.4',
        AbbrName: 'NoTrds',
        Tag: 897,
        NotReqXML: 1,
        Name: 'NoTrades',
    },
    {
        Type: 'Percentage',
        Description:
            'The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 02% indicates that the value of the collateral (after deducting for "haircut") must exceed the cash consideration by 2%.',
        added: 'FIX.4.4',
        AbbrName: 'MgnRatio',
        Tag: 898,
        NotReqXML: 0,
        Name: 'MarginRatio',
    },
    {
        Type: 'Amt',
        Description: 'Excess margin amount (deficit if value is negative)',
        added: 'FIX.4.4',
        AbbrName: 'MgnExcess',
        Tag: 899,
        NotReqXML: 0,
        Name: 'MarginExcess',
    },
    {
        Type: 'Amt',
        Description:
            'TotalNetValue is determined as follows:\nAt the initial collateral assignment TotalNetValue is the sum of (UnderlyingStartValue * (1-haircut)).\nIn a collateral substitution TotalNetValue is the sum of (UnderlyingCurrentValue * (1-haircut)).\nFor listed derivatives clearing margin management, this is the collateral value which equals (Market value * haircut)',
        added: 'FIX.4.4',
        AbbrName: 'TotNetValu',
        Tag: 900,
        NotReqXML: 0,
        Name: 'TotalNetValue',
    },
    {
        Type: 'Amt',
        Description: 'Starting consideration less repayments',
        added: 'FIX.4.4',
        AbbrName: 'CshOutstanding',
        Tag: 901,
        NotReqXML: 0,
        Name: 'CashOutstanding',
    },
    {
        Type: 'String',
        Description: 'Collateral Assignment Identifier',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 902,
        NotReqXML: 0,
        Name: 'CollAsgnID',
    },
    {
        Type: 'int',
        Description: 'Collateral Assignment Transaction Type',
        added: 'FIX.4.4',
        AbbrName: 'TransTyp',
        Tag: 903,
        NotReqXML: 0,
        Name: 'CollAsgnTransType',
    },
    {
        Type: 'String',
        Description: 'Collateral Response Identifier',
        added: 'FIX.4.4',
        AbbrName: 'RespID',
        Tag: 904,
        NotReqXML: 0,
        Name: 'CollRespID',
    },
    {
        Type: 'int',
        Description: 'Collateral Assignment Response Type',
        added: 'FIX.4.4',
        AbbrName: 'RespTyp',
        Tag: 905,
        NotReqXML: 0,
        Name: 'CollAsgnRespType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Collateral Assignment Reject Reason',
        added: 'FIX.4.4',
        AbbrName: 'RejRsn',
        Tag: 906,
        NotReqXML: 0,
        Name: 'CollAsgnRejectReason',
    },
    {
        Type: 'String',
        Description: 'Collateral Assignment Identifier to which a transaction refers',
        added: 'FIX.4.4',
        AbbrName: 'RefID',
        Tag: 907,
        NotReqXML: 0,
        Name: 'CollAsgnRefID',
    },
    {
        Type: 'String',
        Description: 'Collateral Report Identifier',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        Tag: 908,
        NotReqXML: 0,
        Name: 'CollRptID',
    },
    {
        Type: 'String',
        Description: 'Collateral Inquiry Identifier',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 909,
        NotReqXML: 0,
        Name: 'CollInquiryID',
    },
    {
        Type: 'int',
        Description: 'Collateral Status',
        added: 'FIX.4.4',
        AbbrName: 'Stat',
        Tag: 910,
        NotReqXML: 0,
        Name: 'CollStatus',
    },
    {
        Type: 'int',
        Description: 'Total number of reports returned in response to a request.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'TotNumRpts',
        Tag: 911,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'TotNumReports',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates whether this message is that last report message in response to a request, such as Order Mass Status Request.',
        added: 'FIX.4.4',
        AbbrName: 'LastRptReqed',
        Tag: 912,
        NotReqXML: 0,
        Name: 'LastRptRequested',
    },
    {
        Type: 'String',
        Description:
            'The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction.',
        added: 'FIX.4.4',
        AbbrName: 'AgmtDesc',
        Tag: 913,
        NotReqXML: 0,
        Name: 'AgreementDesc',
    },
    {
        Type: 'String',
        Description:
            'A common reference to the applicable standing agreement between the counterparties to a financing transaction.',
        added: 'FIX.4.4',
        AbbrName: 'AgmtID',
        Tag: 914,
        NotReqXML: 0,
        Name: 'AgreementID',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'A reference to the date the underlying agreement specified by AgreementID and AgreementDesc was executed.',
        added: 'FIX.4.4',
        AbbrName: 'AgmtDt',
        Tag: 915,
        NotReqXML: 0,
        Name: 'AgreementDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral',
        added: 'FIX.4.4',
        AbbrName: 'StartDt',
        Tag: 916,
        NotReqXML: 0,
        Name: 'StartDate',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral',
        added: 'FIX.4.4',
        AbbrName: 'EndDt',
        Tag: 917,
        NotReqXML: 0,
        Name: 'EndDate',
    },
    {
        Type: 'Currency',
        Description:
            'Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency.',
        added: 'FIX.4.4',
        AbbrName: 'AgmtCcy',
        Tag: 918,
        NotReqXML: 0,
        Name: 'AgreementCurrency',
    },
    {
        Type: 'int',
        Description: 'Identifies type of settlement',
        added: 'FIX.4.4',
        AbbrName: 'DlvryTyp',
        Tag: 919,
        NotReqXML: 0,
        Name: 'DeliveryType',
    },
    {
        Type: 'Amt',
        Description: 'Accrued Interest Amount applicable to a financing transaction on the End Date.',
        added: 'FIX.4.4',
        AbbrName: 'EndAcrdIntAmt',
        Tag: 920,
        NotReqXML: 0,
        Name: 'EndAccruedInterestAmt',
    },
    {
        Type: 'Amt',
        Description:
            'Starting dirty cash consideration of a financing deal, i.e. paid to the seller on the Start Date.',
        added: 'FIX.4.4',
        AbbrName: 'StartCsh',
        Tag: 921,
        NotReqXML: 0,
        Name: 'StartCash',
    },
    {
        Type: 'Amt',
        Description:
            'Ending dirty cash consideration of a financing deal. i.e. reimbursed to the buyer on the End Date.',
        added: 'FIX.4.4',
        AbbrName: 'EndCsh',
        Tag: 922,
        NotReqXML: 0,
        Name: 'EndCash',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a User Request.',
        added: 'FIX.4.4',
        AbbrName: 'UserReqID',
        Tag: 923,
        NotReqXML: 0,
        Name: 'UserRequestID',
    },
    {
        Type: 'int',
        Description: 'Indicates the action required by a User Request Message',
        added: 'FIX.4.4',
        AbbrName: 'UserReqTyp',
        Tag: 924,
        NotReqXML: 0,
        Name: 'UserRequestType',
    },
    {
        Type: 'String',
        Description: 'New Password or passphrase',
        added: 'FIX.4.4',
        AbbrName: 'NewPassword',
        Tag: 925,
        NotReqXML: 0,
        Name: 'NewPassword',
    },
    {
        Type: 'int',
        Description: 'Indicates the status of a user',
        added: 'FIX.4.4',
        AbbrName: 'UserStat',
        Tag: 926,
        NotReqXML: 0,
        Name: 'UserStatus',
    },
    {
        Type: 'String',
        Description: 'A text description associated with a user status.',
        added: 'FIX.4.4',
        AbbrName: 'UserStatText',
        Tag: 927,
        NotReqXML: 0,
        Name: 'UserStatusText',
    },
    {
        Type: 'int',
        Description: 'Indicates the status of a network connection',
        added: 'FIX.4.4',
        AbbrName: 'StatValu',
        Tag: 928,
        NotReqXML: 0,
        Name: 'StatusValue',
    },
    {
        Type: 'String',
        Description: 'A text description associated with a network status.',
        added: 'FIX.4.4',
        AbbrName: 'StatText',
        Tag: 929,
        NotReqXML: 0,
        Name: 'StatusText',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify a firm.',
        added: 'FIX.4.4',
        AbbrName: 'RefCompID',
        Tag: 930,
        NotReqXML: 0,
        Name: 'RefCompID',
    },
    {
        Type: 'String',
        Description: 'Assigned value used to identify specific elements within a firm.',
        added: 'FIX.4.4',
        AbbrName: 'RefSubID',
        Tag: 931,
        NotReqXML: 0,
        Name: 'RefSubID',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a network response.',
        added: 'FIX.4.4',
        AbbrName: 'NtwkRspID',
        Tag: 932,
        NotReqXML: 0,
        Name: 'NetworkResponseID',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a network resquest.',
        added: 'FIX.4.4',
        AbbrName: 'NtwkReqID',
        Tag: 933,
        NotReqXML: 0,
        Name: 'NetworkRequestID',
    },
    {
        Type: 'String',
        Description:
            'Identifier of the previous Network Response message sent to a counterparty, used to allow incremental updates.',
        added: 'FIX.4.4',
        AbbrName: 'LastNtwkRspID',
        Tag: 934,
        NotReqXML: 0,
        Name: 'LastNetworkResponseID',
    },
    {
        Type: 'int',
        Description:
            "Indicates the type and level of details required for a Network Status Request Message\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)",
        added: 'FIX.4.4',
        AbbrName: 'NtwkReqTyp',
        Tag: 935,
        NotReqXML: 0,
        Name: 'NetworkRequestType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of CompID entries in a repeating group.',
        added: 'FIX.4.4',
        AbbrName: 'NoCompIDs',
        Tag: 936,
        NotReqXML: 1,
        Name: 'NoCompIDs',
    },
    {
        Type: 'int',
        Description: 'Indicates the type of Network Response Message.',
        added: 'FIX.4.4',
        AbbrName: 'NtwkStatRspTyp',
        Tag: 937,
        NotReqXML: 0,
        Name: 'NetworkStatusResponseType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of CollInquiryQualifier entries in a repeating group.',
        added: 'FIX.4.4',
        AbbrName: 'NoCollInqQual',
        Tag: 938,
        NotReqXML: 1,
        Name: 'NoCollInquiryQualifier',
    },
    {
        Type: 'int',
        Description: 'Trade Report Status',
        added: 'FIX.4.4',
        AbbrName: 'TrdRptStat',
        Tag: 939,
        NotReqXML: 0,
        Name: 'TrdRptStatus',
    },
    {
        Type: 'int',
        Description: 'Identifies the status of the ConfirmationAck.',
        added: 'FIX.4.4',
        AbbrName: 'AffirmStat',
        Tag: 940,
        NotReqXML: 0,
        Name: 'AffirmStatus',
    },
    {
        Type: 'Currency',
        Description: 'Currency in which the strike price of an underlying instrument is denominated',
        added: 'FIX.4.4',
        AbbrName: 'StrkCcy',
        Tag: 941,
        NotReqXML: 0,
        Name: 'UnderlyingStrikeCurrency',
    },
    {
        Type: 'Currency',
        Description: 'Currency in which the strike price of a instrument leg of a multileg instrument is denominated',
        added: 'FIX.4.4',
        AbbrName: 'StrkCcy',
        Tag: 942,
        NotReqXML: 0,
        Name: 'LegStrikeCurrency',
    },
    {
        Type: 'String',
        Description:
            'A code that represents a time interval in which a fill or trade occurred.\nRequired for US futures markets.',
        added: 'FIX.4.4',
        AbbrName: 'TmBkt',
        Tag: 943,
        NotReqXML: 0,
        Name: 'TimeBracket',
    },
    {
        Type: 'int',
        Description: 'Action proposed for an Underlying Instrument instance.',
        added: 'FIX.4.4',
        AbbrName: 'Actn',
        Tag: 944,
        NotReqXML: 0,
        Name: 'CollAction',
    },
    {
        Type: 'int',
        Description: 'Status of Collateral Inquiry',
        added: 'FIX.4.4',
        AbbrName: 'Stat',
        Tag: 945,
        NotReqXML: 0,
        Name: 'CollInquiryStatus',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Result returned in response to Collateral Inquiry\n4000+ Reserved and available for bi-laterally agreed upon user-defined values',
        added: 'FIX.4.4',
        AbbrName: 'Rslt',
        Tag: 946,
        NotReqXML: 0,
        Name: 'CollInquiryResult',
    },
    {
        Type: 'Currency',
        Description: 'Currency in which the StrikePrice is denominated.',
        added: 'FIX.4.4',
        AbbrName: 'StrkCcy',
        Tag: 947,
        NotReqXML: 0,
        Name: 'StrikeCurrency',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Nested3PartyID (949), Nested3PartyIDSource (950), and Nested3PartyRole (95) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoNst3PtyIDs',
        Tag: 948,
        NotReqXML: 1,
        Name: 'NoNested3PartyIDs',
    },
    {
        Type: 'String',
        Description: 'PartyID value within a "third instance" Nested repeating group.\nSame values as PartyID (448)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 949,
        NotReqXML: 0,
        Name: 'Nested3PartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description:
            'PartyIDSource value within a "third instance" Nested repeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        Tag: 950,
        NotReqXML: 0,
        Name: 'Nested3PartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description:
            'PartyRole value within a "third instance" Nested repeating group.\nSame values as PartyRole (452)',
        added: 'FIX.4.4',
        AbbrName: 'R',
        Tag: 951,
        NotReqXML: 0,
        Name: 'Nested3PartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Nested3PartySubIDs (953) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoNst3PtySubIDs',
        Tag: 952,
        NotReqXML: 1,
        Name: 'NoNested3PartySubIDs',
    },
    {
        Type: 'String',
        Description:
            'PartySubID value within a "third instance" Nested repeating group.\nSame values as PartySubID (523)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        Tag: 953,
        NotReqXML: 0,
        Name: 'Nested3PartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description:
            'PartySubIDType value within a "third instance" Nested repeating group.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        Tag: 954,
        NotReqXML: 0,
        Name: 'Nested3PartySubIDType',
    },
    {
        Type: 'MonthYear',
        Description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
        added: 'FIX.4.4',
        AbbrName: 'CSetMo',
        Tag: 955,
        NotReqXML: 0,
        Name: 'LegContractSettlMonth',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
        added: 'FIX.4.4',
        AbbrName: 'IntAcrl',
        Tag: 956,
        NotReqXML: 0,
        Name: 'LegInterestAccrualDate',
    },
    {
        Type: 'NumInGroup',
        Description: 'Indicates number of strategy parameters',
        added: 'FIX.4.4',
        AbbrName: 'NoStrtPrm',
        addedEP: 2,
        Tag: 957,
        NotReqXML: 1,
        Name: 'NoStrategyParameters',
    },
    {
        Type: 'String',
        Description: 'Name of parameter',
        added: 'FIX.4.4',
        AbbrName: 'StrtPrmNme',
        addedEP: 2,
        Tag: 958,
        NotReqXML: 0,
        Name: 'StrategyParameterName',
    },
    {
        Type: 'int',
        Description: 'Datatype of the parameter',
        added: 'FIX.4.4',
        AbbrName: 'StrtPrmTyp',
        addedEP: 2,
        Tag: 959,
        NotReqXML: 0,
        Name: 'StrategyParameterType',
    },
    {
        Type: 'String',
        Description: 'Value of the parameter',
        added: 'FIX.4.4',
        AbbrName: 'StrtPrmVal',
        addedEP: 2,
        Tag: 960,
        NotReqXML: 0,
        Name: 'StrategyParameterValue',
    },
    {
        Type: 'String',
        Description:
            'Host assigned entity ID that can be used to reference all components of a cross; sides + strategy + legs. Used as the primary key with which to refer to the Cross Order for cancellation and replace. The HostCrossID will also be used to link together components of the Cross Order. For example, each individual Execution Report associated with the order will carry HostCrossID in order to tie back to the original cross order.',
        added: 'FIX.4.4',
        AbbrName: 'HstCxID',
        addedEP: 3,
        Tag: 961,
        NotReqXML: 0,
        Name: 'HostCrossID',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Indicates how long the order as specified in the side stays in effect. SideTimeInForce allows a two-sided cross order to specify order behavior separately for each side. Absence of this field indicates that TimeInForce should be referenced. SideTimeInForce will override TimeInForce if both are provided.',
        added: 'FIX.4.4',
        AbbrName: 'SideTmFrc',
        addedEP: 3,
        Tag: 962,
        NotReqXML: 0,
        Name: 'SideTimeInForce',
    },
    {
        Type: 'int',
        Description: 'Unique identifier for the Market Data Report.',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        addedEP: 4,
        Tag: 963,
        NotReqXML: 0,
        Name: 'MDReportID',
    },
    {
        Type: 'int',
        Description: 'Identifies a Security List message.',
        added: 'FIX.4.4',
        updatedEP: 87,
        AbbrName: 'RptID',
        addedEP: 4,
        Tag: 964,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'SecurityReportID',
    },
    {
        Type: 'String',
        Description: 'Used for derivatives. Denotes the current state of the Instrument.',
        added: 'FIX.4.4',
        AbbrName: 'Status',
        addedEP: 4,
        Tag: 965,
        NotReqXML: 0,
        Name: 'SecurityStatus',
    },
    {
        Type: 'String',
        Description: 'Indicator to determine if instrument is settle on open',
        added: 'FIX.4.4',
        AbbrName: 'SettlOnOpenFlag',
        addedEP: 4,
        Tag: 966,
        NotReqXML: 0,
        Name: 'SettleOnOpenFlag',
    },
    {
        Type: 'float',
        Description:
            'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
        added: 'FIX.4.4',
        AbbrName: 'StrkMult',
        addedEP: 4,
        Tag: 967,
        NotReqXML: 0,
        Name: 'StrikeMultiplier',
    },
    {
        Type: 'float',
        Description:
            'Used for derivatives. The number of shares/units for the financial instrument involved in the option trade.',
        added: 'FIX.4.4',
        AbbrName: 'StrkValu',
        addedEP: 4,
        Tag: 968,
        NotReqXML: 0,
        Name: 'StrikeValue',
    },
    {
        Type: 'float',
        Description: 'Minimum price increase for a given exchange-traded Instrument',
        added: 'FIX.4.4',
        AbbrName: 'MinPxIncr',
        addedEP: 4,
        Tag: 969,
        NotReqXML: 0,
        Name: 'MinPriceIncrement',
    },
    {
        Type: 'int',
        Description: 'Position Limit for a given exchange-traded product.',
        added: 'FIX.4.4',
        AbbrName: 'PosLmt',
        addedEP: 4,
        Tag: 970,
        NotReqXML: 0,
        Name: 'PositionLimit',
    },
    {
        Type: 'int',
        Description: 'Position Limit in the near-term contract for a given exchange-traded product.',
        added: 'FIX.4.4',
        AbbrName: 'NTPosLmt',
        addedEP: 4,
        Tag: 971,
        NotReqXML: 0,
        Name: 'NTPositionLimit',
    },
    {
        Type: 'Percentage',
        Description: 'Percent of the Strike Price that this underlying represents.',
        added: 'FIX.4.4',
        AbbrName: 'AllocPct',
        addedEP: 4,
        Tag: 972,
        NotReqXML: 0,
        Name: 'UnderlyingAllocationPercent',
    },
    {
        Type: 'Amt',
        Description: 'Cash amount associated with the underlying component.',
        added: 'FIX.4.4',
        AbbrName: 'CashAmt',
        addedEP: 4,
        Tag: 973,
        NotReqXML: 0,
        Name: 'UnderlyingCashAmount',
    },
    {
        Type: 'String',
        Description: 'Used for derivatives that deliver into cash underlying.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'CashTyp',
        addedEP: 4,
        Tag: 974,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingCashType',
    },
    {
        Type: 'int',
        Description: 'Indicates order settlement period for the underlying instrument.',
        added: 'FIX.4.4',
        AbbrName: 'SettlTyp',
        addedEP: 4,
        Tag: 975,
        NotReqXML: 0,
        Name: 'UnderlyingSettlementType',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Date associated to the quantity that is being reported for the position.',
        added: 'FIX.4.4',
        AbbrName: 'QtyDt',
        addedEP: 4,
        Tag: 976,
        NotReqXML: 0,
        Name: 'QuantityDate',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for the Contrary Intention report',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        addedEP: 4,
        Tag: 977,
        NotReqXML: 0,
        Name: 'ContIntRptID',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates if the contrary intention was received after the exchange imposed cutoff time',
        added: 'FIX.4.4',
        AbbrName: 'LateInd',
        addedEP: 4,
        Tag: 978,
        NotReqXML: 0,
        Name: 'LateIndicator',
    },
    {
        Type: 'String',
        Description: 'Source of the contrary intention',
        added: 'FIX.4.4',
        AbbrName: 'InptSrc',
        addedEP: 4,
        Tag: 979,
        NotReqXML: 0,
        Name: 'InputSource',
    },
    {
        Type: 'char',
        Description: '',
        added: 'FIX.4.4',
        AbbrName: 'UpdActn',
        addedEP: 4,
        Tag: 980,
        NotReqXML: 0,
        Name: 'SecurityUpdateAction',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Expiration Qty entries',
        added: 'FIX.4.4',
        AbbrName: 'NoExpiration',
        addedEP: 4,
        Tag: 981,
        NotReqXML: 1,
        Name: 'NoExpiration',
    },
    {
        Type: 'int',
        Description: 'Expiration Quantity type',
        added: 'FIX.4.4',
        AbbrName: 'ExpTyp',
        addedEP: 4,
        Tag: 982,
        NotReqXML: 0,
        Name: 'ExpirationQtyType',
    },
    {
        Type: 'Qty',
        Description: 'Expiration Quantity associated with the Expiration Type',
        added: 'FIX.4.4',
        AbbrName: 'ExpQty',
        addedEP: 4,
        Tag: 983,
        NotReqXML: 0,
        Name: 'ExpQty',
    },
    {
        Type: 'NumInGroup',
        Description: 'Total number of occurrences of Amount to pay in order to receive the underlying instrument',
        added: 'FIX.4.4',
        AbbrName: 'NoUnderlyingAmounts',
        addedEP: 4,
        Tag: 984,
        NotReqXML: 1,
        Name: 'NoUnderlyingAmounts',
    },
    {
        Type: 'Amt',
        Description: 'Amount to pay in order to receive the underlying instrument',
        added: 'FIX.4.4',
        AbbrName: 'PayAmt',
        addedEP: 4,
        Tag: 985,
        NotReqXML: 0,
        Name: 'UnderlyingPayAmount',
    },
    {
        Type: 'Amt',
        Description: 'Amount to collect in order to deliver the underlying instrument',
        added: 'FIX.4.4',
        AbbrName: 'ColAmt',
        addedEP: 4,
        Tag: 986,
        NotReqXML: 0,
        Name: 'UnderlyingCollectAmount',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Date the underlying instrument will settle. Used for derivatives that deliver into more than one underlying instrument. Settlement dates can vary across underlying instruments.',
        added: 'FIX.4.4',
        AbbrName: 'StlDt',
        addedEP: 4,
        Tag: 987,
        NotReqXML: 0,
        Name: 'UnderlyingSettlementDate',
    },
    {
        Type: 'String',
        Description:
            'Settlement status of the underlying instrument. Used for derivatives that deliver into more than one underlying instrument. Settlement can be delayed for an underlying instrument.',
        added: 'FIX.4.4',
        AbbrName: 'SetStat',
        addedEP: 4,
        Tag: 988,
        NotReqXML: 0,
        Name: 'UnderlyingSettlementStatus',
    },
    {
        Type: 'String',
        Description: 'Will allow the intermediary to specify an allocation ID generated by their system.',
        added: 'FIX.4.4',
        AbbrName: 'IndAllocID2',
        addedEP: 5,
        Tag: 989,
        NotReqXML: 0,
        Name: 'SecondaryIndividualAllocID',
    },
    {
        Type: 'String',
        Description: 'Additional attribute to store the Trade ID of the Leg.',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        addedEP: 5,
        Tag: 990,
        NotReqXML: 0,
        Name: 'LegReportID',
    },
    {
        Type: 'Price',
        Description: 'Specifies average price rounded to quoted precision.',
        added: 'FIX.4.4',
        AbbrName: 'RndPx',
        addedEP: 5,
        Tag: 991,
        NotReqXML: 0,
        Name: 'RndPx',
    },
    {
        Type: 'int',
        Description: 'Identifies whether the allocation is to be sub-allocated or allocated to a third party',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        addedEP: 5,
        Tag: 992,
        NotReqXML: 0,
        Name: 'IndividualAllocType',
    },
    {
        Type: 'String',
        Description: 'Capacity of customer in the allocation block.',
        added: 'FIX.4.4',
        AbbrName: 'CustCpcty',
        addedEP: 5,
        Tag: 993,
        NotReqXML: 0,
        Name: 'AllocCustomerCapacity',
    },
    {
        Type: 'String',
        Description: 'The Tier the trade was matched by the clearing system.',
        added: 'FIX.4.4',
        AbbrName: 'TierCD',
        addedEP: 5,
        Tag: 994,
        NotReqXML: 0,
        Name: 'TierCode',
    },
    {
        Type: 'String',
        Description:
            "The unit of measure of the underlying commodity upon which the contract is based. Two groups of units of measure enumerations are supported.\nFixed Magnitude UOMs are primarily used in energy derivatives and specify a magnitude (such as, MM, Kilo, M, etc.) and the dimension (such as, watt hours, BTU's) to produce standard fixed measures (such as MWh - Megawatt-hours, MMBtu - One million BTUs).\nThe second group, Variable Quantity UOMs, specifies the dimension as a single unit without a magnitude (or more accurately a magnitude of one) and uses the UnitOfMeasureQty(1147) field to define the quantity of units per contract. Variable Quantity UOMs are used for both commodities (such as lbs of lean cattle, bushels of corn, ounces of gold) and financial futures.\nExamples:\nFor lean cattle futures contracts, a UnitOfMeasure of 'lbs' with a UnitOfMeasureQty(1147) of 40,000, means each lean cattle futures contract represents 40,000 lbs of lean cattle.\nFor Eurodollars futures contracts, a UnitOfMeasure of USD with a UnitOfMeasureQty(1147) of 1,000,000, means a Eurodollar futures contract represents 1,000,000 USD.\nFor gold futures contracts, a UnitOfMeasure is oz_tr (Troy ounce) with a UnitOfMeasureQty(1147) of 1,000, means each gold futures contract represents 1,000 troy ounces of gold.",
        added: 'FIX.4.4',
        AbbrName: 'UOM',
        addedEP: 5,
        Tag: 996,
        NotReqXML: 0,
        Name: 'UnitOfMeasure',
    },
    {
        Type: 'String',
        Description:
            'Unit of time associated with the contract.\nNOTE: Additional values may be used by mutual agreement of the counterparties',
        added: 'FIX.4.4',
        AbbrName: 'TmUnit',
        addedEP: 5,
        Tag: 997,
        NotReqXML: 0,
        Name: 'TimeUnit',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: 'Refer to defintion of UnitOfMeasure(996)',
        added: 'FIX.4.4',
        AbbrName: 'UOM',
        addedEP: 5,
        Tag: 998,
        NotReqXML: 0,
        Name: 'UnderlyingUnitOfMeasure',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: 'Refer to defintion of UnitOfMeasure(996)',
        added: 'FIX.4.4',
        AbbrName: 'UOM',
        addedEP: 5,
        Tag: 999,
        NotReqXML: 0,
        Name: 'LegUnitOfMeasure',
    },
    {
        Type: 'String',
        EnumDatatype: 997,
        Description: 'Same as TimeUnit.',
        added: 'FIX.4.4',
        AbbrName: 'TmUnit',
        addedEP: 5,
        Tag: 1000,
        NotReqXML: 0,
        Name: 'UnderlyingTimeUnit',
    },
    {
        Type: 'String',
        EnumDatatype: 997,
        Description: 'Same as TimeUnit.',
        added: 'FIX.4.4',
        AbbrName: 'TmUnit',
        addedEP: 5,
        Tag: 1001,
        NotReqXML: 0,
        Name: 'LegTimeUnit',
    },
    {
        Type: 'int',
        Description: 'Specifies the method under which a trade quantity was allocated.',
        added: 'FIX.4.4',
        AbbrName: 'Meth',
        addedEP: 5,
        Tag: 1002,
        NotReqXML: 0,
        Name: 'AllocMethod',
    },
    {
        Type: 'String',
        Description:
            'The unique ID assigned to the trade entity once it is received or matched by the exchange or central counterparty.',
        added: 'FIX.4.4',
        AbbrName: 'TrdID',
        addedEP: 11,
        Tag: 1003,
        NotReqXML: 0,
        Name: 'TradeID',
    },
    {
        Type: 'String',
        Description: 'Used on a multi-sided trade to designate the ReportID',
        added: 'FIX.4.4',
        AbbrName: 'RptID',
        addedEP: 5,
        Tag: 1005,
        NotReqXML: 0,
        Name: 'SideTradeReportID',
    },
    {
        Type: 'String',
        Description: 'Used on a multi-sided trade to convey order routing information',
        added: 'FIX.4.4',
        AbbrName: 'FillStationCd',
        addedEP: 5,
        Tag: 1006,
        NotReqXML: 0,
        Name: 'SideFillStationCd',
    },
    {
        Type: 'String',
        Description: 'Used on a multi-sided trade to convey reason for execution',
        added: 'FIX.4.4',
        AbbrName: 'RsnCD',
        addedEP: 5,
        Tag: 1007,
        NotReqXML: 0,
        Name: 'SideReasonCd',
    },
    {
        Type: 'int',
        EnumDatatype: 829,
        Description:
            'Used on a multi-sided trade to specify the type of trade for a given side. Same values as TrdSubType (829).',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'TrdSubTyp',
        addedEP: 5,
        Tag: 1008,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'SideTrdSubTyp',
    },
    {
        Type: 'int',
        Description: 'Used to indicate the quantity on one of a multi-sided Trade Capture Report',
        added: 'FIX.4.4',
        updatedEP: 77,
        AbbrName: 'SideQty',
        addedEP: 5,
        Tag: 1009,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'SideLastQty',
    },
    {
        Type: 'String',
        Description:
            'Used to identify the event or source which gave rise to a message.\nValid values will be based on an exchange\'s implementation.\nExample values are:\n"MQM" (originated at Firm Back Office)\n"Clear" (originated in Clearing System)\n"Reg" (static data generated via Register request)',
        added: 'FIX.4.4',
        AbbrName: 'MsgEvtSrc',
        addedEP: 5,
        Tag: 1011,
        NotReqXML: 0,
        Name: 'MessageEventSource',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Will be used in a multi-sided message.\nTraded Regulatory timestamp value Use to store time information required by government regulators or self regulatory organizations such as an exchange or clearing house',
        added: 'FIX.4.4',
        AbbrName: 'TS',
        addedEP: 5,
        Tag: 1012,
        NotReqXML: 0,
        Name: 'SideTrdRegTimestamp',
    },
    {
        Type: 'int',
        EnumDatatype: 770,
        Description: 'Same as TrdRegTimeStampType',
        added: 'FIX.4.4',
        updatedEP: 77,
        AbbrName: 'Typ',
        addedEP: 5,
        Tag: 1013,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'SideTrdRegTimestampType',
    },
    {
        Type: 'String',
        Description:
            'Same as TrdRegTimestampOrigin\nText which identifies the origin i.e. system which was used to generate the time stamp for the Traded Regulatory timestamp value',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        addedEP: 5,
        Tag: 1014,
        NotReqXML: 0,
        Name: 'SideTrdRegTimestampSrc',
    },
    {
        Type: 'char',
        Description:
            'Used to indicate that a floor-trade was originally submitted "as of" a specific trade date which is earlier than its clearing date.',
        added: 'FIX.4.4',
        AbbrName: 'AsOfInd',
        addedEP: 5,
        Tag: 1015,
        NotReqXML: 0,
        Name: 'AsOfIndicator',
    },
    {
        Type: 'NumInGroup',
        Description: 'Indicates number of SideTimestamps contained in group',
        added: 'FIX.4.4',
        AbbrName: 'NoSideTrdRegTS',
        addedEP: 5,
        Tag: 1016,
        NotReqXML: 1,
        Name: 'NoSideTrdRegTS',
    },
    {
        Type: 'float',
        Description:
            'Expresses the risk of an option leg\nValue must be between -1 and 1.\nA Call Option will require a ratio value between 0 and 1\nA Put Option will require a ratio value between -1 and 0',
        added: 'FIX.4.4',
        AbbrName: 'LegOptionRatio',
        addedEP: 18,
        Tag: 1017,
        NotReqXML: 0,
        Name: 'LegOptionRatio',
    },
    {
        Type: 'NumInGroup',
        Description: 'Identifies the number of parties identified with an instrument',
        added: 'FIX.4.4',
        AbbrName: 'NoInstrmntPty',
        addedEP: 4,
        Tag: 1018,
        NotReqXML: 1,
        Name: 'NoInstrumentParties',
    },
    {
        Type: 'String',
        Description: 'PartyID value within an instrument party repeating group. Same values as PartyID (448)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        addedEP: 4,
        Tag: 1019,
        NotReqXML: 0,
        Name: 'InstrumentPartyID',
    },
    {
        Type: 'Qty',
        Description: 'Used to report volume with a trade',
        added: 'FIX.4.4',
        AbbrName: 'TrdVol',
        addedEP: 7,
        Tag: 1020,
        NotReqXML: 0,
        Name: 'TradeVolume',
    },
    {
        Type: 'int',
        Description:
            'Describes the type of book for which the feed is intended. Used when multiple feeds are provided over the same connection',
        added: 'FIX.4.4',
        AbbrName: 'MDBkTyp',
        addedEP: 7,
        Tag: 1021,
        NotReqXML: 0,
        Name: 'MDBookType',
    },
    {
        Type: 'String',
        Description:
            'Describes a class of service for a given data feed, ie Regular and Market Maker, Bandwidth Intensive or Bandwidth Conservative',
        added: 'FIX.4.4',
        AbbrName: 'MDFeedTyp',
        addedEP: 7,
        Tag: 1022,
        NotReqXML: 0,
        Name: 'MDFeedType',
    },
    {
        Type: 'int',
        Description:
            'Integer to convey the level of a bid or offer at a given price level. This is in contrast to MDEntryPositionNo which is used to convey the position of an order within a Price level',
        added: 'FIX.4.4',
        AbbrName: 'MDPxLvl',
        addedEP: 7,
        Tag: 1023,
        NotReqXML: 0,
        Name: 'MDPriceLevel',
    },
    {
        Type: 'int',
        Description: 'Used to describe the origin of an entry in the book',
        added: 'FIX.4.4',
        AbbrName: 'MDOrigTyp',
        addedEP: 7,
        Tag: 1024,
        NotReqXML: 0,
        Name: 'MDOriginType',
    },
    {
        Type: 'Price',
        Description: 'Indicates the first trade price of the day/session',
        added: 'FIX.4.4',
        AbbrName: 'FirstPx',
        addedEP: 7,
        Tag: 1025,
        NotReqXML: 0,
        Name: 'FirstPx',
    },
    {
        Type: 'float',
        Description: 'The spot rate for an FX entry',
        added: 'FIX.4.4',
        AbbrName: 'MDEntrySpotRt',
        addedEP: 7,
        Tag: 1026,
        NotReqXML: 0,
        Name: 'MDEntrySpotRate',
    },
    {
        Type: 'PriceOffset',
        Description:
            'Used for an F/X entry. The forward points to be added to or subtracted from the spot rate to get the "all-in" rate in MDEntryPx. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.4',
        AbbrName: 'MDEntryFwdPnts',
        addedEP: 7,
        Tag: 1027,
        NotReqXML: 0,
        Name: 'MDEntryForwardPoints',
    },
    {
        Type: 'Boolean',
        Description: 'Indicates if the order was initially received manually (as opposed to electronically)',
        added: 'FIX.4.4',
        AbbrName: 'ManOrdInd',
        addedEP: 9,
        Tag: 1028,
        NotReqXML: 0,
        Name: 'ManualOrderIndicator',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates if the customer directed this order to a specific execution venue "Y" or not "N".\nA default of "N" customer did not direct this order should be used in the case where the information is both missing and essential.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'CustDrctdOrd',
        addedEP: 9,
        Tag: 1029,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'CustDirectedOrder',
    },
];

const batch3: ISpecFields[] = [
    {
        Type: 'String',
        Description: 'Identifies the Broker / Dealer Department that first took the order.',
        added: 'FIX.4.4',
        AbbrName: 'RcvdDptID',
        addedEP: 9,
        Tag: 1030,
        NotReqXML: 0,
        Name: 'ReceivedDeptID',
    },
    {
        Type: 'MultipleStringValue',
        Description:
            'Codes that apply special information that the Broker / Dealer needs to report, as specified by the customer.\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting only.\nValid values are grouped by OrderHandlingInstSource(1032).',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'CustOrdHdlInst',
        addedEP: 9,
        Tag: 1031,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'CustOrderHandlingInst',
    },
    {
        Type: 'int',
        Description:
            'Identifies the class or source of the "OrderHandlingInst" values. Scope of this will apply to both CustOrderHandlingInst and DeskOrderHandlingInst fields.\nRequired if CustOrderHandlingInst and/or DeskOrderHandlingInst is specified.',
        added: 'FIX.4.4',
        AbbrName: 'OrdHndlInstSrc',
        addedEP: 9,
        Tag: 1032,
        NotReqXML: 0,
        Name: 'OrderHandlingInstSource',
    },
    {
        Type: 'String',
        Description: 'Type of trading desk.  Valid values are grouped by DeskTypeSource(1034).',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'DskTyp',
        addedEP: 9,
        Tag: 1033,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DeskType',
    },
    {
        Type: 'int',
        Description:
            'Identifies the class or source of DeskType(1033) values. Required if DeskType(1033) is specified.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'DskTypSrc',
        addedEP: 9,
        Tag: 1034,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DeskTypeSource',
    },
    {
        Type: 'MultipleStringValue',
        EnumDatatype: 1031,
        Description:
            'Codes that apply special information that the Broker / Dealer needs to report.\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting only.\nValid values are grouped by OrderHandlingInstSource(1032).',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'DskOrdHndlInst',
        addedEP: 9,
        Tag: 1035,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DeskOrderHandlingInst',
    },
    {
        Type: 'char',
        Description: 'The status of this execution acknowledgement message.',
        added: 'FIX.4.4',
        AbbrName: 'ExecAckStat',
        addedEP: 10,
        Tag: 1036,
        NotReqXML: 0,
        Name: 'ExecAckStatus',
    },
    {
        Type: 'Amt',
        Description: 'Indicates the underlying position amount to be delivered',
        added: 'FIX.4.4',
        AbbrName: 'UndlyDlvAmt',
        addedEP: 8,
        Tag: 1037,
        NotReqXML: 0,
        Name: 'UnderlyingDeliveryAmount',
    },
    {
        Type: 'Amt',
        Description: 'Maximum notional value for a capped financial instrument',
        added: 'FIX.4.4',
        AbbrName: 'CapValu',
        addedEP: 8,
        Tag: 1038,
        NotReqXML: 0,
        Name: 'UnderlyingCapValue',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.4.4',
        AbbrName: 'SetMeth',
        addedEP: 8,
        Tag: 1039,
        NotReqXML: 0,
        Name: 'UnderlyingSettlMethod',
    },
    {
        Type: 'String',
        Description: 'Used to carry an internal trade entity ID which may or may not be reported to the firm',
        added: 'FIX.4.4',
        AbbrName: 'TrdID2',
        addedEP: 11,
        Tag: 1040,
        NotReqXML: 0,
        Name: 'SecondaryTradeID',
    },
    {
        Type: 'String',
        Description:
            'The ID assigned to a trade by the Firm to track a trade within the Firm system. This ID can be assigned either before or after submission to the exchange or central counterpary',
        added: 'FIX.4.4',
        AbbrName: 'FirmTrdID',
        addedEP: 11,
        Tag: 1041,
        NotReqXML: 0,
        Name: 'FirmTradeID',
    },
    {
        Type: 'String',
        Description:
            'Used to carry an internal firm assigned ID which may or may not be reported to the exchange or central counterpary',
        added: 'FIX.4.4',
        AbbrName: 'FirmTrdID2',
        addedEP: 11,
        Tag: 1042,
        NotReqXML: 0,
        Name: 'SecondaryFirmTradeID',
    },
    {
        Type: 'int',
        Description: 'conveys how the collateral should be/has been applied',
        added: 'FIX.4.4',
        AbbrName: 'ApplTyp',
        addedEP: 12,
        Tag: 1043,
        NotReqXML: 0,
        Name: 'CollApplType',
    },
    {
        Type: 'Qty',
        Description:
            'Unit amount of the underlying security (shares) adjusted for pending corporate action not yet allocated.',
        added: 'FIX.4.4',
        AbbrName: 'AdjQty',
        addedEP: 12,
        Tag: 1044,
        NotReqXML: 0,
        Name: 'UnderlyingAdjustedQuantity',
    },
    {
        Type: 'float',
        Description:
            'Foreign exchange rate used to compute UnderlyingCurrentValue(885) (or market value) from UnderlyingCurrency(318) to Currency(15).',
        added: 'FIX.4.4',
        AbbrName: 'FxRate',
        addedEP: 12,
        Tag: 1045,
        NotReqXML: 0,
        Name: 'UnderlyingFXRate',
    },
    {
        Type: 'char',
        Description: 'Specifies whether the UnderlyingFxRate(1045) should be multiplied or divided.',
        added: 'FIX.4.4',
        AbbrName: 'FxRateCalc',
        addedEP: 12,
        Tag: 1046,
        NotReqXML: 0,
        Name: 'UnderlyingFXRateCalc',
    },
    {
        Type: 'char',
        Description:
            'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
        added: 'FIX.4.4',
        AbbrName: 'AllocPosEfct',
        addedEP: 17,
        Tag: 1047,
        NotReqXML: 0,
        Name: 'AllocPositionEffect',
    },
    {
        Type: 'char',
        Description: 'Identifies role of dealer; Agent, Principal, RisklessPrincipal',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'DealingCpcty',
        addedEP: 7,
        Tag: 1048,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DealingCapacity',
    },
    {
        Type: 'char',
        Description: 'Method under which assignment was conducted',
        added: 'FIX.4.4',
        AbbrName: 'AsgnMeth',
        addedEP: 4,
        Tag: 1049,
        NotReqXML: 0,
        Name: 'InstrmtAssignmentMethod',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description:
            'PartyIDSource value within an instrument partyrepeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        addedEP: 4,
        Tag: 1050,
        NotReqXML: 0,
        Name: 'InstrumentPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'PartyRole value within an instrument partyepeating group.\nSame values as PartyRole (452)',
        added: 'FIX.4.4',
        AbbrName: 'R',
        addedEP: 4,
        Tag: 1051,
        NotReqXML: 0,
        Name: 'InstrumentPartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoInstrmntPtySubIDs',
        addedEP: 4,
        Tag: 1052,
        NotReqXML: 1,
        Name: 'NoInstrumentPartySubIDs',
    },
    {
        Type: 'String',
        Description: 'PartySubID value within an instrument party repeating group.\nSame values as PartySubID (523)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        addedEP: 4,
        Tag: 1053,
        NotReqXML: 0,
        Name: 'InstrumentPartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Type of InstrumentPartySubID (1053) value.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        addedEP: 4,
        Tag: 1054,
        NotReqXML: 0,
        Name: 'InstrumentPartySubIDType',
    },
    {
        Type: 'String',
        Description: 'The Currency in which the position Amount is denominated',
        added: 'FIX.4.4',
        AbbrName: 'Ccy',
        addedEP: 8,
        Tag: 1055,
        NotReqXML: 0,
        Name: 'PositionCurrency',
    },
    {
        Type: 'Qty',
        Description:
            'Used for the calculated quantity of the other side of the currency trade. Can be derived from LastQty and LastPx.',
        added: 'FIX.4.4',
        AbbrName: 'CalcCcyLastQty',
        addedEP: 21,
        Tag: 1056,
        NotReqXML: 0,
        Name: 'CalculatedCcyLastQty',
    },
    {
        Type: 'Boolean',
        Description: 'Used to identify whether the order initiator is an aggressor or not in the trade.',
        added: 'FIX.4.4',
        AbbrName: 'AgrsrInd',
        addedEP: 21,
        Tag: 1057,
        NotReqXML: 0,
        Name: 'AggressorIndicator',
    },
    {
        Type: 'NumInGroup',
        Description: 'Identifies the number of parties identified with an underlying instrument',
        added: 'FIX.4.4',
        AbbrName: 'NoInstrmntPty',
        addedEP: 8,
        Tag: 1058,
        NotReqXML: 1,
        Name: 'NoUndlyInstrumentParties',
    },
    {
        Type: 'String',
        Description:
            'PartyID value within an underlying instrument party repeating group.\nSame values as PartyID (448)',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'ID',
        addedEP: 8,
        Tag: 1059,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingInstrumentPartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description:
            'PartyIDSource value within an underlying instrument partyrepeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'Src',
        addedEP: 8,
        Tag: 1060,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingInstrumentPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description:
            'PartyRole value within an underlying instrument partyepeating group.\nSame values as PartyRole (452)',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'R',
        addedEP: 8,
        Tag: 1061,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingInstrumentPartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Underlying InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoInstrmntPtySubIDs',
        addedEP: 8,
        Tag: 1062,
        NotReqXML: 1,
        Name: 'NoUndlyInstrumentPartySubIDs',
    },
    {
        Type: 'String',
        Description:
            'PartySubID value within an underlying instrument party repeating group.\nSame values as PartySubID (523)',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'ID',
        addedEP: 8,
        Tag: 1063,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingInstrumentPartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Type of underlying InstrumentPartySubID (1053) value.\nSame values as PartySubIDType (803)',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'Typ',
        addedEP: 8,
        Tag: 1064,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'UnderlyingInstrumentPartySubIDType',
    },
    {
        Type: 'PriceOffset',
        Description:
            'The bid FX Swap points for an FX Swap. It is the "far bid forward points - near offer forward point". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.4',
        AbbrName: 'BidSwapPnts',
        addedEP: 21,
        Tag: 1065,
        NotReqXML: 0,
        Name: 'BidSwapPoints',
    },
    {
        Type: 'PriceOffset',
        Description:
            'The offer FX Swap points for an FX Swap. It is the "far offer forward points - near bid forward points". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.4',
        AbbrName: 'OfrSwapPnts',
        addedEP: 21,
        Tag: 1066,
        NotReqXML: 0,
        Name: 'OfferSwapPoints',
    },
    {
        Type: 'PriceOffset',
        Description:
            'The bid FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.4',
        AbbrName: 'LegBidFwdPnts',
        addedEP: 21,
        Tag: 1067,
        NotReqXML: 0,
        Name: 'LegBidForwardPoints',
    },
    {
        Type: 'PriceOffset',
        Description:
            'The offer FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
        added: 'FIX.4.4',
        AbbrName: 'LegOfrFwdPnts',
        addedEP: 21,
        Tag: 1068,
        NotReqXML: 0,
        Name: 'LegOfferForwardPoints',
    },
    {
        Type: 'PriceOffset',
        Description:
            "For FX Swap, this is used to express the differential between the far leg's bid/offer and the near leg's bid/offer. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
        added: 'FIX.4.4',
        AbbrName: 'SwapPnts',
        addedEP: 21,
        Tag: 1069,
        NotReqXML: 0,
        Name: 'SwapPoints',
    },
    {
        Type: 'int',
        Description: 'Identifies market data quote type.',
        added: 'FIX.4.4',
        AbbrName: 'MDQteTyp',
        addedEP: 7,
        Tag: 1070,
        NotReqXML: 0,
        Name: 'MDQuoteType',
    },
    {
        Type: 'PriceOffset',
        Description:
            "For FX Swap, this is used to express the last market event for the differential between the far leg's bid/offer and the near leg's bid/offer in a fill or partial fill. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
        added: 'FIX.4.4',
        AbbrName: 'LastSwapPnts',
        addedEP: 21,
        Tag: 1071,
        NotReqXML: 0,
        Name: 'LastSwapPoints',
    },
    {
        Type: 'Amt',
        Description:
            'The gross trade amount for this side of the trade. See also GrossTradeAmt (381) for additional definition.',
        added: 'FIX.4.4',
        AbbrName: 'SideGrossTradeAmt',
        addedEP: 25,
        Tag: 1072,
        NotReqXML: 0,
        Name: 'SideGrossTradeAmt',
    },
    {
        Type: 'PriceOffset',
        Description:
            "The forward points for this leg's fill event. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
        added: 'FIX.4.4',
        AbbrName: 'LegLastFwdPnts',
        addedEP: 21,
        Tag: 1073,
        NotReqXML: 0,
        Name: 'LegLastForwardPoints',
    },
    {
        Type: 'Qty',
        Description:
            'Used for the calculated quantity of the other side of the currency for this leg. Can be derived from LegQty and LegLastPx.',
        added: 'FIX.4.4',
        AbbrName: 'LegCalcCcyLastQty',
        addedEP: 21,
        Tag: 1074,
        NotReqXML: 0,
        Name: 'LegCalculatedCcyLastQty',
    },
    {
        Type: 'Amt',
        Description:
            'The gross trade amount of the leg. For FX Futures this is used to express the notional value of a fill when LegLastQty and other quantity fields are express in terms of contract size.',
        added: 'FIX.4.4',
        AbbrName: 'LegGrossTrdAmt',
        addedEP: 21,
        Tag: 1075,
        NotReqXML: 0,
        Name: 'LegGrossTradeAmt',
    },
    {
        Type: 'TZTimeOnly',
        Description: "Time of security's maturity expressed in local time with offset to UTC specified",
        added: 'FIX.4.4',
        AbbrName: 'MatTm',
        addedEP: 21,
        Tag: 1079,
        NotReqXML: 0,
        Name: 'MaturityTime',
    },
    {
        Type: 'String',
        Description: 'The ID reference to the order being hit or taken',
        added: 'FIX.4.4',
        AbbrName: 'RefOrdID',
        addedEP: 22,
        Tag: 1080,
        NotReqXML: 0,
        Name: 'RefOrderID',
    },
    {
        Type: 'char',
        Description:
            'Used to specify what identifier, provided in order depth market data, to use when hitting (taking) a specific order.',
        added: 'FIX.4.4',
        AbbrName: 'RefOrdIDSrc',
        addedEP: 22,
        Tag: 1081,
        NotReqXML: 0,
        Name: 'RefOrderIDSource',
    },
    {
        Type: 'Qty',
        Description:
            'Used for reserve orders when DisplayQty applies to the primary execution market (e.g.an ECN) and another quantity is to be shown at other markets (e.g. the exchange). On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
        added: 'FIX.4.4',
        AbbrName: 'SecDspQty',
        addedEP: 22,
        Tag: 1082,
        NotReqXML: 0,
        Name: 'SecondaryDisplayQty',
    },
    {
        Type: 'char',
        Description: 'Instructs when to refresh DisplayQty (1138).',
        added: 'FIX.4.4',
        AbbrName: 'DspWhn',
        addedEP: 22,
        Tag: 1083,
        NotReqXML: 0,
        Name: 'DisplayWhen',
    },
    {
        Type: 'char',
        Description:
            'Defines what value to use in DisplayQty (1138). If not specified the default DisplayMethod is "1"',
        added: 'FIX.4.4',
        AbbrName: 'DspMthd',
        addedEP: 22,
        Tag: 1084,
        NotReqXML: 0,
        Name: 'DisplayMethod',
    },
    {
        Type: 'Qty',
        Description: 'Defines the lower quantity limit to a randomized refresh of DisplayQty.',
        added: 'FIX.4.4',
        AbbrName: 'DsplLwQty',
        addedEP: 22,
        Tag: 1085,
        NotReqXML: 0,
        Name: 'DisplayLowQty',
    },
    {
        Type: 'Qty',
        Description: 'Defines the upper quantity limit to a randomized refresh of DisplayQty.',
        added: 'FIX.4.4',
        AbbrName: 'DisplayHighQty',
        addedEP: 22,
        Tag: 1086,
        NotReqXML: 0,
        Name: 'DisplayHighQty',
    },
    {
        Type: 'Qty',
        Description:
            'Defines the minimum increment to be used when calculating a random refresh of DisplayQty. A user specifies this when he wants a larger increment than the standard provided by the market (e.g. the round lot size).',
        added: 'FIX.4.4',
        AbbrName: 'DspMinIncr',
        addedEP: 22,
        Tag: 1087,
        NotReqXML: 0,
        Name: 'DisplayMinIncr',
    },
    {
        Type: 'Qty',
        Description: 'Defines the quantity used to refresh DisplayQty.',
        added: 'FIX.4.4',
        AbbrName: 'RfrshQty',
        addedEP: 22,
        Tag: 1088,
        NotReqXML: 0,
        Name: 'RefreshQty',
    },
    {
        Type: 'Qty',
        Description:
            'Allows orders to specify a minimum quantity that applies to every execution (one execution could be for multiple counter-orders). The order may still fill against smaller orders, but the cumulative quantity of the execution must be in multiples of the MatchIncrement.',
        added: 'FIX.4.4',
        AbbrName: 'MtchInc',
        addedEP: 22,
        Tag: 1089,
        NotReqXML: 0,
        Name: 'MatchIncrement',
    },
    {
        Type: 'int',
        Description:
            'Allows an order to specify a maximum number of price levels to trade through. Only valid for aggressive orders and during continuous (autoexecution) trading sessions. Property lost when order is put on book. A partially filled order is assigned last trade price as limit price. Non-filled order behaves as ordinary Market or Limit.',
        added: 'FIX.4.4',
        AbbrName: 'MxPxLvls',
        addedEP: 22,
        Tag: 1090,
        NotReqXML: 0,
        Name: 'MaxPriceLevels',
    },
    {
        Type: 'Boolean',
        Description:
            'Allows trader to explicitly request anonymity or disclosure in pre-trade market data feeds. Anonymity is relevant in markets where counterparties are regularly disclosed in order depth feeds. Disclosure is relevant when counterparties are not normally visible.',
        added: 'FIX.4.4',
        AbbrName: 'PrTrdAnon',
        addedEP: 22,
        Tag: 1091,
        NotReqXML: 0,
        Name: 'PreTradeAnonymity',
    },
    {
        Type: 'char',
        Description: 'Defines the type of price protection the customer requires on their order.',
        added: 'FIX.4.4',
        AbbrName: 'PxPrtScp',
        addedEP: 22,
        Tag: 1092,
        NotReqXML: 0,
        Name: 'PriceProtectionScope',
    },
    {
        Type: 'char',
        Description: 'Defines the lot type assigned to the order.',
        added: 'FIX.4.4',
        AbbrName: 'LotTyp',
        addedEP: 22,
        Tag: 1093,
        NotReqXML: 0,
        Name: 'LotType',
    },
    {
        Type: 'int',
        Description: 'Defines the type of peg.',
        added: 'FIX.4.4',
        AbbrName: 'PegPxTyp',
        addedEP: 22,
        Tag: 1094,
        NotReqXML: 0,
        Name: 'PegPriceType',
    },
    {
        Type: 'Price',
        Description:
            'The value of the reference price that the order is pegged to. PeggedRefPrice + PegOffsetValue (211) = PeggedPrice (839) unless the limit price (44, Price) is breached. The values may not be exact due to rounding.',
        added: 'FIX.4.4',
        AbbrName: 'PggdRefPx',
        addedEP: 22,
        Tag: 1095,
        NotReqXML: 0,
        Name: 'PeggedRefPrice',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            'Defines the identity of the security off whose prices the order will peg. Same values as SecurityIDSource (22)',
        added: 'FIX.4.4',
        AbbrName: 'PegSecurityIDSource',
        addedEP: 22,
        Tag: 1096,
        NotReqXML: 0,
        Name: 'PegSecurityIDSource',
    },
    {
        Type: 'String',
        Description: 'Defines the identity of the security off whose prices the order will peg.',
        added: 'FIX.4.4',
        AbbrName: 'PegSecID',
        addedEP: 22,
        Tag: 1097,
        NotReqXML: 0,
        Name: 'PegSecurityID',
    },
    {
        Type: 'String',
        Description:
            "Defines the common, 'human understood' representation of the security off whose prices the order will Peg.",
        added: 'FIX.4.4',
        AbbrName: 'PgSymbl',
        addedEP: 22,
        Tag: 1098,
        NotReqXML: 0,
        Name: 'PegSymbol',
    },
    {
        Type: 'String',
        Description: 'Security description of the security off whose prices the order will Peg.',
        added: 'FIX.4.4',
        AbbrName: 'PegSecDesc',
        addedEP: 22,
        Tag: 1099,
        NotReqXML: 0,
        Name: 'PegSecurityDesc',
    },
    {
        Type: 'char',
        Description:
            'Defines when the trigger will hit, i.e. the action specified by the trigger instructions will come into effect.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrTyp',
        addedEP: -1,
        Tag: 1100,
        NotReqXML: 0,
        Name: 'TriggerType',
    },
    {
        Type: 'char',
        Description: 'Defines the type of action to take when the trigger hits.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrActn',
        addedEP: -1,
        Tag: 1101,
        NotReqXML: 0,
        Name: 'TriggerAction',
    },
    {
        Type: 'Price',
        Description: 'The price at which the trigger should hit.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrPx',
        addedEP: -1,
        Tag: 1102,
        NotReqXML: 0,
        Name: 'TriggerPrice',
    },
    {
        Type: 'String',
        Description:
            "Defines the common, 'human understood' representation of the security whose prices will be tracked by the trigger logic.",
        added: 'FIX.5.0',
        AbbrName: 'TrgrSym',
        addedEP: -1,
        Tag: 1103,
        NotReqXML: 0,
        Name: 'TriggerSymbol',
    },
    {
        Type: 'String',
        Description: 'Defines the identity of the security whose prices will be tracked by the trigger logic.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrSecID',
        addedEP: -1,
        Tag: 1104,
        NotReqXML: 0,
        Name: 'TriggerSecurityID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description:
            'Defines the identity of the security whose prices will be tracked by the trigger logic. Same values as SecurityIDSource (22).',
        added: 'FIX.5.0',
        AbbrName: 'TrgrSecIDSrc',
        addedEP: -1,
        Tag: 1105,
        NotReqXML: 0,
        Name: 'TriggerSecurityIDSource',
    },
    {
        Type: 'String',
        Description:
            'Defines the security description of the security whose prices will be tracked by the trigger logic.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrSecDesc',
        addedEP: -1,
        Tag: 1106,
        NotReqXML: 0,
        Name: 'TriggerSecurityDesc',
    },
    {
        Type: 'char',
        Description: 'The type of price that the trigger is compared to.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrPxTyp',
        addedEP: -1,
        Tag: 1107,
        NotReqXML: 0,
        Name: 'TriggerPriceType',
    },
    {
        Type: 'char',
        Description: 'Defines the type of price protection the customer requires on their order.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrPxTypScp',
        addedEP: -1,
        Tag: 1108,
        NotReqXML: 0,
        Name: 'TriggerPriceTypeScope',
    },
    {
        Type: 'char',
        Description: 'The side from which the trigger price is reached.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrPxDir',
        addedEP: -1,
        Tag: 1109,
        NotReqXML: 0,
        Name: 'TriggerPriceDirection',
    },
    {
        Type: 'Price',
        Description:
            'The Price that the order should have after the trigger has hit. Could be applicable for any trigger type, but must be specified for Trigger Type 1.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrNewPx',
        addedEP: -1,
        Tag: 1110,
        NotReqXML: 0,
        Name: 'TriggerNewPrice',
    },
    {
        Type: 'char',
        Description:
            'The OrdType the order should have after the trigger has hit. Required to express orders that change from Limit to Market. Other values from OrdType (40) may be used if appropriate and bilaterally agreed upon.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrOrdTyp',
        addedEP: -1,
        Tag: 1111,
        NotReqXML: 0,
        Name: 'TriggerOrderType',
    },
    {
        Type: 'Qty',
        Description: 'The Quantity the order should have after the trigger has hit.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrNewQty',
        addedEP: -1,
        Tag: 1112,
        NotReqXML: 0,
        Name: 'TriggerNewQty',
    },
    {
        Type: 'String',
        Description: 'Defines the trading session at which the order will be activated.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrTrdSessID',
        addedEP: -1,
        Tag: 1113,
        NotReqXML: 0,
        Name: 'TriggerTradingSessionID',
    },
    {
        Type: 'String',
        Description: 'Defines the subordinate trading session at which the order will be activated.',
        added: 'FIX.5.0',
        AbbrName: 'TrgrTrdSessSubID',
        addedEP: -1,
        Tag: 1114,
        NotReqXML: 0,
        Name: 'TriggerTradingSessionSubID',
    },
    {
        Type: 'char',
        Description: 'Defines the type of interest behind a trade (fill or partial fill).',
        added: 'FIX.4.4',
        AbbrName: 'OrdCat',
        addedEP: 22,
        Tag: 1115,
        NotReqXML: 0,
        Name: 'OrderCategory',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of RootPartyID (1117), RootPartyIDSource (1118), and RootPartyRole (1119) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoRootPartyIDs',
        addedEP: 22,
        Tag: 1116,
        NotReqXML: 1,
        Name: 'NoRootPartyIDs',
    },
    {
        Type: 'String',
        Description: 'PartyID value within a root parties component. Same values as PartyID (448)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        addedEP: 22,
        Tag: 1117,
        NotReqXML: 0,
        Name: 'RootPartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description: 'PartyIDSource value within a root parties component. Same values as PartyIDSource (447)',
        added: 'FIX.4.4',
        AbbrName: 'Src',
        addedEP: 22,
        Tag: 1118,
        NotReqXML: 0,
        Name: 'RootPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'PartyRole value within a root parties component. Same values as PartyRole (452)',
        added: 'FIX.4.4',
        AbbrName: 'R',
        addedEP: 22,
        Tag: 1119,
        NotReqXML: 0,
        Name: 'RootPartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of RootPartySubID (1121) and RootPartySubIDType (1122) entries',
        added: 'FIX.4.4',
        AbbrName: 'NoRootPartySubIDs',
        addedEP: 22,
        Tag: 1120,
        NotReqXML: 1,
        Name: 'NoRootPartySubIDs',
    },
    {
        Type: 'String',
        Description: 'PartySubID value within a root parties component. Same values as PartySubID (523)',
        added: 'FIX.4.4',
        AbbrName: 'ID',
        addedEP: 22,
        Tag: 1121,
        NotReqXML: 0,
        Name: 'RootPartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Type of RootPartySubID (1121) value. Same values as PartySubIDType (803)',
        added: 'FIX.4.4',
        AbbrName: 'Typ',
        addedEP: 22,
        Tag: 1122,
        NotReqXML: 0,
        Name: 'RootPartySubIDType',
    },
    {
        Type: 'char',
        Description: 'Specified how the Trade Capture Report should be handled by the Respondent.',
        added: 'FIX.4.4',
        AbbrName: 'TrdHandlInst',
        addedEP: 23,
        Tag: 1123,
        NotReqXML: 0,
        Name: 'TradeHandlingInstr',
    },
    {
        Type: 'char',
        EnumDatatype: 1123,
        Description:
            'Optionally used with TradeHandlingInstr = 0 to relay the trade handling instruction used when reporting the trade to the marketplace. Same values as TradeHandlingInstr (1123)',
        added: 'FIX.4.4',
        AbbrName: 'OrigTrdHandlInst',
        addedEP: 23,
        Tag: 1124,
        NotReqXML: 0,
        Name: 'OrigTradeHandlingInstr',
    },
    {
        Type: 'LocalMktDate',
        Description:
            'Used to preserve original trade date when original trade is being referenced in a subsequent trade transaction such as a transfer',
        added: 'FIX.4.4',
        AbbrName: 'OrigTrdDt',
        addedEP: 23,
        Tag: 1125,
        NotReqXML: 0,
        Name: 'OrigTradeDate',
    },
    {
        Type: 'String',
        Description:
            'Used to preserve original trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
        added: 'FIX.4.4',
        AbbrName: 'OrigTrdID',
        addedEP: 23,
        Tag: 1126,
        NotReqXML: 0,
        Name: 'OrigTradeID',
    },
    {
        Type: 'String',
        Description:
            'Used to preserve original secondary trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
        added: 'FIX.4.4',
        AbbrName: 'OrignTrdID2',
        addedEP: 23,
        Tag: 1127,
        NotReqXML: 0,
        Name: 'OrigSecondaryTradeID',
    },
    {
        Type: 'String',
        Description:
            'Specifies the service pack release being applied at message level. Enumerated field with values assigned at time of service pack release',
        added: 'FIX.4.4',
        AbbrName: 'ApplVerID',
        addedEP: 16,
        Tag: 1128,
        NotReqXML: 0,
        Name: 'ApplVerID',
    },
    {
        Type: 'String',
        Description: 'Specifies a custom extension to a message being applied at the message level. Enumerated field',
        added: 'FIX.4.4',
        AbbrName: 'CstmApplVerID',
        addedEP: 16,
        Tag: 1129,
        NotReqXML: 1,
        Name: 'CstmApplVerID',
    },
    {
        Type: 'String',
        EnumDatatype: 1128,
        Description:
            'Specifies the service pack release being applied to a message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
        added: 'FIX.4.4',
        AbbrName: 'RefApplVerID',
        addedEP: 16,
        Tag: 1130,
        NotReqXML: 0,
        Name: 'RefApplVerID',
    },
    {
        Type: 'String',
        Description: 'Specifies a custom extension to a message being applied at the session level.',
        added: 'FIX.4.4',
        AbbrName: 'RefCstmApplVerID',
        addedEP: 16,
        Tag: 1131,
        NotReqXML: 0,
        Name: 'RefCstmApplVerID',
    },
    {
        Type: 'TZTimestamp',
        Description: 'Transact time in the local date-time stamp with a TZ offset to UTC identified',
        added: 'FIX.4.4',
        AbbrName: 'TZTransactTime',
        addedEP: 26,
        Tag: 1132,
        NotReqXML: 0,
        Name: 'TZTransactTime',
    },
    {
        Type: 'char',
        Description: 'The ID source of ExDestination',
        added: 'FIX.4.4',
        AbbrName: 'ExDestIDSrc',
        addedEP: 26,
        Tag: 1133,
        NotReqXML: 0,
        Name: 'ExDestinationIDSource',
    },
    {
        Type: 'Boolean',
        Description:
            'Indicates that the reported price that is different from the market price. The price difference should be stated by using field 828 TrdType and, if required, field 829 TrdSubType',
        added: 'FIX.4.4',
        AbbrName: 'ReportedPxDiff',
        addedEP: 26,
        Tag: 1134,
        NotReqXML: 0,
        Name: 'ReportedPxDiff',
    },
    {
        Type: 'String',
        Description: 'Indicates the system or medium on which the report has been published',
        added: 'FIX.4.4',
        AbbrName: 'RptSys',
        addedEP: 26,
        Tag: 1135,
        NotReqXML: 0,
        Name: 'RptSys',
    },
    {
        Type: 'String',
        Description: 'ClearingFeeIndicator(635) for Allocation, see ClearingFeeIndicator(635) for permitted values.',
        added: 'FIX.4.4',
        AbbrName: 'ClrFeeInd',
        addedEP: 25,
        Tag: 1136,
        NotReqXML: 0,
        Name: 'AllocClearingFeeIndicator',
    },
    {
        Type: 'String',
        EnumDatatype: 1128,
        Description:
            'Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
        added: 'FIX.4.4',
        AbbrName: 'DefApplVerID',
        addedEP: 16,
        Tag: 1137,
        NotReqXML: 0,
        Name: 'DefaultApplVerID',
    },
    {
        Type: 'Qty',
        Description:
            'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
        added: 'FIX.4.4',
        AbbrName: 'DisplayQty',
        addedEP: 22,
        Tag: 1138,
        NotReqXML: 0,
        Name: 'DisplayQty',
    },
    {
        Type: 'String',
        Description: 'Free format text string related to exchange.',
        added: 'FIX.4.4',
        updatedEP: 95,
        AbbrName: 'ExchSpeclInstr',
        addedEP: 29,
        Tag: 1139,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'ExchangeSpecialInstructions',
    },
    {
        Type: 'TZTimeOnly',
        Description: "Time of security's maturity expressed in local time with offset to UTC specified",
        added: 'FIX.5.0',
        AbbrName: 'MatTm',
        addedEP: 41,
        Tag: 1213,
        NotReqXML: 0,
        Name: 'UnderlyingMaturityTime',
    },
    {
        Type: 'TZTimeOnly',
        Description: "Time of security's maturity expressed in local time with offset to UTC specified",
        added: 'FIX.5.0',
        AbbrName: 'MatTm',
        addedEP: 41,
        Tag: 1212,
        NotReqXML: 0,
        Name: 'LegMaturityTime',
    },
    {
        Type: 'Qty',
        Description: 'The maximum order quantity that can be submitted for a security.',
        added: 'FIX.5.0',
        AbbrName: 'MaxTrdVol',
        addedEP: 42,
        Tag: 1140,
        NotReqXML: 0,
        Name: 'MaxTradeVol',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of feed types and corresponding book depths associated with a security',
        added: 'FIX.5.0',
        AbbrName: 'NoMDFeedTypes',
        addedEP: 42,
        Tag: 1141,
        NotReqXML: 1,
        Name: 'NoMDFeedTypes',
    },
    {
        Type: 'String',
        Description:
            'The types of algorithm used to match orders in a specific security. Possilbe value types are FIFO, Allocation, Pro-rata, Lead Market Maker, Currency Calender.',
        added: 'FIX.5.0',
        AbbrName: 'MtchAlgo',
        addedEP: 42,
        Tag: 1142,
        NotReqXML: 0,
        Name: 'MatchAlgorithm',
    },
    {
        Type: 'float',
        Description: 'The maximum price variation of an execution from one event to the next for a given security.',
        added: 'FIX.5.0',
        AbbrName: 'MxPxVar',
        addedEP: 42,
        Tag: 1143,
        NotReqXML: 0,
        Name: 'MaxPriceVariation',
    },
    {
        Type: 'int',
        Description:
            'Indicates that an implied market should be created for either the legs of a multi-leg instrument (Implied-in) or for the multi-leg instrument based on the existence of the legs (Implied-out). Determination as to whether implied markets should be created is generally done at the level of the multi-leg instrument. Commonly used in listed derivatives.',
        added: 'FIX.5.0',
        AbbrName: 'ImpldMktInd',
        addedEP: 42,
        Tag: 1144,
        NotReqXML: 0,
        Name: 'ImpliedMarketIndicator',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'Specific time of event. To be used in combination with EventDate [866]',
        added: 'FIX.5.0',
        AbbrName: 'Tm',
        addedEP: 42,
        Tag: 1145,
        NotReqXML: 0,
        Name: 'EventTime',
    },
    {
        Type: 'Amt',
        Description:
            'Minimum price increment amount associated with the MinPriceIncrement ( tag 969). For listed derivatives, the value can be calculated by multiplying MinPriceIncrement by ContractValueFactor(231).',
        added: 'FIX.5.0',
        AbbrName: 'MinPxIncrAmt',
        addedEP: 42,
        Tag: 1146,
        NotReqXML: 0,
        Name: 'MinPriceIncrementAmount',
    },
    {
        Type: 'Qty',
        Description:
            'Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based, such as, 2500 lbs of lean cattle, 1000 barrels of crude oil, 1000 bushels of corn, etc. UnitOfMeasureQty is required for UnitOfMeasure(996) Variable Quantity UOMs enumerations. Refer to the definition of UnitOfMeasure(996) for more information on the use of UnitOfMeasureQty.',
        added: 'FIX.5.0',
        AbbrName: 'UOMQty',
        addedEP: 42,
        Tag: 1147,
        NotReqXML: 0,
        Name: 'UnitOfMeasureQty',
    },
    {
        Type: 'Price',
        Description:
            'Allowable low limit price for the trading day. A key parameter in validating order price. Used as the lower band for validating order prices. Orders submitted with prices below the lower limit will be rejected',
        added: 'FIX.5.0',
        AbbrName: 'LowLmtPx',
        addedEP: 42,
        Tag: 1148,
        NotReqXML: 0,
        Name: 'LowLimitPrice',
    },
    {
        Type: 'Price',
        Description:
            'Allowable high limit price for the trading day. A key parameter in validating order price. Used as the upper band for validating order prices. Orders submitted with prices above the upper limit will be rejected',
        added: 'FIX.5.0',
        updatedEP: 76,
        AbbrName: 'HiLmtPx',
        addedEP: 42,
        Tag: 1149,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'HighLimitPrice',
    },
    {
        Type: 'Price',
        Description:
            'Reference price for the current trading price range usually representing the mid price between the HighLimitPrice and LowLimitPrice. The value may be the settlement price or closing price of the prior trading day.',
        added: 'FIX.5.0',
        AbbrName: 'TrdgRefPx',
        addedEP: 42,
        Tag: 1150,
        NotReqXML: 0,
        Name: 'TradingReferencePrice',
    },
    {
        Type: 'String',
        Description:
            'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.',
        added: 'FIX.5.0',
        AbbrName: 'SecGrp',
        addedEP: 42,
        Tag: 1151,
        NotReqXML: 0,
        Name: 'SecurityGroup',
    },
    {
        Type: 'int',
        Description: 'Allow sequencing of Legs for a Strategy to be captured',
        added: 'FIX.5.0',
        AbbrName: 'LegNo',
        addedEP: 44,
        Tag: 1152,
        NotReqXML: 0,
        Name: 'LegNumber',
    },
    {
        Type: 'int',
        Description: 'Settlement cycle in which the settlement obligation was generated',
        added: 'FIX.5.0',
        AbbrName: 'CycleNo',
        addedEP: 44,
        Tag: 1153,
        NotReqXML: 0,
        Name: 'SettlementCycleNo',
    },
    {
        Type: 'Currency',
        Description: 'Used to identify the trading currency on the Trade Capture Report Side',
        added: 'FIX.5.0',
        AbbrName: 'Ccy',
        addedEP: 44,
        Tag: 1154,
        NotReqXML: 0,
        Name: 'SideCurrency',
    },
    {
        Type: 'Currency',
        Description: 'Used to identify the settlement currency on the Trade Capture Report Side',
        added: 'FIX.5.0',
        AbbrName: 'SettlCcy',
        addedEP: 44,
        Tag: 1155,
        NotReqXML: 0,
        Name: 'SideSettlCurrency',
    },
    {
        Type: 'Amt',
        Description: 'Net flow of Currency 1',
        added: 'FIX.5.0',
        AbbrName: 'CcyAmt',
        addedEP: 44,
        Tag: 1157,
        NotReqXML: 0,
        Name: 'CcyAmt',
    },
    {
        Type: 'NumInGroup',
        Description: 'Used to group Each Settlement Party',
        added: 'FIX.5.0',
        AbbrName: 'NoSettlDetails',
        addedEP: 44,
        Tag: 1158,
        NotReqXML: 1,
        Name: 'NoSettlDetails',
    },
    {
        Type: 'int',
        Description:
            'Used to identify the reporting mode of the settlement obligation which is either preliminary or final',
        added: 'FIX.5.0',
        AbbrName: 'SettlMode',
        addedEP: 44,
        Tag: 1159,
        NotReqXML: 0,
        Name: 'SettlObligMode',
    },
    {
        Type: 'String',
        Description: 'Message identifier for Settlement Obligation Report',
        added: 'FIX.5.0',
        AbbrName: 'SettlMsgID',
        addedEP: 44,
        Tag: 1160,
        NotReqXML: 0,
        Name: 'SettlObligMsgID',
    },
    {
        Type: 'String',
        Description: 'Unique ID for this settlement instruction.',
        added: 'FIX.5.0',
        AbbrName: 'SettlID',
        addedEP: 44,
        Tag: 1161,
        NotReqXML: 0,
        Name: 'SettlObligID',
    },
    {
        Type: 'char',
        Description: 'Transaction Type - required except where SettlInstMode is 5=Reject SSI request',
        added: 'FIX.5.0',
        AbbrName: 'SettlTransTyp',
        addedEP: 44,
        Tag: 1162,
        NotReqXML: 0,
        Name: 'SettlObligTransType',
    },
    {
        Type: 'String',
        Description: 'Required where SettlInstTransType is Cancel or Replace',
        added: 'FIX.5.0',
        AbbrName: 'SettlRefID',
        addedEP: 44,
        Tag: 1163,
        NotReqXML: 0,
        Name: 'SettlObligRefID',
    },
    {
        Type: 'char',
        Description: 'Used to identify whether these delivery instructions are for the buyside or the sellside.',
        added: 'FIX.5.0',
        AbbrName: 'SettlSrc',
        addedEP: 44,
        Tag: 1164,
        NotReqXML: 0,
        Name: 'SettlObligSource',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of settlement obligations',
        added: 'FIX.5.0',
        AbbrName: 'NoSettlOblig',
        addedEP: 44,
        Tag: 1165,
        NotReqXML: 1,
        Name: 'NoSettlOblig',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a quote message.',
        added: 'FIX.5.0',
        AbbrName: 'QtMsgID',
        addedEP: 45,
        Tag: 1166,
        NotReqXML: 0,
        Name: 'QuoteMsgID',
    },
    {
        Type: 'int',
        Description:
            'Identifies the status of an individual quote. See also QuoteStatus(297) which is used for single Quotes.',
        added: 'FIX.5.0',
        updatedEP: 95,
        AbbrName: 'QtEntSts',
        addedEP: 45,
        Tag: 1167,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'QuoteEntryStatus',
    },
    {
        Type: 'int',
        Description: 'Specifies the number of canceled quotes',
        added: 'FIX.5.0',
        AbbrName: 'TotNoCxldQts',
        addedEP: 45,
        Tag: 1168,
        NotReqXML: 0,
        Name: 'TotNoCxldQuotes',
    },
    {
        Type: 'int',
        Description: 'Specifies the number of accepted quotes',
        added: 'FIX.5.0',
        AbbrName: 'TotNoAccQts',
        addedEP: 45,
        Tag: 1169,
        NotReqXML: 0,
        Name: 'TotNoAccQuotes',
    },
    {
        Type: 'int',
        Description: 'Specifies the number of rejected quotes',
        added: 'FIX.5.0',
        AbbrName: 'TotNoRejQts',
        addedEP: 45,
        Tag: 1170,
        NotReqXML: 0,
        Name: 'TotNoRejQuotes',
    },
    {
        Type: 'Boolean',
        Description:
            'Specifies whether a quote is public, i.e. available to the market, or private, i.e. available to a specified counterparty only.',
        added: 'FIX.5.0',
        AbbrName: 'PrvtQt',
        addedEP: 46,
        Tag: 1171,
        NotReqXML: 0,
        Name: 'PrivateQuote',
    },
    {
        Type: 'int',
        Description: 'Specifies the type of respondents requested.',
        added: 'FIX.5.0',
        AbbrName: 'RspdntTyp',
        addedEP: 46,
        Tag: 1172,
        NotReqXML: 0,
        Name: 'RespondentType',
    },
    {
        Type: 'int',
        Description:
            'Describes a class of sub book, e.g. for the separation of various lot types. The Sub Book Type indicates that the following Market Data Entries belong to a non-integrated Sub Book. Whenever provided the Sub Book must be used together with MDPriceLevel and MDEntryPositionNo in order to sort the order properly.\nValues are bilaterally agreed.',
        added: 'FIX.5.0',
        AbbrName: 'MDSubBkTyp',
        addedEP: 47,
        Tag: 1173,
        NotReqXML: 0,
        Name: 'MDSubBookType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Identifies an event related to a SecurityTradingStatus(326). An event occurs and is gone, it is not a state that applies for a period of time.',
        added: 'FIX.5.0',
        AbbrName: 'SecTrdEvnt',
        addedEP: 47,
        Tag: 1174,
        NotReqXML: 0,
        Name: 'SecurityTradingEvent',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of statistics indicator repeating group entries',
        added: 'FIX.5.0',
        AbbrName: 'NoStatsInds',
        addedEP: 47,
        Tag: 1175,
        NotReqXML: 1,
        Name: 'NoStatsIndicators',
    },
    {
        Type: 'int',
        Description: 'Type of statistics',
        added: 'FIX.5.0',
        AbbrName: 'StatsTyp',
        addedEP: 47,
        Tag: 1176,
        NotReqXML: 0,
        Name: 'StatsType',
    },
    {
        Type: 'NumInGroup',
        Description: 'The number of secondary sizes specifies in this entry',
        added: 'FIX.5.0',
        AbbrName: 'NoSecSzs',
        addedEP: 47,
        Tag: 1177,
        NotReqXML: 1,
        Name: 'NoOfSecSizes',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Specifies the type of secondary size.',
        added: 'FIX.5.0',
        AbbrName: 'MDSecSizeType',
        addedEP: 47,
        Tag: 1178,
        NotReqXML: 0,
        Name: 'MDSecSizeType',
    },
    {
        Type: 'Qty',
        Description:
            'A part of the MDEntrySize(271) that represents secondary interest as specified by MDSecSizeType(1178).',
        added: 'FIX.5.0',
        AbbrName: 'MDSecSize',
        addedEP: 47,
        Tag: 1179,
        NotReqXML: 0,
        Name: 'MDSecSize',
    },
    {
        Type: 'String',
        Description:
            'Identifies the application with which a message is associated. Used only if application sequencing is in effect.',
        added: 'FIX.5.0',
        AbbrName: 'ApplID',
        addedEP: 48,
        Tag: 1180,
        NotReqXML: 0,
        Name: 'ApplID',
    },
    {
        Type: 'SeqNum',
        Description: 'Data sequence number to be used when FIX session is not in effect',
        added: 'FIX.5.0',
        AbbrName: 'ApplSeqNum',
        addedEP: 48,
        Tag: 1181,
        NotReqXML: 0,
        Name: 'ApplSeqNum',
    },
    {
        Type: 'SeqNum',
        Description: 'Beginning range of application sequence numbers',
        added: 'FIX.5.0',
        AbbrName: 'ApplBegSeqNum',
        addedEP: 48,
        Tag: 1182,
        NotReqXML: 0,
        Name: 'ApplBegSeqNum',
    },
    {
        Type: 'SeqNum',
        Description: 'Ending range of application sequence numbers',
        added: 'FIX.5.0',
        AbbrName: 'ApplEndSeq',
        addedEP: 48,
        Tag: 1183,
        NotReqXML: 0,
        Name: 'ApplEndSeqNum',
    },
    {
        Type: 'Length',
        Description: 'Lenght of the SecurityXML data block.',
        added: 'FIX.5.0',
        AssociatedDataTag: 1185,
        AbbrName: 'SecXMLLen',
        addedEP: 49,
        Tag: 1184,
        NotReqXML: 1,
        Name: 'SecurityXMLLen',
    },
    {
        Type: 'XMLData',
        Description: 'Actual XML data stream describing a security, normally FpML.',
        added: 'FIX.5.0',
        AbbrName: 'SecXML',
        addedEP: 49,
        Tag: 1185,
        NotReqXML: 1,
        Name: 'SecurityXML',
    },
    {
        Type: 'String',
        Description: 'The schema used to validate the contents of SecurityXML',
        added: 'FIX.5.0',
        AbbrName: 'Schema',
        addedEP: 49,
        Tag: 1186,
        NotReqXML: 0,
        Name: 'SecurityXMLSchema',
    },
    {
        Type: 'Boolean',
        Description:
            "Set by the sender to tell the receiver to perform an immediate refresh of the book due to disruptions in the accompanying real-time feed\n'Y' - Mandatory refresh by all participants\n'N' - Process as required",
        added: 'FIX.5.0',
        AbbrName: 'RefInd',
        addedEP: 50,
        Tag: 1187,
        NotReqXML: 0,
        Name: 'RefreshIndicator',
    },
    {
        Type: 'float',
        Description: 'Annualized volatility for option model calculations',
        added: 'FIX.5.0',
        AbbrName: 'Vol',
        addedEP: 51,
        Tag: 1188,
        NotReqXML: 0,
        Name: 'Volatility',
    },
    {
        Type: 'float',
        Description:
            'Time to expiration in years calculated as the number of days remaining to expiration divided by 365 days per year.',
        added: 'FIX.5.0',
        AbbrName: 'TmToExp',
        addedEP: 51,
        Tag: 1189,
        NotReqXML: 0,
        Name: 'TimeToExpiration',
    },
    {
        Type: 'float',
        Description: 'Interest rate. Usually some form of short term rate.',
        added: 'FIX.5.0',
        AbbrName: 'RFR',
        addedEP: 51,
        Tag: 1190,
        NotReqXML: 0,
        Name: 'RiskFreeRate',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description:
            'Used to express the UOM of the price if different from the contract. In futures, this can be different for cross-rate products in which the price is quoted in units differently from the contract',
        added: 'FIX.5.0',
        AbbrName: 'PxUOM',
        addedEP: 52,
        Tag: 1191,
        NotReqXML: 0,
        Name: 'PriceUnitOfMeasure',
    },
    {
        Type: 'Qty',
        Description:
            'Used to express the UOM Quantity of the price if different from the contract. In futures, this can be different for physically delivered products in which price is quoted in a unit size different from the contract, i.e. a Cattle Future contract has a UOMQty of 40,000 and a PriceUOMQty of 100.',
        added: 'FIX.5.0',
        AbbrName: 'PxUOMQty',
        addedEP: 52,
        Tag: 1192,
        NotReqXML: 0,
        Name: 'PriceUnitOfMeasureQty',
    },
    {
        Type: 'char',
        Description: 'Settlement method for a contract. Can be used as an alternative to CFI Code value',
        added: 'FIX.5.0',
        AbbrName: 'SettlMeth',
        addedEP: 52,
        Tag: 1193,
        NotReqXML: 0,
        Name: 'SettlMethod',
    },
    {
        Type: 'int',
        Description: 'Type of exercise of a derivatives security',
        added: 'FIX.5.0',
        AbbrName: 'ExerStyle',
        addedEP: 52,
        Tag: 1194,
        NotReqXML: 0,
        Name: 'ExerciseStyle',
    },
    {
        Type: 'int',
        EnumDatatype: 1194,
        Description: 'Type of exercise of a derivatives security',
        added: 'FIX.5.0',
        AbbrName: 'ExerStyle',
        addedEP: 52,
        Tag: 1419,
        NotReqXML: 0,
        Name: 'UnderlyingExerciseStyle',
    },
    {
        Type: 'int',
        EnumDatatype: 1194,
        Description: 'Type of exercise of a derivatives security',
        added: 'FIX.5.0',
        AbbrName: 'ExerStyle',
        addedEP: 52,
        Tag: 1420,
        NotReqXML: 0,
        Name: 'LegExerciseStyle',
    },
    {
        Type: 'Amt',
        Description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount. \nConditionally required if OptPayoutType(1482) is set to binary.',
        added: 'FIX.5.0',
        updatedEP: 92,
        AbbrName: 'OptPayAmt',
        addedEP: 52,
        Tag: 1195,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'OptPayoutAmount',
    },
    {
        Type: 'String',
        Description: 'Method for price quotation',
        added: 'FIX.5.0',
        AbbrName: 'PxQteMeth',
        addedEP: 52,
        Tag: 1196,
        NotReqXML: 0,
        Name: 'PriceQuoteMethod',
    },
    {
        Type: 'String',
        Description: 'Specifies the type of valuation method applied.',
        added: 'FIX.5.0',
        updatedEP: 83,
        AbbrName: 'ValMeth',
        addedEP: 52,
        Tag: 1197,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'ValuationMethod',
    },
    {
        Type: 'int',
        Description: 'Indicates whether instruments are pre-listed only or can also be defined via user request',
        added: 'FIX.5.0',
        AbbrName: 'ListMeth',
        addedEP: 52,
        Tag: 1198,
        NotReqXML: 0,
        Name: 'ListMethod',
    },
    {
        Type: 'Price',
        Description: 'Used to express the ceiling price of a capped call',
        added: 'FIX.5.0',
        AbbrName: 'CapPx',
        addedEP: 52,
        Tag: 1199,
        NotReqXML: 0,
        Name: 'CapPrice',
    },
    {
        Type: 'Price',
        Description: 'Used to express the floor price of a capped put',
        added: 'FIX.5.0',
        AbbrName: 'FlrPx',
        addedEP: 52,
        Tag: 1200,
        NotReqXML: 0,
        Name: 'FloorPrice',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of strike rule entries. This block specifies the rules for determining how new strikes should be listed within the stated price range of the underlying instrument',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1201,
        NotReqXML: 1,
        Name: 'NoStrikeRules',
    },
    {
        Type: 'Price',
        Description:
            'Starting price for the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
        added: 'FIX.5.0',
        AbbrName: 'StartStrkPxRng',
        addedEP: 52,
        Tag: 1202,
        NotReqXML: 0,
        Name: 'StartStrikePxRange',
    },
    {
        Type: 'Price',
        Description:
            'Ending price of the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
        added: 'FIX.5.0',
        AbbrName: 'EndStrkPxRng',
        addedEP: 52,
        Tag: 1203,
        NotReqXML: 0,
        Name: 'EndStrikePxRange',
    },
    {
        Type: 'float',
        Description: 'Value by which strike price should be incremented within the specified price range.',
        added: 'FIX.5.0',
        AbbrName: 'StrkIncr',
        addedEP: 52,
        Tag: 1204,
        NotReqXML: 0,
        Name: 'StrikeIncrement',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of tick rules. This block specifies the rules for determining how a security ticks, i.e. the price increments at which it can be quoted and traded, depending on the current price of the security',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1205,
        NotReqXML: 1,
        Name: 'NoTickRules',
    },
    {
        Type: 'Price',
        Description: 'Starting price range for specified tick increment',
        added: 'FIX.5.0',
        AbbrName: 'StartTickPxRng',
        addedEP: 52,
        Tag: 1206,
        NotReqXML: 0,
        Name: 'StartTickPriceRange',
    },
    {
        Type: 'Price',
        Description: 'Ending price range for the specified tick increment',
        added: 'FIX.5.0',
        AbbrName: 'EndTickPxRng',
        addedEP: 52,
        Tag: 1207,
        NotReqXML: 0,
        Name: 'EndTickPriceRange',
    },
    {
        Type: 'Price',
        Description:
            'Tick increment for stated price range. Specifies the valid price increments at which a security can be quoted and traded',
        added: 'FIX.5.0',
        AbbrName: 'TickIncr',
        addedEP: 52,
        Tag: 1208,
        NotReqXML: 0,
        Name: 'TickIncrement',
    },
    {
        Type: 'int',
        Description: 'Specifies the type of tick rule which is being described',
        added: 'FIX.5.0',
        AbbrName: 'TickRuleTyp',
        addedEP: 52,
        Tag: 1209,
        NotReqXML: 0,
        Name: 'TickRuleType',
    },
    {
        Type: 'int',
        EnumDatatype: 871,
        Description: 'Code to represent the type of instrument attribute',
        added: 'FIX.5.0',
        AbbrName: 'Typ',
        addedEP: 52,
        Tag: 1210,
        NotReqXML: 0,
        Name: 'NestedInstrAttribType',
    },
    {
        Type: 'String',
        Description: 'Attribute value appropriate to the NestedInstrAttribType field',
        added: 'FIX.5.0',
        AbbrName: 'Val',
        addedEP: 52,
        Tag: 1211,
        NotReqXML: 0,
        Name: 'NestedInstrAttribValue',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for Symbol(55)',
        added: 'FIX.5.0',
        AbbrName: 'Sym',
        addedEP: 52,
        Tag: 1214,
        NotReqXML: 0,
        Name: 'DerivativeSymbol',
    },
    {
        Type: 'String',
        EnumDatatype: 65,
        Description: 'Refer to definition for SymbolSfx(65)',
        added: 'FIX.5.0',
        AbbrName: 'Sfx',
        addedEP: 52,
        Tag: 1215,
        NotReqXML: 0,
        Name: 'DerivativeSymbolSfx',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityID(48)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 52,
        Tag: 1216,
        NotReqXML: 0,
        Name: 'DerivativeSecurityID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description: 'Refer to definition for SecurityIDSoruce(22)',
        added: 'FIX.5.0',
        AbbrName: 'Src',
        addedEP: 52,
        Tag: 1217,
        NotReqXML: 0,
        Name: 'DerivativeSecurityIDSource',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition for NoSecurityAltID(454)',
        added: 'FIX.5.0',
        AbbrName: 'NoDerivativeSecurityAltID',
        addedEP: 52,
        Tag: 1218,
        NotReqXML: 1,
        Name: 'NoDerivativeSecurityAltID',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityAltID(455)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 52,
        Tag: 1219,
        NotReqXML: 0,
        Name: 'DerivativeSecurityAltID',
    },
    {
        Type: 'String',
        EnumDatatype: 22,
        Description: 'Refer to definition for SecurityAltIDSource(456)',
        added: 'FIX.5.0',
        AbbrName: 'Src',
        addedEP: 52,
        Tag: 1220,
        NotReqXML: 0,
        Name: 'DerivativeSecurityAltIDSource',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition of LowLimitPrice(1148)',
        added: 'FIX.5.0',
        AbbrName: 'LowLmtPx',
        addedEP: 52,
        Tag: 1221,
        NotReqXML: 0,
        Name: 'SecondaryLowLimitPrice',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition of HighLimitPrice(1149)',
        added: 'FIX.5.0',
        AbbrName: 'HiLmtPx',
        addedEP: 52,
        Tag: 1230,
        NotReqXML: 0,
        Name: 'SecondaryHighLimitPrice',
    },
    {
        Type: 'String',
        Description:
            'Allows maturity rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
        added: 'FIX.5.0',
        AbbrName: 'MatRuleID',
        addedEP: 52,
        Tag: 1222,
        NotReqXML: 0,
        Name: 'MaturityRuleID',
    },
    {
        Type: 'String',
        Description:
            'Allows strike rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
        added: 'FIX.5.0',
        AbbrName: 'StrkRule',
        addedEP: 52,
        Tag: 1223,
        NotReqXML: 0,
        Name: 'StrikeRuleID',
    },
    {
        Type: 'Amt',
        Description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount',
        added: 'FIX.5.0',
        AbbrName: 'OptPayAmt',
        addedEP: 52,
        Tag: 1225,
        NotReqXML: 0,
        Name: 'DerivativeOptPayAmount',
    },
    {
        Type: 'MonthYear',
        Description: 'Ending maturity month year for an option class',
        added: 'FIX.5.0',
        AbbrName: 'EndMMY',
        addedEP: 52,
        Tag: 1226,
        NotReqXML: 0,
        Name: 'EndMaturityMonthYear',
    },
    {
        Type: 'String',
        Description:
            'Identifies an entire suite of products for a given market. In Futures this may be "interest rates", "agricultural", "equity indexes", etc.',
        added: 'FIX.5.0',
        AbbrName: 'ProdCmplx',
        addedEP: 52,
        Tag: 1227,
        NotReqXML: 0,
        Name: 'ProductComplex',
    },
    {
        Type: 'String',
        Description: 'Refer to ProductComplex(1227)',
        added: 'FIX.5.0',
        AbbrName: 'ProdCmplx',
        addedEP: 52,
        Tag: 1228,
        NotReqXML: 0,
        Name: 'DerivativeProductComplex',
    },
    {
        Type: 'int',
        Description: 'Increment between successive maturities for an option class',
        added: 'FIX.5.0',
        AbbrName: 'MMYIncr',
        addedEP: 52,
        Tag: 1229,
        NotReqXML: 0,
        Name: 'MaturityMonthYearIncrement',
    },
    {
        Type: 'Qty',
        Description: 'Minimum lot size allowed based on lot type specified in LotType(1093)',
        added: 'FIX.5.0',
        AbbrName: 'MinLotSz',
        addedEP: 52,
        Tag: 1231,
        NotReqXML: 0,
        Name: 'MinLotSize',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of execution instructions',
        added: 'FIX.5.0',
        AbbrName: 'NoExecInstRules',
        addedEP: 52,
        Tag: 1232,
        NotReqXML: 1,
        Name: 'NoExecInstRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Lot Type Rules',
        added: 'FIX.5.0',
        AbbrName: 'NoLotTypeRules',
        addedEP: 52,
        Tag: 1234,
        NotReqXML: 1,
        Name: 'NoLotTypeRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Match Rules',
        added: 'FIX.5.0',
        AbbrName: 'NoMatchRules',
        addedEP: 52,
        Tag: 1235,
        NotReqXML: 1,
        Name: 'NoMatchRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of maturity rules in MarurityRules component block',
        added: 'FIX.5.0',
        AbbrName: 'NoMaturityRules',
        addedEP: 52,
        Tag: 1236,
        NotReqXML: 1,
        Name: 'NoMaturityRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of order types',
        added: 'FIX.5.0',
        AbbrName: 'NoOrdTypeRules',
        addedEP: 52,
        Tag: 1237,
        NotReqXML: 1,
        Name: 'NoOrdTypeRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of time in force techniques',
        added: 'FIX.5.0',
        AbbrName: 'NoTimeInForceRules',
        addedEP: 52,
        Tag: 1239,
        NotReqXML: 1,
        Name: 'NoTimeInForceRules',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition for TradingReferencePrice(1150)',
        added: 'FIX.5.0',
        AbbrName: 'TrdgRefPx',
        addedEP: 52,
        Tag: 1240,
        NotReqXML: 0,
        Name: 'SecondaryTradingReferencePrice',
    },
    {
        Type: 'MonthYear',
        Description: 'Starting maturity month year for an option class',
        added: 'FIX.5.0',
        AbbrName: 'StartMMY',
        addedEP: 52,
        Tag: 1241,
        NotReqXML: 0,
        Name: 'StartMaturityMonthYear',
    },
    {
        Type: 'Boolean',
        Description: 'Used to indicate if a product or group of product supports the creation of flexible securities',
        added: 'FIX.5.0',
        AbbrName: 'FlexProdElig',
        addedEP: 52,
        Tag: 1242,
        NotReqXML: 0,
        Name: 'FlexProductEligibilityIndicator',
    },
    {
        Type: 'Boolean',
        Description: 'Refer to FlexProductEligibilityIndicator(1242)',
        added: 'FIX.5.0',
        AbbrName: 'FlexProdElig',
        addedEP: 52,
        Tag: 1243,
        NotReqXML: 0,
        Name: 'DerivFlexProductEligibilityIndicator',
    },
    {
        Type: 'Boolean',
        Description:
            'Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative CFICode(461) Standard/Non-standard attribute.',
        added: 'FIX.5.0',
        AbbrName: 'FlexInd',
        addedEP: 52,
        Tag: 1244,
        NotReqXML: 0,
        Name: 'FlexibleIndicator',
    },
    {
        Type: 'Currency',
        Description: 'Used when the trading currency can differ from the price currency',
        added: 'FIX.5.0',
        AbbrName: 'TrdCcy',
        addedEP: 52,
        Tag: 1245,
        NotReqXML: 0,
        Name: 'TradingCurrency',
    },
    {
        Type: 'int',
        EnumDatatype: 460,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Prod',
        addedEP: 52,
        Tag: 1246,
        NotReqXML: 0,
        Name: 'DerivativeProduct',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'SecGrp',
        addedEP: 52,
        Tag: 1247,
        NotReqXML: 0,
        Name: 'DerivativeSecurityGroup',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'CFI',
        addedEP: 52,
        Tag: 1248,
        NotReqXML: 0,
        Name: 'DerivativeCFICode',
    },
    {
        Type: 'String',
        EnumDatatype: 167,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'SecTyp',
        addedEP: 52,
        Tag: 1249,
        NotReqXML: 0,
        Name: 'DerivativeSecurityType',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'SecSubTyp',
        addedEP: 52,
        Tag: 1250,
        NotReqXML: 0,
        Name: 'DerivativeSecuritySubType',
    },
    {
        Type: 'MonthYear',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'MMY',
        addedEP: 52,
        Tag: 1251,
        NotReqXML: 0,
        Name: 'DerivativeMaturityMonthYear',
    },
    {
        Type: 'LocalMktDate',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'MatDt',
        addedEP: 52,
        Tag: 1252,
        NotReqXML: 0,
        Name: 'DerivativeMaturityDate',
    },
    {
        Type: 'TZTimeOnly',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'MatTm',
        addedEP: 52,
        Tag: 1253,
        NotReqXML: 0,
        Name: 'DerivativeMaturityTime',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'OpenCloseSettlFlag',
        addedEP: 52,
        Tag: 1254,
        NotReqXML: 0,
        Name: 'DerivativeSettleOnOpenFlag',
    },
    {
        Type: 'char',
        EnumDatatype: 1049,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'AsgnMeth',
        addedEP: 52,
        Tag: 1255,
        NotReqXML: 0,
        Name: 'DerivativeInstrmtAssignmentMethod',
    },
    {
        Type: 'String',
        EnumDatatype: 965,
        Description: '',
        added: 'FIX.5.0',
        updatedEP: 76,
        AbbrName: 'Status',
        addedEP: 52,
        Tag: 1256,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DerivativeSecurityStatus',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Rgstry',
        addedEP: 52,
        Tag: 1257,
        NotReqXML: 0,
        Name: 'DerivativeInstrRegistry',
    },
    {
        Type: 'Country',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Ctry',
        addedEP: 52,
        Tag: 1258,
        NotReqXML: 0,
        Name: 'DerivativeCountryOfIssue',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'StPrv',
        addedEP: 52,
        Tag: 1259,
        NotReqXML: 0,
        Name: 'DerivativeStateOrProvinceOfIssue',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Lcl',
        addedEP: 52,
        Tag: 1260,
        NotReqXML: 0,
        Name: 'DerivativeLocaleOfIssue',
    },
    {
        Type: 'Price',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'StrkPx',
        addedEP: 52,
        Tag: 1261,
        NotReqXML: 0,
        Name: 'DerivativeStrikePrice',
    },
    {
        Type: 'Currency',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'StrkCcy',
        addedEP: 52,
        Tag: 1262,
        NotReqXML: 0,
        Name: 'DerivativeStrikeCurrency',
    },
    {
        Type: 'float',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'StrkMult',
        addedEP: 52,
        Tag: 1263,
        NotReqXML: 0,
        Name: 'DerivativeStrikeMultiplier',
    },
    {
        Type: 'float',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'StrkValu',
        addedEP: 52,
        Tag: 1264,
        NotReqXML: 0,
        Name: 'DerivativeStrikeValue',
    },
    {
        Type: 'char',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'OptAt',
        addedEP: 52,
        Tag: 1265,
        NotReqXML: 0,
        Name: 'DerivativeOptAttribute',
    },
    {
        Type: 'float',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Mult',
        addedEP: 52,
        Tag: 1266,
        NotReqXML: 0,
        Name: 'DerivativeContractMultiplier',
    },
    {
        Type: 'float',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'MinPxIncr',
        addedEP: 52,
        Tag: 1267,
        NotReqXML: 0,
        Name: 'DerivativeMinPriceIncrement',
    },
    {
        Type: 'Amt',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'MinPxIncrAmt',
        addedEP: 52,
        Tag: 1268,
        NotReqXML: 0,
        Name: 'DerivativeMinPriceIncrementAmount',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'UOM',
        addedEP: 52,
        Tag: 1269,
        NotReqXML: 0,
        Name: 'DerivativeUnitOfMeasure',
    },
    {
        Type: 'Qty',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'UOMQty',
        addedEP: 52,
        Tag: 1270,
        NotReqXML: 0,
        Name: 'DerivativeUnitOfMeasureQty',
    },
    {
        Type: 'String',
        EnumDatatype: 997,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'TmUnit',
        addedEP: 52,
        Tag: 1271,
        NotReqXML: 0,
        Name: 'DerivativeTimeUnit',
    },
    {
        Type: 'Exchange',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Exch',
        addedEP: 52,
        Tag: 1272,
        NotReqXML: 0,
        Name: 'DerivativeSecurityExchange',
    },
    {
        Type: 'int',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'PosLmt',
        addedEP: 52,
        Tag: 1273,
        NotReqXML: 0,
        Name: 'DerivativePositionLimit',
    },
    {
        Type: 'int',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'NTPosLmt',
        addedEP: 52,
        Tag: 1274,
        NotReqXML: 0,
        Name: 'DerivativeNTPositionLimit',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Issr',
        addedEP: 52,
        Tag: 1275,
        NotReqXML: 0,
        Name: 'DerivativeIssuer',
    },
    {
        Type: 'LocalMktDate',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'IssDt',
        addedEP: 52,
        Tag: 1276,
        NotReqXML: 0,
        Name: 'DerivativeIssueDate',
    },
    {
        Type: 'Length',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'EncIssrLen',
        addedEP: 52,
        Tag: 1277,
        NotReqXML: 0,
        Name: 'DerivativeEncodedIssuerLen',
    },
    {
        Type: 'data',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'EncIssr',
        addedEP: 52,
        Tag: 1278,
        NotReqXML: 0,
        Name: 'DerivativeEncodedIssuer',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Desc',
        addedEP: 52,
        Tag: 1279,
        NotReqXML: 0,
        Name: 'DerivativeSecurityDesc',
    },
    {
        Type: 'Length',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'EncSecDescLen',
        addedEP: 52,
        Tag: 1280,
        NotReqXML: 0,
        Name: 'DerivativeEncodedSecurityDescLen',
    },
    {
        Type: 'data',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'EncSecDesc',
        addedEP: 52,
        Tag: 1281,
        NotReqXML: 0,
        Name: 'DerivativeEncodedSecurityDesc',
    },
    {
        Type: 'Length',
        Description: 'Refer to definition SecurityXMLLen(1184)',
        added: 'FIX.5.0',
        AssociatedDataTag: 1283,
        AbbrName: 'SecXMLLen',
        addedEP: 52,
        Tag: 1282,
        NotReqXML: 1,
        Name: 'DerivativeSecurityXMLLen',
    },
    {
        Type: 'data',
        Description: 'Refer to definition of SecurityXML(1185)',
        added: 'FIX.5.0',
        AbbrName: 'SecXML',
        addedEP: 52,
        Tag: 1283,
        NotReqXML: 1,
        Name: 'DerivativeSecurityXML',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of SecurityXMLSchema(1186)',
        added: 'FIX.5.0',
        AbbrName: 'Schema',
        addedEP: 52,
        Tag: 1284,
        NotReqXML: 0,
        Name: 'DerivativeSecurityXMLSchema',
    },
    {
        Type: 'MonthYear',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'CSetMo',
        addedEP: 52,
        Tag: 1285,
        NotReqXML: 0,
        Name: 'DerivativeContractSettlMonth',
    },
    {
        Type: 'NumInGroup',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'NoDerivativeEvents',
        addedEP: 52,
        Tag: 1286,
        NotReqXML: 1,
        Name: 'NoDerivativeEvents',
    },
    {
        Type: 'int',
        EnumDatatype: 865,
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'EventTyp',
        addedEP: 52,
        Tag: 1287,
        NotReqXML: 0,
        Name: 'DerivativeEventType',
    },
    {
        Type: 'LocalMktDate',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Dt',
        addedEP: 52,
        Tag: 1288,
        NotReqXML: 0,
        Name: 'DerivativeEventDate',
    },
    {
        Type: 'UTCTimestamp',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Tm',
        addedEP: 52,
        Tag: 1289,
        NotReqXML: 0,
        Name: 'DerivativeEventTime',
    },
    {
        Type: 'Price',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Px',
        addedEP: 52,
        Tag: 1290,
        NotReqXML: 0,
        Name: 'DerivativeEventPx',
    },
    {
        Type: 'String',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'Txt',
        addedEP: 52,
        Tag: 1291,
        NotReqXML: 0,
        Name: 'DerivativeEventText',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition of NoParties(453)',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1292,
        NotReqXML: 1,
        Name: 'NoDerivativeInstrumentParties',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of PartyID(448)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 52,
        Tag: 1293,
        NotReqXML: 0,
        Name: 'DerivativeInstrumentPartyID',
    },
    {
        Type: 'String',
        EnumDatatype: 447,
        Description: 'Refer to definition of PartyIDSource(447)',
        added: 'FIX.5.0',
        AbbrName: 'Src',
        addedEP: 52,
        Tag: 1294,
        NotReqXML: 0,
        Name: 'DerivativeInstrumentPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'REfer to definition of PartyRole(452)',
        added: 'FIX.5.0',
        AbbrName: 'R',
        addedEP: 52,
        Tag: 1295,
        NotReqXML: 0,
        Name: 'DerivativeInstrumentPartyRole',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition for NoPartySubIDs(802)',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1296,
        NotReqXML: 1,
        Name: 'NoDerivativeInstrumentPartySubIDs',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for PartySubID(523)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 52,
        Tag: 1297,
        NotReqXML: 0,
        Name: 'DerivativeInstrumentPartySubID',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Refer to definition for PartySubIDType(803)',
        added: 'FIX.5.0',
        AbbrName: 'Typ',
        addedEP: 52,
        Tag: 1298,
        NotReqXML: 0,
        Name: 'DerivativeInstrumentPartySubIDType',
    },
    {
        Type: 'char',
        EnumDatatype: 1194,
        Description: 'Type of exercise of a derivatives security',
        added: 'FIX.5.0',
        AbbrName: 'ExerStyle',
        addedEP: 52,
        Tag: 1299,
        NotReqXML: 0,
        Name: 'DerivativeExerciseStyle',
    },
    {
        Type: 'String',
        Description: 'Identifies the market segment',
        added: 'FIX.5.0',
        AbbrName: 'MktSegID',
        addedEP: 52,
        Tag: 1300,
        NotReqXML: 0,
        Name: 'MarketSegmentID',
    },
    {
        Type: 'Exchange',
        Description: 'Identifies the Market',
        added: 'FIX.5.0',
        AbbrName: 'MktID',
        addedEP: 52,
        Tag: 1301,
        NotReqXML: 0,
        Name: 'MarketID',
    },
    {
        Type: 'int',
        Description: 'Unit of measure for the Maturity Month Year Increment',
        added: 'FIX.5.0',
        AbbrName: 'MMYIncrUnits',
        addedEP: 52,
        Tag: 1302,
        NotReqXML: 0,
        Name: 'MaturityMonthYearIncrementUnits',
    },
    {
        Type: 'int',
        Description: 'Format used to generate the MaturityMonthYear for each option',
        added: 'FIX.5.0',
        AbbrName: 'MMYFmt',
        addedEP: 52,
        Tag: 1303,
        NotReqXML: 0,
        Name: 'MaturityMonthYearFormat',
    },
    {
        Type: 'int',
        EnumDatatype: 1194,
        Description: 'Expiration Style for an option class:',
        added: 'FIX.5.0',
        AbbrName: 'StrkExrStyle',
        addedEP: 52,
        Tag: 1304,
        NotReqXML: 0,
        Name: 'StrikeExerciseStyle',
    },
    {
        Type: 'int',
        EnumDatatype: 1306,
        Description: 'Describes the how the price limits are expressed',
        added: 'FIX.5.0',
        AbbrName: 'PxLmtTyp',
        addedEP: 52,
        Tag: 1305,
        NotReqXML: 0,
        Name: 'SecondaryPriceLimitType',
    },
    {
        Type: 'int',
        Description: 'Describes the how the price limits are expressed',
        added: 'FIX.5.0',
        AbbrName: 'PxLmtTyp',
        addedEP: 52,
        Tag: 1306,
        NotReqXML: 0,
        Name: 'PriceLimitType',
    },
    {
        Type: 'char',
        EnumDatatype: 18,
        Description: 'Indicates execution instructions that are valid for the specified market segment',
        added: 'FIX.5.0',
        AbbrName: 'ExecInstValu',
        addedEP: 52,
        Tag: 1308,
        NotReqXML: 0,
        Name: 'ExecInstValue',
    },
    {
        Type: 'NumInGroup',
        Description: 'Allows trading rules to be expressed by trading session',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1309,
        NotReqXML: 1,
        Name: 'NoTradingSessionRules',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Market Segments on which a security may trade.',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1310,
        NotReqXML: 1,
        Name: 'NoMarketSegments',
    },
    {
        Type: 'NumInGroup',
        Description: '',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1311,
        NotReqXML: 1,
        Name: 'NoDerivativeInstrAttrib',
    },
    {
        Type: 'NumInGroup',
        Description: '',
        added: 'FIX.5.0',
        addedEP: 52,
        Tag: 1312,
        NotReqXML: 1,
        Name: 'NoNestedInstrAttrib',
    },
    {
        Type: 'int',
        EnumDatatype: 871,
        Description: 'Refer to definition of InstrAttribType(871)',
        added: 'FIX.5.0',
        AbbrName: 'Typ',
        addedEP: 52,
        Tag: 1313,
        NotReqXML: 0,
        Name: 'DerivativeInstrAttribType',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of InstrAttribValue(872)',
        added: 'FIX.5.0',
        AbbrName: 'Val',
        addedEP: 52,
        Tag: 1314,
        NotReqXML: 0,
        Name: 'DerivativeInstrAttribValue',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: 'Refer to definition for PriceUnitOfMeasure(1191)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOM',
        addedEP: 52,
        Tag: 1315,
        NotReqXML: 0,
        Name: 'DerivativePriceUnitOfMeasure',
    },
    {
        Type: 'Qty',
        Description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOMQty',
        addedEP: 52,
        Tag: 1316,
        NotReqXML: 0,
        Name: 'DerivativePriceUnitOfMeasureQty',
    },
    {
        Type: 'char',
        EnumDatatype: 1193,
        Description: 'Refer to definition of SettlMethod(1193)',
        added: 'FIX.5.0',
        AbbrName: 'SettlMeth',
        addedEP: 52,
        Tag: 1317,
        NotReqXML: 0,
        Name: 'DerivativeSettlMethod',
    },
    {
        Type: 'String',
        EnumDatatype: 1196,
        Description: 'Refer to definition of PriceQuoteMethod(1196)',
        added: 'FIX.5.0',
        AbbrName: 'PxQteMeth',
        addedEP: 52,
        Tag: 1318,
        NotReqXML: 0,
        Name: 'DerivativePriceQuoteMethod',
    },
    {
        Type: 'String',
        EnumDatatype: 1197,
        Description: 'Refer to definition of ValuationMethod(1197).',
        added: 'FIX.5.0',
        updatedEP: 83,
        AbbrName: 'ValMeth',
        addedEP: 52,
        Tag: 1319,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'DerivativeValuationMethod',
    },
    {
        Type: 'int',
        EnumDatatype: 1198,
        Description: 'Indicates whether instruments are pre-listed only or can also be defined via user request',
        added: 'FIX.5.0',
        AbbrName: 'ListMeth',
        addedEP: 52,
        Tag: 1320,
        NotReqXML: 0,
        Name: 'DerivativeListMethod',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition of CapPrice(1199)',
        added: 'FIX.5.0',
        AbbrName: 'CapPx',
        addedEP: 52,
        Tag: 1321,
        NotReqXML: 0,
        Name: 'DerivativeCapPrice',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition of FloorPrice(1200)',
        added: 'FIX.5.0',
        AbbrName: 'FlrPx',
        addedEP: 52,
        Tag: 1322,
        NotReqXML: 0,
        Name: 'DerivativeFloorPrice',
    },
    {
        Type: 'int',
        EnumDatatype: 201,
        Description: 'Indicates whether an Option is for a put or call',
        added: 'FIX.5.0',
        AbbrName: 'PutCall',
        addedEP: 52,
        Tag: 1323,
        NotReqXML: 0,
        Name: 'DerivativePutOrCall',
    },
    {
        Type: 'char',
        EnumDatatype: 980,
        Description: 'If provided, then Instrument occurrence has explicitly changed',
        added: 'FIX.5.0',
        AbbrName: 'ListUpdActn',
        addedEP: 52,
        Tag: 1324,
        NotReqXML: 0,
        Name: 'ListUpdateAction',
    },
    {
        Type: 'int',
        Description: 'Refer to definition of PutOrCall(201)',
        added: 'FIX.5.0',
        AbbrName: 'PutCall',
        addedEP: 52,
        Tag: 1358,
        NotReqXML: 0,
        Name: 'LegPutOrCall',
    },
    {
        Type: 'Qty',
        Description: 'Refer to definition of UnitOfMeasureQty(1147)',
        added: 'FIX.5.0',
        AbbrName: 'UOMQty',
        addedEP: 52,
        Tag: 1224,
        NotReqXML: 0,
        Name: 'LegUnitOfMeasureQty',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: 'Refer to definition for PriceUnitOfMeasure(1191)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOM',
        addedEP: 52,
        Tag: 1421,
        NotReqXML: 0,
        Name: 'LegPriceUnitOfMeasure',
    },
    {
        Type: 'Qty',
        Description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOMQty',
        addedEP: 52,
        Tag: 1422,
        NotReqXML: 0,
        Name: 'LegPriceUnitOfMeasureQty',
    },
    {
        Type: 'Qty',
        Description: 'Refer to definition of UnitOfMeasureQty(1147)',
        added: 'FIX.5.0',
        AbbrName: 'UOMQty',
        addedEP: 52,
        Tag: 1423,
        NotReqXML: 0,
        Name: 'UnderlyingUnitOfMeasureQty',
    },
    {
        Type: 'String',
        EnumDatatype: 996,
        Description: 'Refer to definition for PriceUnitOfMeasure(1191)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOM',
        addedEP: 52,
        Tag: 1424,
        NotReqXML: 0,
        Name: 'UnderlyingPriceUnitOfMeasure',
    },
    {
        Type: 'Qty',
        Description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
        added: 'FIX.5.0',
        AbbrName: 'PxUOMQty',
        addedEP: 52,
        Tag: 1425,
        NotReqXML: 0,
        Name: 'UnderlyingPriceUnitOfMeasureQty',
    },
    {
        Type: 'String',
        Description: 'Unique ID of a Market Definition Request message.',
        added: 'FIX.5.0',
        AbbrName: 'MktReqID',
        addedEP: 53,
        Tag: 1393,
        NotReqXML: 0,
        Name: 'MarketReqID',
    },
    {
        Type: 'String',
        Description: 'Market Definition message identifier.',
        added: 'FIX.5.0',
        AbbrName: 'MktRptID',
        addedEP: 53,
        Tag: 1394,
        NotReqXML: 0,
        Name: 'MarketReportID',
    },
    {
        Type: 'char',
        EnumDatatype: 980,
        Description: 'Specifies the action taken for the specified MarketID(1301) + MarketSegmentID(1300).',
        added: 'FIX.5.0',
        AbbrName: 'MktUpdtActn',
        addedEP: 53,
        Tag: 1395,
        NotReqXML: 0,
        Name: 'MarketUpdateAction',
    },
    {
        Type: 'String',
        Description: 'Description or name of Market Segment',
        added: 'FIX.5.0',
        AbbrName: 'MarketSegmentDesc',
        addedEP: 53,
        Tag: 1396,
        NotReqXML: 0,
        Name: 'MarketSegmentDesc',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedMktSegmDesc(1324) field.',
        added: 'FIX.5.0',
        AbbrName: 'EncodedMktSegmDescLen',
        addedEP: 53,
        Tag: 1397,
        NotReqXML: 0,
        Name: 'EncodedMktSegmDescLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the MarketSegmDesc(1396) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the MarketSegmDesc field.',
        added: 'FIX.5.0',
        AbbrName: 'EncodedMktSegmDesc',
        addedEP: 53,
        Tag: 1398,
        NotReqXML: 0,
        Name: 'EncodedMktSegmDesc',
    },
    {
        Type: 'String',
        Description: 'Reference to a parent Market Segment. See MarketSegmentID(1300)',
        added: 'FIX.5.0',
        AbbrName: 'ParentMktSegmID',
        addedEP: 53,
        Tag: 1325,
        NotReqXML: 0,
        Name: 'ParentMktSegmID',
    },
    {
        Type: 'String',
        Description: 'Trading Session description',
        added: 'FIX.5.0',
        AbbrName: 'TradingSessionDesc',
        addedEP: 53,
        Tag: 1326,
        NotReqXML: 0,
        Name: 'TradingSessionDesc',
    },
    {
        Type: 'char',
        EnumDatatype: 980,
        Description: 'Specifies the action taken for the specified trading sessions.',
        added: 'FIX.5.0',
        AbbrName: 'TradSesUpdtActn',
        addedEP: 53,
        Tag: 1327,
        NotReqXML: 0,
        Name: 'TradSesUpdateAction',
    },
    {
        Type: 'String',
        Description: 'Those will be used by Firms to send a reason for rejecting a trade in an allocate claim model.',
        added: 'FIX.5.0',
        AbbrName: 'RejTxt',
        addedEP: 55,
        Tag: 1328,
        NotReqXML: 0,
        Name: 'RejectText',
    },
    {
        Type: 'float',
        Description:
            'This is a multiplier that Clearing (Fee system) will use to calculate fees and will be sent to the firms on their confirms.',
        added: 'FIX.5.0',
        AbbrName: 'FeeMult',
        addedEP: 55,
        Tag: 1329,
        NotReqXML: 0,
        Name: 'FeeMultiplier',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for Symbol(55)',
        added: 'FIX.5.0',
        AbbrName: 'Sym',
        addedEP: 55,
        Tag: 1330,
        NotReqXML: 0,
        Name: 'UnderlyingLegSymbol',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SymbolSfx(65)',
        added: 'FIX.5.0',
        AbbrName: 'Sfx',
        addedEP: 55,
        Tag: 1331,
        NotReqXML: 0,
        Name: 'UnderlyingLegSymbolSfx',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityID(48)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 55,
        Tag: 1332,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityID',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityIDSource(22)',
        added: 'FIX.5.0',
        AbbrName: 'Src',
        addedEP: 55,
        Tag: 1333,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityIDSource',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition for NoSecurityAltID(454)',
        added: 'FIX.5.0',
        AbbrName: 'NoUnderlyingLegSecurityAltID',
        addedEP: 55,
        Tag: 1334,
        NotReqXML: 1,
        Name: 'NoUnderlyingLegSecurityAltID',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityAltID(455)',
        added: 'FIX.5.0',
        AbbrName: 'AltID',
        addedEP: 55,
        Tag: 1335,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityAltID',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityAltIDSource(456)',
        added: 'FIX.5.0',
        AbbrName: 'AltIDSrc',
        addedEP: 55,
        Tag: 1336,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityAltIDSource',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityType(167)',
        added: 'FIX.5.0',
        AbbrName: 'SecType',
        addedEP: 55,
        Tag: 1337,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityType',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecuritySubType(762)',
        added: 'FIX.5.0',
        AbbrName: 'SubType',
        addedEP: 55,
        Tag: 1338,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecuritySubType',
    },
    {
        Type: 'MonthYear',
        Description: 'Refer to definition for MaturityMonthYear(200)',
        added: 'FIX.5.0',
        AbbrName: 'MMY',
        addedEP: 55,
        Tag: 1339,
        NotReqXML: 0,
        Name: 'UnderlyingLegMaturityMonthYear',
    },
    {
        Type: 'int',
        Description: 'Refer to definition for PutOrCall(201)',
        added: 'FIX.5.0',
        AbbrName: 'PutCall',
        addedEP: 55,
        Tag: 1343,
        NotReqXML: 0,
        Name: 'UnderlyingLegPutOrCall',
    },
    {
        Type: 'Price',
        Description: 'Refer to definition for StrikePrice(202)',
        added: 'FIX.5.0',
        AbbrName: 'StrkPx',
        addedEP: 55,
        Tag: 1340,
        NotReqXML: 0,
        Name: 'UnderlyingLegStrikePrice',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for SecurityExchange(207)',
        added: 'FIX.5.0',
        AbbrName: 'Exch',
        addedEP: 55,
        Tag: 1341,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityExchange',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Underlyings, Identifies the Underlying of the Leg',
        added: 'FIX.5.0',
        AbbrName: 'NoOfLegUnderlyings',
        addedEP: 55,
        Tag: 1342,
        NotReqXML: 1,
        Name: 'NoOfLegUnderlyings',
    },
    {
        Type: 'String',
        Description: 'Refer to definition for CFICode(461)',
        added: 'FIX.5.0',
        AbbrName: 'CFI',
        addedEP: 55,
        Tag: 1344,
        NotReqXML: 0,
        Name: 'UnderlyingLegCFICode',
    },
    {
        Type: 'LocalMktDate',
        Description: 'Date of maturity.',
        added: 'FIX.5.0',
        AbbrName: 'MatDt',
        addedEP: 55,
        Tag: 1345,
        NotReqXML: 0,
        Name: 'UnderlyingLegMaturityDate',
    },
    {
        Type: 'TZTimeOnly',
        Description: "Time of security's maturity expressed in local time with offset to UTC specified",
        added: 'FIX.5.0',
        AbbrName: 'MatTm',
        addedEP: 55,
        Tag: 1405,
        NotReqXML: 0,
        Name: 'UnderlyingLegMaturityTime',
    },
    {
        Type: 'char',
        Description: 'Refer to definition of OptAttribute(206)',
        added: 'FIX.5.0',
        AbbrName: 'OptAt',
        addedEP: 55,
        Tag: 1391,
        NotReqXML: 0,
        Name: 'UnderlyingLegOptAttribute',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of SecurityDesc(107)',
        added: 'FIX.5.0',
        AbbrName: 'Desc',
        addedEP: 55,
        Tag: 1392,
        NotReqXML: 0,
        Name: 'UnderlyingLegSecurityDesc',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Enumeration defining the encryption method used to encrypt password fields.\nAt this time there are no encryption methods defined by FPL.',
        added: 'FIX.5.0',
        AbbrName: 'EncPwdMethod',
        addedEP: 56,
        Tag: 1400,
        NotReqXML: 0,
        Name: 'EncryptedPasswordMethod',
    },
    {
        Type: 'Length',
        Description: 'Length of the EncryptedPassword(1402) field',
        added: 'FIX.5.0',
        AssociatedDataTag: 1402,
        AbbrName: 'EncPwdLen',
        addedEP: 56,
        Tag: 1401,
        NotReqXML: 1,
        Name: 'EncryptedPasswordLen',
    },
    {
        Type: 'data',
        Description:
            'Encrypted password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
        added: 'FIX.5.0',
        AbbrName: 'EncPwd',
        addedEP: 56,
        Tag: 1402,
        NotReqXML: 0,
        Name: 'EncryptedPassword',
    },
    {
        Type: 'Length',
        Description: 'Length of the EncryptedNewPassword(1404) field',
        added: 'FIX.5.0',
        AssociatedDataTag: 1404,
        AbbrName: 'EncNewPwdLen',
        addedEP: 56,
        Tag: 1403,
        NotReqXML: 1,
        Name: 'EncryptedNewPasswordLen',
    },
    {
        Type: 'data',
        Description:
            'Encrypted new password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
        added: 'FIX.5.0',
        AbbrName: 'EncNewPwd',
        addedEP: 56,
        Tag: 1404,
        NotReqXML: 0,
        Name: 'EncryptedNewPassword',
    },
    {
        Type: 'int',
        Description: 'The extension pack number associated with an application message.',
        added: 'FIX.5.0',
        AbbrName: 'ApplExtID',
        addedEP: 56,
        Tag: 1156,
        NotReqXML: 1,
        Name: 'ApplExtID',
    },
    {
        Type: 'int',
        Description: 'The extension pack number associated with an application message.',
        added: 'FIX.5.0',
        AbbrName: 'RefApplExtID',
        addedEP: 56,
        Tag: 1406,
        NotReqXML: 0,
        Name: 'RefApplExtID',
    },
    {
        Type: 'int',
        Description: 'The extension pack number that is the default for a FIX session.',
        added: 'FIX.5.0',
        AbbrName: 'DfltApplExtID',
        addedEP: 56,
        Tag: 1407,
        NotReqXML: 0,
        Name: 'DefaultApplExtID',
    },
    {
        Type: 'String',
        Description: 'The default custom application version ID that is the default for a session.',
        added: 'FIX.5.0',
        AbbrName: 'DefaultCstmApplVerID',
        addedEP: 56,
        Tag: 1408,
        NotReqXML: 1,
        Name: 'DefaultCstmApplVerID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Status of a FIX session',
        added: 'FIX.5.0',
        AbbrName: 'SessStat',
        addedEP: 56,
        Tag: 1409,
        NotReqXML: 0,
        Name: 'SessionStatus',
    },
    {
        Type: 'Boolean',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'DfltVerInd',
        addedEP: 56,
        Tag: 1410,
        NotReqXML: 0,
        Name: 'DefaultVerIndicator',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of Usernames to which this this response is directed',
        added: 'FIX.4.4',
        AbbrName: 'NoUsers',
        Tag: 809,
        NotReqXML: 1,
        Name: 'NoUsernames',
    },
    {
        Type: 'Currency',
        Description: 'Identifies settlement currency for the leg level allocation.',
        added: 'FIX.5.0',
        AbbrName: 'AllocSettlCcy',
        addedEP: 58,
        Tag: 1367,
        NotReqXML: 0,
        Name: 'LegAllocSettlCurrency',
    },
    {
        Type: 'int',
        Description:
            'Total number of fill entries across all messages. Should be the sum of all NoFills(1362) in each message that has repeating list of fill entries related to the same ExecID(17). Used to support fragmentation.',
        added: 'FIX.5.0',
        AbbrName: 'TotNoFills',
        addedEP: 58,
        Tag: 1361,
        NotReqXML: 0,
        Name: 'TotNoFills',
    },
    {
        Type: 'NumInGroup',
        Description: '',
        added: 'FIX.5.0',
        AbbrName: 'NoFills',
        addedEP: 58,
        Tag: 1362,
        NotReqXML: 1,
        Name: 'NoFills',
    },
    {
        Type: 'String',
        Description:
            'Refer to ExecID(17). Used when multiple partial fills are reported in single Execution Report. ExecID and FillExecID should not overlap,',
        added: 'FIX.5.0',
        AbbrName: 'FillExecID',
        addedEP: 58,
        Tag: 1363,
        NotReqXML: 0,
        Name: 'FillExecID',
    },
    {
        Type: 'Price',
        Description: 'Price of Fill. Refer to LastPx(31).',
        added: 'FIX.5.0',
        AbbrName: 'FillPx',
        addedEP: 58,
        Tag: 1364,
        NotReqXML: 0,
        Name: 'FillPx',
    },
    {
        Type: 'Qty',
        Description: 'Quantity of Fill. Refer to LastQty(32).',
        added: 'FIX.5.0',
        AbbrName: 'FillQty',
        addedEP: 58,
        Tag: 1365,
        NotReqXML: 0,
        Name: 'FillQty',
    },
    {
        Type: 'String',
        Description: 'The AllocID(70) of an individual leg of a multileg order.',
        added: 'FIX.5.0',
        AbbrName: 'LegAllocID',
        addedEP: 58,
        Tag: 1366,
        NotReqXML: 0,
        Name: 'LegAllocID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Identifies an event related to a TradSesStatus(340). An event occurs and is gone, it is not a state that applies for a period of time.',
        added: 'FIX.5.0',
        AbbrName: 'TradSesEvent',
        addedEP: 58,
        Tag: 1368,
        NotReqXML: 0,
        Name: 'TradSesEvent',
    },
    {
        Type: 'String',
        Description:
            'Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)',
        added: 'FIX.5.0',
        AbbrName: 'MassActionReportID',
        addedEP: 58,
        Tag: 1369,
        NotReqXML: 0,
        Name: 'MassActionReportID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of not affected orders in the repeating group of order ids.',
        added: 'FIX.5.0',
        AbbrName: 'NoNotAffectedOrders',
        addedEP: 58,
        Tag: 1370,
        NotReqXML: 1,
        Name: 'NoNotAffectedOrders',
    },
    {
        Type: 'String',
        Description: 'OrderID(37) of an order not affected by a mass cancel request.',
        added: 'FIX.5.0',
        AbbrName: 'NotAffectedOrderID',
        addedEP: 58,
        Tag: 1371,
        NotReqXML: 0,
        Name: 'NotAffectedOrderID',
    },
    {
        Type: 'String',
        Description:
            'ClOrdID(11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests.',
        added: 'FIX.5.0',
        AbbrName: 'NotAffOrigClOrdID',
        addedEP: 58,
        Tag: 1372,
        NotReqXML: 0,
        Name: 'NotAffOrigClOrdID',
    },
    {
        Type: 'int',
        Description: 'Specifies the type of action requested',
        added: 'FIX.5.0',
        AbbrName: 'MassActionType',
        addedEP: 58,
        Tag: 1373,
        NotReqXML: 0,
        Name: 'MassActionType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Specifies scope of Order Mass Action Request.',
        added: 'FIX.5.0',
        updatedEP: 85,
        AbbrName: 'MassActionScope',
        addedEP: 58,
        Tag: 1374,
        NotReqXML: 0,
        updated: 'FIX.5.0SP1',
        Name: 'MassActionScope',
    },
    {
        Type: 'int',
        Description:
            'Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request.',
        added: 'FIX.5.0',
        AbbrName: 'MassActionResponse',
        addedEP: 58,
        Tag: 1375,
        NotReqXML: 0,
        Name: 'MassActionResponse',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason Order Mass Action Request was rejected',
        added: 'FIX.5.0',
        AbbrName: 'MassActionRejectReason',
        addedEP: 58,
        Tag: 1376,
        NotReqXML: 0,
        Name: 'MassActionRejectReason',
    },
    {
        Type: 'int',
        Description: 'Specifies the type of multileg order.',
        added: 'FIX.5.0',
        AbbrName: 'MlegModel',
        addedEP: 59,
        Tag: 1377,
        NotReqXML: 0,
        Name: 'MultilegModel',
    },
    {
        Type: 'int',
        Description:
            'Code to represent how the multileg price is to be interpreted when applied to the legs.\n(See Volume : "Glossary" for further value definitions)',
        added: 'FIX.5.0',
        AbbrName: 'MlegPxMeth',
        addedEP: 59,
        Tag: 1378,
        NotReqXML: 0,
        Name: 'MultilegPriceMethod',
    },
    {
        Type: 'float',
        Description: 'Specifies the volatility of an instrument leg.',
        added: 'FIX.5.0',
        AbbrName: 'LegVolatility',
        addedEP: 59,
        Tag: 1379,
        NotReqXML: 0,
        Name: 'LegVolatility',
    },
    {
        Type: 'Percentage',
        Description:
            'The continuously-compounded annualized dividend yield of the underlying(s) of an option. Used as a parameter to theoretical option pricing models.',
        added: 'FIX.5.0',
        AbbrName: 'DividendYield',
        addedEP: 59,
        Tag: 1380,
        NotReqXML: 0,
        Name: 'DividendYield',
    },
    {
        Type: 'Percentage',
        Description: 'Refer to definition for DividendYield(1380).',
        added: 'FIX.5.0',
        AbbrName: 'LegDividendYield',
        addedEP: 59,
        Tag: 1381,
        NotReqXML: 0,
        Name: 'LegDividendYield',
    },
    {
        Type: 'float',
        Description:
            'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then CurrencyRatio = 0.7',
        added: 'FIX.5.0',
        AbbrName: 'CurrencyRatio',
        addedEP: 59,
        Tag: 1382,
        NotReqXML: 0,
        Name: 'CurrencyRatio',
    },
    {
        Type: 'float',
        Description:
            'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then LegCurrencyRatio = 0.7',
        added: 'FIX.5.0',
        AbbrName: 'LegCurrencyRatio',
        addedEP: 59,
        Tag: 1383,
        NotReqXML: 0,
        Name: 'LegCurrencyRatio',
    },
    {
        Type: 'MultipleCharValue',
        EnumDatatype: 18,
        Description: 'Refer to ExecInst(18)\nSame values as ExecInst(18)',
        added: 'FIX.5.0',
        AbbrName: 'LegExecInst',
        addedEP: 59,
        Tag: 1384,
        NotReqXML: 0,
        Name: 'LegExecInst',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Defines the type of contingency.',
        added: 'FIX.5.0',
        AbbrName: 'ContingencyType',
        addedEP: 60,
        Tag: 1385,
        NotReqXML: 0,
        Name: 'ContingencyType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Identifies the reason for rejection of a New Order List message. Note that OrdRejReason(103) is used if the rejection is based on properties of an individual order part of the List.',
        added: 'FIX.5.0',
        AbbrName: 'ListRejectReason',
        addedEP: 60,
        Tag: 1386,
        NotReqXML: 0,
        Name: 'ListRejectReason',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of trade reporting indicators',
        added: 'FIX.5.0',
        AbbrName: 'NoTrdRepIndicators',
        addedEP: 61,
        Tag: 1387,
        NotReqXML: 1,
        Name: 'NoTrdRepIndicators',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'Identifies the type of party for trade reporting. Same values as PartyRole(452).',
        added: 'FIX.5.0',
        AbbrName: 'PtyRole',
        addedEP: 61,
        Tag: 1388,
        NotReqXML: 0,
        Name: 'TrdRepPartyRole',
    },
    {
        Type: 'Boolean',
        Description:
            'Specifies whether the trade should be reported (or not) to parties of the provided TrdRepPartyRole(1388). Used to override standard reporting behavior by the receiver of the trade report and thereby complements the PublTrdIndicator( tag1390).',
        added: 'FIX.5.0',
        AbbrName: 'TrdRepInd',
        addedEP: 61,
        Tag: 1389,
        NotReqXML: 0,
        Name: 'TrdRepIndicator',
    },
    {
        Type: 'int',
        Description:
            'Indicates if a trade should be reported via a market reporting service. The indicator governs all reporting services of the recipient. Replaces PublishTrdIndicator(852).',
        added: 'FIX.5.0',
        AbbrName: 'TrdPubInd',
        addedEP: 61,
        Tag: 1390,
        NotReqXML: 0,
        Name: 'TradePublishIndicator',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for request',
        added: 'FIX.5.0',
        AbbrName: 'ApplReqID',
        addedEP: 63,
        Tag: 1346,
        NotReqXML: 0,
        Name: 'ApplReqID',
    },
    {
        Type: 'int',
        Description: 'Type of Application Message Request being made.',
        added: 'FIX.5.0',
        AbbrName: 'ApplReqTyp',
        addedEP: 63,
        Tag: 1347,
        NotReqXML: 0,
        Name: 'ApplReqType',
    },
    {
        Type: 'int',
        Description: 'Used to indicate the type of acknowledgement being sent.',
        added: 'FIX.5.0',
        AbbrName: 'ApplRespTyp',
        addedEP: 63,
        Tag: 1348,
        NotReqXML: 0,
        Name: 'ApplResponseType',
    },
    {
        Type: 'int',
        Description: 'Total number of messages included in transmission.',
        added: 'FIX.5.0',
        AbbrName: 'ApplTotMsgCnt',
        addedEP: 63,
        Tag: 1349,
        NotReqXML: 0,
        Name: 'ApplTotalMessageCount',
    },
    {
        Type: 'SeqNum',
        Description: 'Application sequence number of last message in transmission',
        added: 'FIX.5.0',
        AbbrName: 'ApplLastSeqNum',
        addedEP: 63,
        Tag: 1350,
        NotReqXML: 0,
        Name: 'ApplLastSeqNum',
    },
    {
        Type: 'NumInGroup',
        Description: 'Specifies number of application id occurrences',
        added: 'FIX.5.0',
        AbbrName: 'NoApplIDs',
        addedEP: 63,
        Tag: 1351,
        NotReqXML: 1,
        Name: 'NoApplIDs',
    },
    {
        Type: 'Boolean',
        Description:
            "Used to indicate that a message is being sent in response to an Application Message Request. It is possible for both ApplResendFlag and PossDupFlag to be set on the same message if the Sender's cache size is greater than zero and the message is being resent due to a session level resend request",
        added: 'FIX.5.0',
        AbbrName: 'ApplResendFlag',
        addedEP: 63,
        Tag: 1352,
        NotReqXML: 0,
        Name: 'ApplResendFlag',
    },
    {
        Type: 'String',
        Description: 'Identifier for the Applicaton Message Request Ack',
        added: 'FIX.5.0',
        AbbrName: 'ApplRespID',
        addedEP: 63,
        Tag: 1353,
        NotReqXML: 0,
        Name: 'ApplResponseID',
    },
    {
        Type: 'int',
        Description: 'Used to return an error code or text associated with a response to an Application Request.',
        added: 'FIX.5.0',
        AbbrName: 'ApplRespErr',
        addedEP: 63,
        Tag: 1354,
        NotReqXML: 0,
        Name: 'ApplResponseError',
    },
    {
        Type: 'String',
        Description:
            'Reference to the unique application identifier which corresponds to ApplID(1180) from the Application Sequence Group component',
        added: 'FIX.5.0',
        AbbrName: 'RefApplID',
        addedEP: 63,
        Tag: 1355,
        NotReqXML: 0,
        Name: 'RefApplID',
    },
    {
        Type: 'String',
        Description: 'Identifier for the Application Sequence Reset',
        added: 'FIX.5.0',
        AbbrName: 'ApplRptID',
        addedEP: 63,
        Tag: 1356,
        NotReqXML: 0,
        Name: 'ApplReportID',
    },
    {
        Type: 'SeqNum',
        Description: 'Application sequence number of last message in transmission.',
        added: 'FIX.5.0',
        AbbrName: 'RefApplLastSeqNum',
        addedEP: 63,
        Tag: 1357,
        NotReqXML: 0,
        Name: 'RefApplLastSeqNum',
    },
    {
        Type: 'SeqNum',
        Description: 'Used to specify a new application sequence number.',
        added: 'FIX.5.0',
        AbbrName: 'ApplNewSeqNum',
        addedEP: 63,
        Tag: 1399,
        NotReqXML: 0,
        Name: 'ApplNewSeqNum',
    },
    {
        Type: 'int',
        Description: 'Type of report',
        added: 'FIX.5.0SP2',
        AbbrName: 'ApplRptTyp',
        Tag: 1426,
        NotReqXML: 0,
        Name: 'ApplReportType',
    },
    {
        Type: 'int',
        EnumDatatype: 803,
        Description: 'Refer to definition of PartySubIDType(803)',
        added: 'FIX.5.0',
        AbbrName: 'Typ',
        addedEP: 69,
        Tag: 1411,
        NotReqXML: 0,
        Name: 'Nested4PartySubIDType',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of PartySubID(523)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 69,
        Tag: 1412,
        NotReqXML: 0,
        Name: 'Nested4PartySubID',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition of NoPartySubIDs(802)',
        added: 'FIX.5.0',
        AbbrName: 'NoNested4PartySubIDs',
        addedEP: 69,
        Tag: 1413,
        NotReqXML: 0,
        Name: 'NoNested4PartySubIDs',
    },
    {
        Type: 'NumInGroup',
        Description: 'Refer to definition of NoPartyIDs(453)',
        added: 'FIX.5.0',
        AbbrName: 'NoNested4PartyIDs',
        addedEP: 69,
        Tag: 1414,
        NotReqXML: 0,
        Name: 'NoNested4PartyIDs',
    },
    {
        Type: 'String',
        Description: 'Refer to definition of PartyID(448)',
        added: 'FIX.5.0',
        AbbrName: 'ID',
        addedEP: 69,
        Tag: 1415,
        NotReqXML: 0,
        Name: 'Nested4PartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description: 'Refer to definition of PartyIDSource(447)',
        added: 'FIX.5.0',
        AbbrName: 'Src',
        addedEP: 69,
        Tag: 1416,
        NotReqXML: 0,
        Name: 'Nested4PartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'Refer to definition of PartyRole(452)',
        added: 'FIX.5.0',
        AbbrName: 'R',
        addedEP: 69,
        Tag: 1417,
        NotReqXML: 0,
        Name: 'Nested4PartyRole',
    },
    {
        Type: 'Qty',
        Description: 'Fill quantity for the leg instrument',
        added: 'FIX.5.0',
        AbbrName: 'LastQty',
        addedEP: 72,
        Tag: 1418,
        NotReqXML: 0,
        Name: 'LegLastQty',
    },
    {
        Type: 'String',
        Description:
            'When reporting trades, used to reference the identifier of the execution (ExecID) being reported if different ExecIDs were assigned to each side of the trade.',
        added: 'FIX.5.0SP1',
        AbbrName: 'SideExecID',
        addedEP: 77,
        Tag: 1427,
        NotReqXML: 0,
        Name: 'SideExecID',
    },
    {
        Type: 'int',
        Description:
            'Time lapsed from order entry until match, based on the unit of time specified in OrderDelayUnit.  Default is seconds if OrderDelayUnit is not specified. Value = 0, indicates the aggressor (the initiating side of the trade).',
        added: 'FIX.5.0SP1',
        AbbrName: 'OrdDelay',
        addedEP: 77,
        Tag: 1428,
        NotReqXML: 0,
        Name: 'OrderDelay',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Time unit in which the OrderDelay(1428) is expressed',
        added: 'FIX.5.0SP1',
        AbbrName: 'OrdDelayUnit',
        addedEP: 77,
        Tag: 1429,
        NotReqXML: 0,
        Name: 'OrderDelayUnit',
    },
    {
        Type: 'char',
        Description: 'Identifies the type of venue where a trade was executed',
        added: 'FIX.5.0SP1',
        AbbrName: 'VenuTyp',
        addedEP: 77,
        Tag: 1430,
        NotReqXML: 0,
        Name: 'VenueType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'The reason for updating the RefOrdID',
        added: 'FIX.5.0SP1',
        AbbrName: 'RefOrdIDRsn',
        addedEP: 77,
        Tag: 1431,
        NotReqXML: 0,
        Name: 'RefOrdIDReason',
    },
    {
        Type: 'int',
        Description:
            'The customer capacity for this trade at the time of the order/execution.\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).',
        added: 'FIX.5.0SP1',
        AbbrName: 'OrigCustOrdCpcty',
        addedEP: 77,
        Tag: 1432,
        NotReqXML: 0,
        Name: 'OrigCustOrderCapacity',
    },
    {
        Type: 'String',
        Description:
            'Used to reference a previously submitted ApplReqID (1346) from within a subsequent ApplicationMessageRequest(MsgType=BW)',
        added: 'FIX.5.0SP1',
        AbbrName: 'RefID',
        addedEP: 78,
        Tag: 1433,
        NotReqXML: 0,
        Name: 'RefApplReqID',
    },
    {
        Type: 'int',
        Description: 'Type of pricing model used',
        added: 'FIX.5.0SP1',
        AbbrName: 'ModelTyp',
        addedEP: 79,
        Tag: 1434,
        NotReqXML: 0,
        Name: 'ModelType',
    },
    {
        Type: 'int',
        Description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit ContractMultiplier(tag 231) is expressed in.',
        added: 'FIX.5.0SP1',
        AbbrName: 'MultTyp',
        addedEP: 80,
        Tag: 1435,
        NotReqXML: 0,
        Name: 'ContractMultiplierUnit',
    },
    {
        Type: 'int',
        EnumDatatype: 1435,
        Description:
            '"Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit LegContractMultiplier(tag 614) is expressed in.',
        added: 'FIX.5.0SP1',
        AbbrName: 'MultTyp',
        addedEP: 80,
        Tag: 1436,
        NotReqXML: 0,
        Name: 'LegContractMultiplierUnit',
    },
    {
        Type: 'int',
        EnumDatatype: 1435,
        Description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit UndlyContractMultiplier(tag 436) is expressed in.',
        added: 'FIX.5.0SP1',
        AbbrName: 'MultTyp',
        addedEP: 80,
        Tag: 1437,
        NotReqXML: 0,
        Name: 'UnderlyingContractMultiplierUnit',
    },
    {
        Type: 'int',
        EnumDatatype: 1435,
        Description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit DerivativeContractMultiplier(tag 1266)is expressed in.',
        added: 'FIX.5.0SP1',
        AbbrName: 'MultTyp',
        addedEP: 80,
        Tag: 1438,
        NotReqXML: 0,
        Name: 'DerivativeContractMultiplierUnit',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
        added: 'FIX.5.0SP1',
        AbbrName: 'FlowSchedTyp',
        addedEP: 80,
        Tag: 1439,
        NotReqXML: 0,
        Name: 'FlowScheduleType',
    },
    {
        Type: 'int',
        EnumDatatype: 1439,
        UnionDataType: 'Reserved100Plus',
        Description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
        added: 'FIX.5.0SP1',
        AbbrName: 'FlowSchedTyp',
        addedEP: 80,
        Tag: 1440,
        NotReqXML: 0,
        Name: 'LegFlowScheduleType',
    },
    {
        Type: 'int',
        EnumDatatype: 1439,
        UnionDataType: 'Reserved100Plus',
        Description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
        added: 'FIX.5.0SP1',
        AbbrName: 'FlowSchedTyp',
        addedEP: 80,
        Tag: 1441,
        NotReqXML: 0,
        Name: 'UnderlyingFlowScheduleType',
    },
    {
        Type: 'int',
        EnumDatatype: 1439,
        UnionDataType: 'Reserved100Plus',
        Description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
        added: 'FIX.5.0SP1',
        AbbrName: 'FlowSchedTyp',
        addedEP: 80,
        Tag: 1442,
        NotReqXML: 0,
        Name: 'DerivativeFlowScheduleType',
    },
    {
        Type: 'int',
        EnumDatatype: 851,
        Description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled',
        added: 'FIX.5.0SP1',
        AbbrName: 'LqdtyInd',
        addedEP: 81,
        Tag: 1443,
        NotReqXML: 0,
        Name: 'FillLiquidityInd',
    },
    {
        Type: 'int',
        EnumDatatype: 851,
        Description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled.',
        added: 'FIX.5.0SP1',
        AbbrName: 'LqdtyInd',
        addedEP: 81,
        Tag: 1444,
        NotReqXML: 0,
        Name: 'SideLiquidityInd',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of rate sources being specified.',
        added: 'FIX.5.0SP1',
        AbbrName: 'NoRtSrc',
        addedEP: 82,
        Tag: 1445,
        NotReqXML: 1,
        Name: 'NoRateSources',
    },
    {
        Type: 'int',
        Description:
            'Identifies the source of rate information.\nFor FX, the reference source to be used for the FX spot rate.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RtSrc',
        addedEP: 82,
        Tag: 1446,
        NotReqXML: 0,
        Name: 'RateSource',
    },
    {
        Type: 'int',
        Description: 'Indicates whether the rate source specified is a primary or secondary source.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RtSrcTyp',
        addedEP: 82,
        Tag: 1447,
        NotReqXML: 0,
        Name: 'RateSourceType',
    },
    {
        Type: 'String',
        Description:
            'Identifies the reference "page" from the rate source.\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RefPg',
        addedEP: 82,
        Tag: 1448,
        NotReqXML: 0,
        Name: 'ReferencePage',
    },
    {
        Type: 'String',
        Description:
            'A category of CDS credit even in which the underlying bond experiences a restructuring.\nUsed to define a CDS instrument.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RestrctTyp',
        addedEP: 83,
        Tag: 1449,
        NotReqXML: 0,
        Name: 'RestructuringType',
    },
    {
        Type: 'String',
        Description:
            'Specifies which issue (underlying bond) will receive payment priority in the event of a default.\nUsed to define a CDS instrument.',
        added: 'FIX.5.0SP1',
        AbbrName: 'Snrty',
        addedEP: 83,
        Tag: 1450,
        NotReqXML: 0,
        Name: 'Seniority',
    },
    {
        Type: 'Percentage',
        Description:
            'Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\nUsed to calculate the true value of a CDS trade or position.',
        added: 'FIX.5.0SP1',
        AbbrName: 'NotlPctOut',
        addedEP: 83,
        Tag: 1451,
        NotReqXML: 0,
        Name: 'NotionalPercentageOutstanding',
    },
    {
        Type: 'Percentage',
        Description:
            'Used to reflect the Original value prior to the application of a credit event. See NotionalPercentageOutstanding(1451).',
        added: 'FIX.5.0SP1',
        AbbrName: 'OrigNotlPctOut',
        addedEP: 83,
        Tag: 1452,
        NotReqXML: 0,
        Name: 'OriginalNotionalPercentageOutstanding',
    },
    {
        Type: 'String',
        EnumDatatype: 1449,
        Description: 'See RestructuringType(1449)',
        added: 'FIX.5.0SP1',
        AbbrName: 'RestrctTyp',
        addedEP: 83,
        Tag: 1453,
        NotReqXML: 0,
        Name: 'UnderlyingRestructuringType',
    },
    {
        Type: 'String',
        EnumDatatype: 1450,
        Description: 'See Seniority(1450)',
        added: 'FIX.5.0SP1',
        AbbrName: 'Snrty',
        addedEP: 83,
        Tag: 1454,
        NotReqXML: 0,
        Name: 'UnderlyingSeniority',
    },
    {
        Type: 'Percentage',
        Description: 'See NotionalPercentageOutstanding(1451)',
        added: 'FIX.5.0SP1',
        AbbrName: 'NotlPctOut',
        addedEP: 83,
        Tag: 1455,
        NotReqXML: 0,
        Name: 'UnderlyingNotionalPercentageOutstanding',
    },
    {
        Type: 'Percentage',
        Description: 'See OriginalNotionalPercentageOutstanding(1452)',
        added: 'FIX.5.0SP1',
        AbbrName: 'OrigNotlPctOut',
        addedEP: 83,
        Tag: 1456,
        NotReqXML: 0,
        Name: 'UnderlyingOriginalNotionalPercentageOutstanding',
    },
    {
        Type: 'Percentage',
        Description: 'Lower bound percentage of the loss that the tranche can endure.',
        added: 'FIX.5.0SP1',
        AbbrName: 'AttchPnt',
        addedEP: 83,
        Tag: 1457,
        NotReqXML: 0,
        Name: 'AttachmentPoint',
    },
    {
        Type: 'Percentage',
        Description: 'Upper bound percentage of the loss the tranche can endure.',
        added: 'FIX.5.0SP1',
        AbbrName: 'DetchPnt',
        addedEP: 83,
        Tag: 1458,
        NotReqXML: 0,
        Name: 'DetachmentPoint',
    },
    {
        Type: 'Percentage',
        Description: 'See AttachmentPoint(1457).',
        added: 'FIX.5.0SP1',
        AbbrName: 'AttchPnt',
        addedEP: 83,
        Tag: 1459,
        NotReqXML: 0,
        Name: 'UnderlyingAttachmentPoint',
    },
    {
        Type: 'Percentage',
        Description: 'See DetachmentPoint(1458).',
        added: 'FIX.5.0SP1',
        AbbrName: 'DetchPnt',
        addedEP: 83,
        Tag: 1460,
        NotReqXML: 0,
        Name: 'UnderlyingDetachmentPoint',
    },
    {
        Type: 'NumInGroup',
        Description: 'Identifies the number of target parties identified in a mass action.',
        added: 'FIX.5.0SP1',
        addedEP: 85,
        Tag: 1461,
        NotReqXML: 1,
        Name: 'NoTargetPartyIDs',
    },
    {
        Type: 'String',
        Description: 'PartyID value within an target party repeating group.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ID',
        addedEP: 85,
        Tag: 1462,
        NotReqXML: 0,
        Name: 'TargetPartyID',
    },
    {
        Type: 'char',
        EnumDatatype: 447,
        Description: 'PartyIDSource value within an target party repeating group.\nSame values as PartyIDSource (447)',
        added: 'FIX.5.0SP1',
        AbbrName: 'Src',
        addedEP: 85,
        Tag: 1463,
        NotReqXML: 0,
        Name: 'TargetPartyIDSource',
    },
    {
        Type: 'int',
        EnumDatatype: 452,
        Description: 'PartyRole value within an target party repeating group.\nSame values as PartyRole (452)',
        added: 'FIX.5.0SP1',
        AbbrName: 'R',
        addedEP: 85,
        Tag: 1464,
        NotReqXML: 0,
        Name: 'TargetPartyRole',
    },
    {
        Type: 'String',
        Description: 'Specifies an identifier for a Security List',
        added: 'FIX.5.0SP1',
        AbbrName: 'ListID',
        addedEP: 87,
        Tag: 1465,
        NotReqXML: 0,
        Name: 'SecurityListID',
    },
    {
        Type: 'String',
        Description:
            'Specifies a reference from one Security List to another. Used to support a hierarchy of Security Lists.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ListRefID',
        addedEP: 87,
        Tag: 1466,
        NotReqXML: 0,
        Name: 'SecurityListRefID',
    },
    {
        Type: 'String',
        Description: 'Specifies a description or name of a Security List.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ListDesc',
        addedEP: 87,
        Tag: 1467,
        NotReqXML: 0,
        Name: 'SecurityListDesc',
    },
    {
        Type: 'Length',
        Description: 'Byte length of encoded (non-ASCII characters) EncodedSecurityListDesc (tbd) field.',
        added: 'FIX.5.0SP1',
        AssociatedDataTag: 1469,
        addedEP: 87,
        Tag: 1468,
        NotReqXML: 1,
        Name: 'EncodedSecurityListDescLen',
    },
    {
        Type: 'data',
        Description:
            'Encoded (non-ASCII characters) representation of the SecurityListDesc (1467) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityListDesc field.',
        added: 'FIX.5.0SP1',
        addedEP: 87,
        Tag: 1469,
        NotReqXML: 1,
        Name: 'EncodedSecurityListDesc',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Specifies a type of Security List.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ListTyp',
        addedEP: 87,
        Tag: 1470,
        NotReqXML: 0,
        Name: 'SecurityListType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Specifies a specific source for a SecurityListType. Relevant when a certain type can be provided from various sources.',
        added: 'FIX.5.0SP1',
        AbbrName: 'LstTypSrc',
        addedEP: 87,
        Tag: 1471,
        NotReqXML: 0,
        Name: 'SecurityListTypeSource',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for a News message',
        added: 'FIX.5.0SP1',
        AbbrName: 'ID',
        addedEP: 90,
        Tag: 1472,
        NotReqXML: 0,
        Name: 'NewsID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Category of news mesage.',
        added: 'FIX.5.0SP1',
        AbbrName: 'NewsCatgy',
        addedEP: 90,
        Tag: 1473,
        NotReqXML: 0,
        Name: 'NewsCategory',
    },
    {
        Type: 'Language',
        Description: 'The national language in which the news item is provided.',
        added: 'FIX.5.0SP1',
        AbbrName: 'LangCd',
        addedEP: 90,
        Tag: 1474,
        NotReqXML: 0,
        Name: 'LanguageCode',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of News reference items',
        added: 'FIX.5.0SP1',
        addedEP: 90,
        Tag: 1475,
        NotReqXML: 1,
        Name: 'NoNewsRefIDs',
    },
    {
        Type: 'String',
        Description: 'Reference to another News message identified by NewsID(1474).',
        added: 'FIX.5.0SP1',
        AbbrName: 'RefID',
        addedEP: 90,
        Tag: 1476,
        NotReqXML: 0,
        Name: 'NewsRefID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Type of reference to another News Message item. Defines if the referenced news item is a replacement, is in a different language, or is complimentary.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RefTyp',
        addedEP: 90,
        Tag: 1477,
        NotReqXML: 0,
        Name: 'NewsRefType',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description:
            'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.  \nConditionally, required if value is other than "fixed".',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrkPxDtrmnMeth',
        addedEP: 92,
        Tag: 1478,
        NotReqXML: 0,
        Name: 'StrikePriceDeterminationMethod',
    },
    {
        Type: 'int',
        Description:
            'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrkPxBndryMeth',
        addedEP: 92,
        Tag: 1479,
        NotReqXML: 0,
        Name: 'StrikePriceBoundaryMethod',
    },
    {
        Type: 'Percentage',
        Description:
            'Used in combination with StrikePriceBoundaryMethod to specify the percentage of the strike price in relation to the  underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StrkPxBndryPrcsn',
        addedEP: 92,
        Tag: 1480,
        NotReqXML: 0,
        Name: 'StrikePriceBoundaryPrecision',
    },
    {
        Type: 'int',
        Description:
            'Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period ("Look-back") or set to the average value of the underlying during the defined period ("Asian option").',
        added: 'FIX.5.0SP1',
        AbbrName: 'PxDtrmnMeth',
        addedEP: 92,
        Tag: 1481,
        NotReqXML: 0,
        Name: 'UnderlyingPriceDeterminationMethod',
    },
    {
        Type: 'int',
        Description: 'Indicates the type of payout that will result from an in-the-money option.',
        added: 'FIX.5.0SP1',
        AbbrName: 'OptPayoutTyp',
        addedEP: 92,
        Tag: 1482,
        NotReqXML: 0,
        Name: 'OptPayoutType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of complex event occurrences.',
        added: 'FIX.5.0SP1',
        addedEP: 92,
        Tag: 1483,
        NotReqXML: 1,
        Name: 'NoComplexEvents',
    },
    {
        Type: 'int',
        Description: 'Identifies the type of complex event.',
        added: 'FIX.5.0SP1',
        AbbrName: 'Typ',
        addedEP: 92,
        Tag: 1484,
        NotReqXML: 0,
        Name: 'ComplexEventType',
    },
    {
        Type: 'Amt',
        Description:
            'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
        added: 'FIX.5.0SP1',
        AbbrName: 'OptPayAmt',
        addedEP: 92,
        Tag: 1485,
        NotReqXML: 0,
        Name: 'ComplexOptPayoutAmount',
    },
    {
        Type: 'Price',
        Description:
            'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484).',
        added: 'FIX.5.0SP1',
        AbbrName: 'Px',
        addedEP: 92,
        Tag: 1486,
        NotReqXML: 0,
        Name: 'ComplexEventPrice',
    },
    {
        Type: 'int',
        Description:
            'Specifies the boundary condition to be used for the event price relative to the underlying price at the point the complex event outcome takes effect as determined by the ComplexEventPriceTimeType.',
        added: 'FIX.5.0SP1',
        AbbrName: 'PxBndryMeth',
        addedEP: 92,
        Tag: 1487,
        NotReqXML: 0,
        Name: 'ComplexEventPriceBoundaryMethod',
    },
    {
        Type: 'Percentage',
        Description:
            'Used in combination with ComplexEventPriceBoundaryMethod to specify the percentage of the strike price in relation to the  underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
        added: 'FIX.5.0SP1',
        AbbrName: 'PxBndryPrcsn',
        addedEP: 92,
        Tag: 1488,
        NotReqXML: 0,
        Name: 'ComplexEventPriceBoundaryPrecision',
    },
    {
        Type: 'int',
        Description:
            'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the ComplexEventType.',
        added: 'FIX.5.0SP1',
        AbbrName: 'PxTmTyp',
        addedEP: 92,
        Tag: 1489,
        NotReqXML: 0,
        Name: 'ComplexEventPriceTimeType',
    },
    {
        Type: 'int',
        Description:
            'Specifies the condition between complex events when more than one event is specified.  \nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
        added: 'FIX.5.0SP1',
        AbbrName: 'Cond',
        addedEP: 92,
        Tag: 1490,
        NotReqXML: 0,
        Name: 'ComplexEventCondition',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of complex event date occurrences for a given complex event.',
        added: 'FIX.5.0SP1',
        addedEP: 92,
        Tag: 1491,
        NotReqXML: 1,
        Name: 'NoComplexEventDates',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Specifies the start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\nComplexEventStartDate must always be less than or equal to ComplexEventEndDate.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StartDt',
        addedEP: 92,
        Tag: 1492,
        NotReqXML: 0,
        Name: 'ComplexEventStartDate',
    },
    {
        Type: 'UTCTimestamp',
        Description:
            'Specifies the end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\nComplexEventEndDate must always be greater than or equal to ComplexEventStartDate.',
        added: 'FIX.5.0SP1',
        AbbrName: 'EndDt',
        addedEP: 92,
        Tag: 1493,
        NotReqXML: 0,
        Name: 'ComplexEventEndDate',
    },
    {
        Type: 'NumInGroup',
        Description:
            'Number of complex event time occurrences for a given complex event date\nThe default in case of an absence of time fields is 00:00:00-23:59:59.',
        added: 'FIX.5.0SP1',
        addedEP: 92,
        Tag: 1494,
        NotReqXML: 1,
        Name: 'NoComplexEventTimes',
    },
    {
        Type: 'UTCTimeOnly',
        Description:
            'Specifies the start time of the time range on which a complex event date is effective. \nComplexEventStartTime must always be less than or equal to ComplexEventEndTime.',
        added: 'FIX.5.0SP1',
        AbbrName: 'StartTm',
        addedEP: 92,
        Tag: 1495,
        NotReqXML: 0,
        Name: 'ComplexEventStartTime',
    },
    {
        Type: 'UTCTimeOnly',
        Description:
            'Specifies the end time of the time range on which a complex event date is effective.\nComplexEventEndTime must always be greater than or equal to ComplexEventStartTime.',
        added: 'FIX.5.0SP1',
        AbbrName: 'EndTm',
        addedEP: 92,
        Tag: 1496,
        NotReqXML: 0,
        Name: 'ComplexEventEndTime',
    },
    {
        Type: 'String',
        Description: 'Unique identifier for the stream assignment request provided by the requester.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ReqID',
        addedEP: 93,
        Tag: 1497,
        NotReqXML: 0,
        Name: 'StreamAsgnReqID',
    },
    {
        Type: 'int',
        Description: 'Type of stream assignment request.',
        added: 'FIX.5.0SP1',
        AbbrName: 'AsgnReqTyp',
        addedEP: 93,
        Tag: 1498,
        NotReqXML: 0,
        Name: 'StreamAsgnReqType',
    },
    {
        Type: 'NumInGroup',
        Description: 'Number of assignment requests.',
        added: 'FIX.5.0SP1',
        addedEP: 93,
        Tag: 1499,
        NotReqXML: 1,
        Name: 'NoAsgnReqs',
    },
    {
        Type: 'String',
        Description: 'The identifier or name of the price stream.',
        added: 'FIX.5.0SP1',
        AbbrName: 'MDStrmID',
        addedEP: 93,
        Tag: 1500,
        NotReqXML: 0,
        Name: 'MDStreamID',
    },
    {
        Type: 'String',
        Description: 'Unique identifier of the stream assignment report provided by the respondent.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RptID',
        addedEP: 93,
        Tag: 1501,
        NotReqXML: 0,
        Name: 'StreamAsgnRptID',
    },
    {
        Type: 'int',
        UnionDataType: 'Reserved100Plus',
        Description: 'Reason code for stream assignment request reject.',
        added: 'FIX.5.0SP1',
        AbbrName: 'RejRsn',
        addedEP: 93,
        Tag: 1502,
        NotReqXML: 0,
        Name: 'StreamAsgnRejReason',
    },
    {
        Type: 'int',
        Description: 'Type of acknowledgement.',
        added: 'FIX.5.0SP1',
        AbbrName: 'ActTyp',
        addedEP: 93,
        Tag: 1503,
        NotReqXML: 0,
        Name: 'StreamAsgnAckType',
    },
    {
        Type: 'int',
        Description: 'The type of assignment being affected in the Stream Assignment Report.',
        added: 'FIX.5.0SP1',
        AbbrName: 'AsgnTyp',
        addedEP: 93,
        Tag: 1617,
        NotReqXML: 0,
        Name: 'StreamAsgnType',
    },
    {
        Type: 'UTCTimestamp',
        Description: 'See TransactTime(60)',
        added: 'FIX.5.0SP1',
        AbbrName: 'TxnTm',
        addedEP: 94,
        Tag: 1504,
        NotReqXML: 0,
        Name: 'RelSymTransactTime',
    },
];

export const FIELDS: ISpecFields[] = batch1.concat(batch2).concat(batch3);
